import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO 8601-encoded datetime */
  ISO8601String: any;
  /** A object contains pairs of key and value */
  KeyValueObject: any;
  /** Hash(Object) of Time */
  TimeObject: any;
  /** A void value */
  Void: any;
};

export type AdAnalyticsMetrics =
  | 'clicks'
  | 'conversions'
  | 'cpa'
  | 'cpa_with_view_through_conversions'
  | 'cpc'
  | 'cpm'
  | 'ctr'
  | 'cvr'
  | 'impressions'
  | 'mobile_app_installs'
  | 'spend'
  | 'view_through_conversions';

export type AdAnalyticsNetwork = {
  key: Scalars['String'];
  name: Scalars['String'];
  placements: Array<AdAnalyticsPlacement>;
};

export type AdAnalyticsPlacement = {
  external_api_key: Scalars['String'];
  key: Scalars['String'];
  name: Scalars['String'];
};

export type AdAnalyticsPlatform = {
  key: Scalars['String'];
  name: Scalars['String'];
  networks: Array<AdAnalyticsNetwork>;
};

export type AdAnalyticsVideoFilter = {
  max?: InputMaybe<Scalars['Float']>;
  metrics: AdAnalyticsMetrics;
  min?: InputMaybe<Scalars['Float']>;
};

export type AdAnalyticsVideoSort = {
  direction: OrderDirection;
  metrics: AdAnalyticsMetrics;
};

export type AdMediaKey =
  | 'audience_network'
  | 'facebook'
  | 'instagram'
  | 'messenger';

export type AdPlacementKey =
  | 'audience_network_all_placements'
  | 'audience_network_an_classic'
  | 'audience_network_instream_video'
  | 'audience_network_native_banner_interstitial'
  | 'audience_network_rewarded_video'
  | 'facebook_feed'
  | 'facebook_instant_article'
  | 'facebook_instream_video'
  | 'facebook_marketplace'
  | 'facebook_stories'
  | 'facebook_suggested_video'
  | 'instagram_feed'
  | 'instagram_right_hand_column'
  | 'instagram_stories'
  | 'messenger_inbox'
  | 'messenger_sponsored_messages'
  | 'messenger_stories';

export type AdPlatformKey =
  | 'facebook';

export type AmazonAdAccount = {
  countryCode: AmazonAdAccountCountryCode;
  currencyCode: AmazonAdAccountCurrencyCode;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  profileId: Scalars['ID'];
  type: AmazonAdAccountTypeEnum;
};

export type AmazonAdAccountCountryCode =
  /** United Arab Emirates */
  | 'AE'
  /** Australia */
  | 'AU'
  /** Brazil */
  | 'BR'
  /** Canada */
  | 'CA'
  /** Germany */
  | 'DE'
  /** Spain */
  | 'ES'
  /** France */
  | 'FR'
  /** Italy */
  | 'IT'
  /** Japan */
  | 'JP'
  /** Mexico */
  | 'MX'
  /** The Netherlands */
  | 'NL'
  /** United Kingdom */
  | 'UK'
  /** United States */
  | 'US';

export type AmazonAdAccountCurrencyCode =
  | 'AED'
  | 'AUD'
  | 'BRL'
  | 'CAD'
  | 'EUR'
  | 'GBP'
  | 'JPY'
  | 'MXN'
  | 'USD';

export type AmazonAdAccountTypeEnum =
  | 'AGENCY'
  | 'SELLER'
  | 'VENDOR';

export type AmazonUploadedCreative = {
  creativeId: Scalars['ID'];
  mediaId: Scalars['String'];
  uploadedAt: Scalars['ISO8601String'];
};

export type Article = {
  id: Scalars['ID'];
  thumbnailImageUrl: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type AspectRatio = {
  height: Scalars['Int'];
  width: Scalars['Int'];
};

export type AspectRatioInput = {
  height: Scalars['Float'];
  width: Scalars['Float'];
};

export type AudioPreparedMaterial = {
  displayName: Scalars['String'];
  id: Scalars['ID'];
  originalUrl: Scalars['String'];
};

export type AvailableDeliveryDueDate = {
  days: Scalars['Int'];
  dueDate: Scalars['ISO8601String'];
  expressDueDays: Scalars['Int'];
};

export type Basic = {
  creativeType: SupportingCreativeType;
  isModificationRequestable: Scalars['Boolean'];
  isResizable: Scalars['Boolean'];
};

export type BusinessAccount = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type BusinessRegion = {
  idBusinessRegion: BusinessRegionIdBusinessRegion;
  key: BusinessRegionAdRegionKey;
  timeZone: Scalars['String'];
};

export type BusinessRegionAdRegionKey =
  | 'gl'
  | 'jp'
  | 'us';

export type BusinessRegionIdBusinessRegion =
  | 'global'
  | 'japan'
  | 'united_states';

export type Category = {
  articles: Array<Article>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  pcColumnCount: Scalars['Int'];
  rowCount: Scalars['Int'];
  spColumnCount: Scalars['Int'];
};

export type Channel = {
  channelId: Scalars['ID'];
  name: Scalars['String'];
  thumbnailUrl: Scalars['String'];
};

export type Creation = {
  achievementId?: Maybe<Scalars['ID']>;
  assignee?: Maybe<UserOptimizer>;
  assignmentId: Scalars['ID'];
  createdAt: Scalars['ISO8601String'];
  creationSetId: Scalars['ID'];
  creativeFormat: CreativeFormat;
  deliverables: Array<Deliverable>;
  finalized: Scalars['Boolean'];
  finalizedAt?: Maybe<Scalars['ISO8601String']>;
  id: Scalars['ID'];
  inspectionModificationRequests: Array<InspectionRequest>;
  isNextModificationRequestForAFee: Scalars['Boolean'];
  latestDeliverableSubmittedAt?: Maybe<Scalars['ISO8601String']>;
  latestDeliverableUrl?: Maybe<Scalars['String']>;
  latestProposedDeliverable?: Maybe<Deliverable>;
  modificationRequestExpired: Scalars['Boolean'];
  modificationRequestFreeExpiredAt?: Maybe<Scalars['ISO8601String']>;
  modificationRequestFreeLimit: Scalars['Int'];
  modificationRequestPoint: Scalars['Int'];
  modificationRequestReward: Reward;
  modificationRequests: Array<Request>;
  organization: Organization;
  projectId: Scalars['ID'];
  proposed: Scalars['Boolean'];
  resizeBaseId?: Maybe<Scalars['ID']>;
  state: CreationState;
  stateUpdatedAt: Scalars['ISO8601String'];
  submittedAt?: Maybe<Scalars['ISO8601String']>;
};

/** The connection type for Creation. */
export type CreationConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CreationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Creation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CreationEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Creation>;
};

export type CreationSet = {
  additionalAmount: Scalars['Int'];
  amount: Scalars['Int'];
  creations: Array<Creation>;
  creationsByAssignmentId: Array<Creation>;
  creationsByOtherAssignedOptimizers: Array<Creation>;
  creativeFormats: Array<CreativeFormat>;
  currentAssignmentId: Scalars['ID'];
  deliveryDueDate?: Maybe<Scalars['ISO8601String']>;
  deliveryDueDays?: Maybe<Scalars['Int']>;
  expressDueDays?: Maybe<Scalars['Int']>;
  finalizedAt?: Maybe<Scalars['ISO8601String']>;
  id: Scalars['ID'];
  inspectionPassedCreations?: Maybe<Array<Creation>>;
  offerId?: Maybe<Scalars['ID']>;
  project: Project;
};

export type CreationSetInput = {
  amount: Scalars['Int'];
  creativeFormats: Array<CreativeFormatInput>;
  deliveryDueDays?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type CreationState =
  | 'canceled'
  | 'in_inspection'
  | 'in_proposal'
  | 'initial'
  | 'inspection_modification_requested'
  | 'modification_requested'
  | 'submitted';

export type Creative = {
  fastStart?: Maybe<CreativeFastStart>;
  file: File;
  id: Scalars['ID'];
};

export type CreativeFastStart = {
  enabled?: Maybe<Scalars['Boolean']>;
};

export type CreativeFormat = {
  attribute: CreativeFormatAttribute;
  creativeType: CreativeFormatCreativeType;
  id: Scalars['ID'];
  network: CreativeFormatNetwork;
  offerPricingDetails?: Maybe<OfferPricingDetail>;
  placement: CreativeFormatPlacement;
  resizeBaseId?: Maybe<Scalars['ID']>;
  selectedPricingMerchandiseOptions: Array<Option>;
};

export type CreativeFormatAspectRatio = {
  aspectRatio: AspectRatio;
  id: Scalars['ID'];
  requiredOption?: Maybe<ProductOption>;
  size: DisplaySize;
  supportingAspectRatioId: Scalars['ID'];
};

export type CreativeFormatAspectRatioInput = {
  aspectRatio: AspectRatioInput;
  requiredOption?: InputMaybe<ProductOptionInput>;
  size: DisplaySizeInput;
  supportingAspectRatioId: Scalars['ID'];
};

export type CreativeFormatAttribute = {
  aspectRatio?: Maybe<CreativeFormatAspectRatio>;
  fastStart?: Maybe<CreativeFormatFastStart>;
  playbackTime?: Maybe<CreativeFormatPlaybackTime>;
};

export type CreativeFormatAttributeInput = {
  aspectRatio?: InputMaybe<CreativeFormatAspectRatioInput>;
  playbackTime?: InputMaybe<CreativeFormatPlaybackTimeInput>;
};

export type CreativeFormatCreativeType = {
  id: Scalars['ID'];
  key: CreativeFormatCreativeTypeKey;
  name: Scalars['String'];
  requiredPoints: Array<ProductPricing>;
};

export type CreativeFormatCreativeTypeKey =
  | 'static_image'
  | 'video';

export type CreativeFormatFastStart = {
  enabled?: Maybe<Scalars['Boolean']>;
};

export type CreativeFormatInput = {
  attribute: CreativeFormatAttributeInput;
  creativeTypeId: Scalars['ID'];
  networkId: Scalars['ID'];
  placementId: Scalars['ID'];
  resizeBaseIndex?: InputMaybe<Scalars['Int']>;
};

export type CreativeFormatNetwork = {
  id: Scalars['ID'];
  key: CreativeFormatNetworkKey;
  name: Scalars['String'];
  placements: Array<SupportingCreativeFormatPlacement>;
};

export type CreativeFormatNetworkKey =
  | 'amazon'
  | 'any_network'
  | 'apple'
  | 'facebook'
  | 'google'
  | 'instagram'
  | 'line'
  | 'other'
  | 'owned_media'
  | 'snapchat'
  | 'twitter'
  | 'yahoo'
  | 'youtube';

export type CreativeFormatPlacement = {
  basicMerchandises: Array<Basic>;
  id: Scalars['ID'];
  key: Scalars['String'];
  name: Scalars['String'];
};

export type CreativeFormatPlaybackTime = {
  id: Scalars['ID'];
  requiredOption?: Maybe<ProductOption>;
  seconds: Scalars['Int'];
  supportingPlaybackTimeId: Scalars['ID'];
};

export type CreativeFormatPlaybackTimeInput = {
  requiredOption?: InputMaybe<ProductOptionInput>;
  seconds: Scalars['Int'];
  supportingPlaybackTimeId: Scalars['ID'];
};

export type CreativePerformanceBrowsingAd = {
  clicks: Scalars['Float'];
  conversions: Scalars['Float'];
  conversionsKey?: Maybe<Scalars['String']>;
  cpa?: Maybe<Scalars['Float']>;
  cpaWithViewThroughConversions?: Maybe<Scalars['Float']>;
  cpc?: Maybe<Scalars['Float']>;
  cpm?: Maybe<Scalars['Float']>;
  ctr?: Maybe<Scalars['Float']>;
  currency: Scalars['String'];
  cvr: Scalars['Float'];
  duration: Scalars['Float'];
  impressions: Scalars['Float'];
  medias: Array<AdAnalyticsNetwork>;
  mobileAppInstalls?: Maybe<Scalars['Float']>;
  placements: Array<AdAnalyticsPlacement>;
  platforms: Array<AdAnalyticsPlatform>;
  project?: Maybe<Project>;
  spend: Scalars['Float'];
  thumbnailImageUrl: Scalars['String'];
  title: Scalars['String'];
  videoP25Watched: Scalars['Float'];
  videoP50Watched: Scalars['Float'];
  videoP75Watched: Scalars['Float'];
  videoP95Watched: Scalars['Float'];
  videoP100Watched: Scalars['Float'];
  videoUrl: Scalars['String'];
  viewThroughConversions: Scalars['Float'];
};

/** The connection type for CreativePerformanceBrowsingAd. */
export type CreativePerformanceBrowsingAdConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CreativePerformanceBrowsingAdEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CreativePerformanceBrowsingAd>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CreativePerformanceBrowsingAdEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CreativePerformanceBrowsingAd>;
};

export type CreativePerformanceBrowsingCampaign = {
  clicks: Scalars['Float'];
  conversions: Scalars['Float'];
  conversionsKey?: Maybe<Scalars['String']>;
  cpa?: Maybe<Scalars['Float']>;
  cpaWithViewThroughConversions?: Maybe<Scalars['Float']>;
  cpc?: Maybe<Scalars['Float']>;
  cpm?: Maybe<Scalars['Float']>;
  ctr?: Maybe<Scalars['Float']>;
  currency: Scalars['String'];
  cvr: Scalars['Float'];
  duration: Scalars['Float'];
  impressions: Scalars['Float'];
  medias: Array<AdAnalyticsNetwork>;
  mobileAppInstalls?: Maybe<Scalars['Float']>;
  placements: Array<AdAnalyticsPlacement>;
  platforms: Array<AdAnalyticsPlatform>;
  project?: Maybe<Project>;
  spend: Scalars['Float'];
  thumbnailImageUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  videoP25Watched: Scalars['Float'];
  videoP50Watched: Scalars['Float'];
  videoP75Watched: Scalars['Float'];
  videoP95Watched: Scalars['Float'];
  videoP100Watched: Scalars['Float'];
  videoUrl: Scalars['String'];
  viewThroughConversions: Scalars['Float'];
};

/** The connection type for CreativePerformanceBrowsingCampaign. */
export type CreativePerformanceBrowsingCampaignConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CreativePerformanceBrowsingCampaignEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CreativePerformanceBrowsingCampaign>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CreativePerformanceBrowsingCampaignEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CreativePerformanceBrowsingCampaign>;
};

export type CreativePerformanceBrowsingCreative = {
  clicks: Scalars['Float'];
  conversions: Scalars['Float'];
  conversionsKey?: Maybe<Scalars['String']>;
  cpa?: Maybe<Scalars['Float']>;
  cpaWithViewThroughConversions?: Maybe<Scalars['Float']>;
  cpc?: Maybe<Scalars['Float']>;
  cpm?: Maybe<Scalars['Float']>;
  ctr?: Maybe<Scalars['Float']>;
  currency: Scalars['String'];
  cvr: Scalars['Float'];
  duration: Scalars['Float'];
  impressions: Scalars['Float'];
  medias: Array<AdAnalyticsNetwork>;
  mobileAppInstalls?: Maybe<Scalars['Float']>;
  placements: Array<AdAnalyticsPlacement>;
  platforms: Array<AdAnalyticsPlatform>;
  project?: Maybe<Project>;
  spend: Scalars['Float'];
  thumbnailImageUrl: Scalars['String'];
  title: Scalars['String'];
  videoP25Watched: Scalars['Float'];
  videoP50Watched: Scalars['Float'];
  videoP75Watched: Scalars['Float'];
  videoP95Watched: Scalars['Float'];
  videoP100Watched: Scalars['Float'];
  videoUrl: Scalars['String'];
  viewThroughConversions: Scalars['Float'];
};

/** The connection type for CreativePerformanceBrowsingCreative. */
export type CreativePerformanceBrowsingCreativeConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CreativePerformanceBrowsingCreativeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CreativePerformanceBrowsingCreative>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CreativePerformanceBrowsingCreativeEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CreativePerformanceBrowsingCreative>;
};

export type Currency =
  | 'JPY'
  | 'USD';

export type DailyPerformance = {
  adVideoId: Scalars['ID'];
  clicks: Array<DailyPerformanceValue>;
  conversions: Array<DailyPerformanceValue>;
  cpa: Array<DailyPerformanceValue>;
  cpaWithViewThroughConversions: Array<DailyPerformanceValue>;
  cpc: Array<DailyPerformanceValue>;
  cpm: Array<DailyPerformanceValue>;
  ctr: Array<DailyPerformanceValue>;
  cvr: Array<DailyPerformanceValue>;
  impressions: Array<DailyPerformanceValue>;
  mobileAppInstalls: Array<DailyPerformanceValue>;
  spend: Array<DailyPerformanceValue>;
  viewThroughConversions: Array<DailyPerformanceValue>;
};

export type DailyPerformanceValue = {
  actualValue: PerformanceValue;
  date: Scalars['ISO8601String'];
};

export type DailySummaryPerformance = {
  basis: DailySummaryPerformanceBasis;
  creatives: Array<DailySummaryPerformanceCreative>;
  metric: PerformanceReportMetric;
  period: PerformanceReportPeriod;
};

export type DailySummaryPerformanceBasis = {
  /** 配信データが存在しない日のデータは含まれない */
  values: Array<DailyPerformanceValue>;
};

export type DailySummaryPerformanceCreative = {
  adName: Scalars['String'];
  creation: Creation;
  /** DailySummary上の同一クリエイティブを認識するために必要なID */
  creativeId: Scalars['ID'];
  thumbnailImageUrl: Scalars['String'];
  /** 配信データが存在しない日のデータは含まれない */
  values: Array<DailyPerformanceValue>;
};

export type Deliverable = {
  attachedThumbnail?: Maybe<Creative>;
  createdAt: Scalars['ISO8601String'];
  creationId: Scalars['ID'];
  creative: Creative;
  id: Scalars['ID'];
  intent: Scalars['String'];
  state: DeliverableState;
  stateUpdatedAt: Scalars['ISO8601String'];
  uploadedAdPlatformKeys: Array<Scalars['String']>;
};

export type DeliverableState =
  | 'inspection_modification_requested'
  | 'modification_requested'
  | 'submitted';

export type DesignInspirationCase = {
  description: Scalars['String'];
  designInspirationCategory: DesignInspirationCategory;
  id: Scalars['ID'];
  name: Scalars['String'];
  thumbnailUrl?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type DesignInspirationCategory = {
  designInspirationCases: Array<DesignInspirationCase>;
  iconUrl: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DetailPerformanceValue = {
  /** データが存在しない指標の場合はnullになる */
  actualValue?: Maybe<PerformanceValue>;
  metric: PerformanceReportMetric;
};

export type DirectorMutation = {
  addModificationRequestItemAsset: Scalars['Boolean'];
  adoptProposalCreations?: Maybe<CreationConnection>;
  approveModificationRequest?: Maybe<Request>;
  cancelCreatingDraftModificationRequest?: Maybe<Creation>;
  createAdAnalyticsReport?: Maybe<Report>;
  createModificationRequestAsDraft?: Maybe<Request>;
  createModificationRequestItem?: Maybe<RequestItem>;
  createModificationRequestItemIssue?: Maybe<Issue>;
  createModificationRequestItemIssueComment?: Maybe<IssueComment>;
  createProjectAsDraft?: Maybe<Project>;
  createProjectIssue?: Maybe<Issue>;
  createProjectIssueComment?: Maybe<IssueComment>;
  deleteAdAnalyticsReport: Scalars['Boolean'];
  deleteModificationRequestItem?: Maybe<Request>;
  deleteModificationRequestItemAssets: Scalars['Boolean'];
  deleteProject?: Maybe<ProjectDeleteProjectPayload>;
  deleteProjectIssueComment?: Maybe<Issue>;
  editModificationRequestItem?: Maybe<RequestItem>;
  finalizeCreation?: Maybe<Creation>;
  integrateAmazonAdAccount: Scalars['Boolean'];
  integrateFacebookAdAccount: Scalars['Boolean'];
  integrateGoogleAdAccount: Scalars['Boolean'];
  integrateTiktokAdAccount: Scalars['Boolean'];
  integrateYahooAdAccount: Scalars['Boolean'];
  integrateYoutubeChannel?: Maybe<Channel>;
  purchaseProposalCreations?: Maybe<CreationConnection>;
  registerAmazonToken: Scalars['ID'];
  registerGoogleTokenWithAdwordsScope?: Maybe<Array<GoogleAdAccount>>;
  registerTiktokToken: Scalars['ID'];
  registerYahooToken: Scalars['ID'];
  reopenModificationRequestIssue?: Maybe<Issue>;
  resolveModificationRequestIssue?: Maybe<Scalars['Void']>;
  revokeAmazonAdAccount: Scalars['Boolean'];
  revokeFacebookAdAccount: Scalars['Boolean'];
  revokeGoogleAdAccount: Scalars['Boolean'];
  revokeYoutubeChannel: Scalars['Boolean'];
  sendCreativeToAmazon?: Maybe<Creative>;
  sendCreativeToFacebookAdAccount?: Maybe<Creative>;
  sendCreativeToTiktok?: Maybe<Creative>;
  sendCreativeToYahoo?: Maybe<Creative>;
  sendCreativeToYoutube?: Maybe<Creative>;
  submitModificationRequest?: Maybe<Request>;
  submitProject?: Maybe<Project>;
  unlinkTiktokAdAccount: Scalars['Boolean'];
  unlinkYahooAdAccount: Scalars['Boolean'];
  updateAdAnalyticsReport: Scalars['Boolean'];
  updateProject?: Maybe<ProjectProjectWithUpdated>;
  updateProjectAsDraft?: Maybe<Project>;
  updateProjectIssueComment?: Maybe<IssueComment>;
};


export type DirectorMutationAddModificationRequestItemAssetArgs = {
  assetId: Scalars['String'];
  modificationRequestItemId: Scalars['ID'];
};


export type DirectorMutationAdoptProposalCreationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['ID'];
  proposalCreationIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type DirectorMutationApproveModificationRequestArgs = {
  modificationRequestId: Scalars['ID'];
};


export type DirectorMutationCancelCreatingDraftModificationRequestArgs = {
  modificationRequestId: Scalars['ID'];
};


export type DirectorMutationCreateAdAnalyticsReportArgs = {
  adMediaKeys: Array<AdMediaKey>;
  adPlacementKeys: Array<AdPlacementKey>;
  adPlatformKeys: Array<AdPlatformKey>;
  adVideoIds: Array<Scalars['ID']>;
  organizationId: Scalars['ID'];
  period: PerformanceReportPeriodPattern;
  title: Scalars['String'];
};


export type DirectorMutationCreateModificationRequestAsDraftArgs = {
  targetDeliverableId: Scalars['ID'];
};


export type DirectorMutationCreateModificationRequestItemArgs = {
  body: ModificationRequestItemsInput;
  modificationRequestId: Scalars['ID'];
};


export type DirectorMutationCreateModificationRequestItemIssueArgs = {
  assetIds?: InputMaybe<Array<Scalars['String']>>;
  body: Scalars['String'];
  bucketId?: InputMaybe<Scalars['String']>;
  modificationRequestItemId: Scalars['ID'];
  name: Scalars['String'];
};


export type DirectorMutationCreateModificationRequestItemIssueCommentArgs = {
  assetIds: Array<Scalars['String']>;
  body: Scalars['String'];
  bucketId?: InputMaybe<Scalars['String']>;
  issueId: Scalars['ID'];
};


export type DirectorMutationCreateProjectAsDraftArgs = {
  assetCategoryDefinition: Scalars['ID'];
  assetCategoryValues?: InputMaybe<DynamicSchemaValuesInput>;
  creationSet?: InputMaybe<CreationSetInput>;
  creativeBriefDefinition: Scalars['ID'];
  creativeBriefValues?: InputMaybe<DynamicSchemaValuesInput>;
  designInspirationCaseId?: InputMaybe<Scalars['ID']>;
  matchingFormat: MatchingFormat;
  organization: Scalars['ID'];
  parent?: InputMaybe<Scalars['ID']>;
  projectType: Scalars['ID'];
  title: Scalars['String'];
};


export type DirectorMutationCreateProjectIssueArgs = {
  body: Scalars['String'];
  name: Scalars['String'];
  projectId: Scalars['ID'];
};


export type DirectorMutationCreateProjectIssueCommentArgs = {
  body: Scalars['String'];
  issueId: Scalars['ID'];
};


export type DirectorMutationDeleteAdAnalyticsReportArgs = {
  id: Scalars['ID'];
};


export type DirectorMutationDeleteModificationRequestItemArgs = {
  modificationRequestItemId: Scalars['ID'];
};


export type DirectorMutationDeleteModificationRequestItemAssetsArgs = {
  assetIds: Array<Scalars['String']>;
  modificationRequestItemId: Scalars['ID'];
};


export type DirectorMutationDeleteProjectArgs = {
  id: Scalars['ID'];
};


export type DirectorMutationDeleteProjectIssueCommentArgs = {
  commentId: Scalars['ID'];
};


export type DirectorMutationEditModificationRequestItemArgs = {
  body: ModificationRequestItemsInput;
  modificationRequestItemId: Scalars['ID'];
};


export type DirectorMutationFinalizeCreationArgs = {
  id: Scalars['ID'];
};


export type DirectorMutationIntegrateAmazonAdAccountArgs = {
  countryCode: Scalars['String'];
  organizationId: Scalars['ID'];
  profileId: Scalars['ID'];
  tokenId: Scalars['ID'];
};


export type DirectorMutationIntegrateFacebookAdAccountArgs = {
  facebookAccessToken: Scalars['ID'];
  facebookAdAccountId: Scalars['ID'];
  organizationId: Scalars['ID'];
};


export type DirectorMutationIntegrateGoogleAdAccountArgs = {
  googleAdAccount: GoogleAdAccountInput;
  organizationId: Scalars['ID'];
};


export type DirectorMutationIntegrateTiktokAdAccountArgs = {
  organizationId: Scalars['ID'];
  tiktokAdAccountId: Scalars['ID'];
  tokenId: Scalars['ID'];
};


export type DirectorMutationIntegrateYahooAdAccountArgs = {
  organizationId: Scalars['ID'];
  tokenId: Scalars['ID'];
  yahooAdAccountId: Scalars['ID'];
};


export type DirectorMutationIntegrateYoutubeChannelArgs = {
  authCode: Scalars['String'];
};


export type DirectorMutationPurchaseProposalCreationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['ID'];
  proposalCreationIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type DirectorMutationRegisterAmazonTokenArgs = {
  authCode: Scalars['String'];
  codeVerifier: Scalars['String'];
  organizationId: Scalars['ID'];
};


export type DirectorMutationRegisterGoogleTokenWithAdwordsScopeArgs = {
  authCode: Scalars['ID'];
  organizationId: Scalars['ID'];
};


export type DirectorMutationRegisterTiktokTokenArgs = {
  authCode: Scalars['String'];
  organizationId: Scalars['ID'];
};


export type DirectorMutationRegisterYahooTokenArgs = {
  authCode: Scalars['String'];
  organizationId: Scalars['ID'];
};


export type DirectorMutationReopenModificationRequestIssueArgs = {
  issueId: Scalars['ID'];
};


export type DirectorMutationResolveModificationRequestIssueArgs = {
  issueId: Scalars['ID'];
};


export type DirectorMutationRevokeAmazonAdAccountArgs = {
  organizationId: Scalars['ID'];
  profileId: Scalars['ID'];
};


export type DirectorMutationRevokeFacebookAdAccountArgs = {
  facebookAdAccountId: Scalars['ID'];
  organizationId: Scalars['ID'];
};


export type DirectorMutationRevokeGoogleAdAccountArgs = {
  accountId: Scalars['ID'];
  organizationId: Scalars['ID'];
};


export type DirectorMutationRevokeYoutubeChannelArgs = {
  channelId: Scalars['ID'];
};


export type DirectorMutationSendCreativeToAmazonArgs = {
  creativeId: Scalars['ID'];
  organizationId: Scalars['ID'];
  profileId: Scalars['ID'];
  projectId: Scalars['ID'];
};


export type DirectorMutationSendCreativeToFacebookAdAccountArgs = {
  creativeId: Scalars['ID'];
  facebookAccessToken: Scalars['ID'];
  facebookAdAccountId: Scalars['ID'];
};


export type DirectorMutationSendCreativeToTiktokArgs = {
  creativeId: Scalars['ID'];
  organizationId: Scalars['ID'];
  projectId: Scalars['ID'];
  tiktokAdAccountId: Scalars['ID'];
};


export type DirectorMutationSendCreativeToYahooArgs = {
  creativeId: Scalars['ID'];
  organizationId: Scalars['ID'];
  projectId: Scalars['ID'];
  yahooAdAccountId: Scalars['ID'];
};


export type DirectorMutationSendCreativeToYoutubeArgs = {
  channelId: Scalars['ID'];
  creativeId: Scalars['ID'];
};


export type DirectorMutationSubmitModificationRequestArgs = {
  feeType?: InputMaybe<ModificationRequestFeeType>;
  modificationRequestId: Scalars['ID'];
};


export type DirectorMutationSubmitProjectArgs = {
  agreedWithCreativeVisibility: Scalars['Boolean'];
  code?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type DirectorMutationUnlinkTiktokAdAccountArgs = {
  organizationId: Scalars['ID'];
  tiktokAdAccountId: Scalars['ID'];
};


export type DirectorMutationUnlinkYahooAdAccountArgs = {
  organizationId: Scalars['ID'];
  yahooAdAccountId: Scalars['ID'];
};


export type DirectorMutationUpdateAdAnalyticsReportArgs = {
  body: Scalars['String'];
  id: Scalars['ID'];
};


export type DirectorMutationUpdateProjectArgs = {
  assetCategoryValues?: InputMaybe<DynamicSchemaValuesInput>;
  creativeBriefValues?: InputMaybe<DynamicSchemaValuesInput>;
  id: Scalars['ID'];
  title: Scalars['String'];
  versionId: Scalars['ID'];
};


export type DirectorMutationUpdateProjectAsDraftArgs = {
  assetCategoryValues?: InputMaybe<DynamicSchemaValuesInput>;
  creationSet?: InputMaybe<CreationSetInput>;
  creativeBriefValues?: InputMaybe<DynamicSchemaValuesInput>;
  designInspirationCaseId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  matchingFormat?: InputMaybe<MatchingFormat>;
  selectedPricingMerchandiseOptionIds?: InputMaybe<Array<Scalars['ID']>>;
  title?: InputMaybe<Scalars['String']>;
};


export type DirectorMutationUpdateProjectIssueCommentArgs = {
  body: Scalars['String'];
  commentId: Scalars['ID'];
};

export type DirectorQuery = {
  accessibleAmazonAdAccounts: Array<AmazonAdAccount>;
  accessibleTiktokAdAccounts: Array<TiktokAdAccount>;
  accessibleYahooAdAccounts: Array<YahooAdAccount>;
  adAnalyticsDailyPerformance?: Maybe<Array<DailyPerformance>>;
  adAnalyticsPlacementTypes?: Maybe<PlacementTypes>;
  adAnalyticsReport?: Maybe<Report>;
  adAnalyticsReports?: Maybe<ReportWithTotalCountArrayConnection>;
  adAnalyticsVideos?: Maybe<VideoVideoArrayConnection>;
  availableDeliveryDueDates: Array<AvailableDeliveryDueDate>;
  creation?: Maybe<Creation>;
  creationSet?: Maybe<CreationSet>;
  creationsByProject?: Maybe<CreationConnection>;
  creativePerformanceBrowsingAds?: Maybe<CreativePerformanceBrowsingAdConnection>;
  creativePerformanceBrowsingCampaigns?: Maybe<CreativePerformanceBrowsingCampaignConnection>;
  creativePerformanceBrowsingCreatives?: Maybe<CreativePerformanceBrowsingCreativeConnection>;
  dailySummaryPerformance?: Maybe<DailySummaryPerformance>;
  facebookAdAccounts?: Maybe<Array<FacebookAdAccount>>;
  insightCategoriesByOrganization?: Maybe<Array<Category>>;
  integratedAmazonAdAccounts: Array<AmazonAdAccount>;
  integratedFacebookAdAccounts: Array<FacebookAdAccount>;
  integratedGoogleAdAccounts?: Maybe<Array<GoogleAdAccount>>;
  integratedTiktokAdAccounts: Array<TiktokAdAccount>;
  integratedYahooAdAccounts: Array<YahooAdAccount>;
  joinedOrganizations?: Maybe<Array<Organization>>;
  me?: Maybe<User>;
  organization?: Maybe<Organization>;
  periodicDetailPerformance?: Maybe<PeriodicDetailPerformance>;
  periodicImprovementPerformance?: Maybe<PeriodicImprovementPerformance>;
  preparedMaterialCategories: Array<PreparedMaterialCategory>;
  project?: Maybe<Project>;
  projectChange?: Maybe<ProjectChange>;
  projectType?: Maybe<ProjectType>;
  projectTypes?: Maybe<ProjectTypeConnection>;
  projectsByOrganization?: Maybe<ProjectConnection>;
  uploadedAmazonCreatives: Array<AmazonUploadedCreative>;
  uploadedTiktokCreatives: Array<TiktokUploadedCreative>;
  uploadedYahooCreatives: Array<YahooUploadedCreative>;
  youtubeChannels?: Maybe<Array<Channel>>;
};


export type DirectorQueryAccessibleAmazonAdAccountsArgs = {
  organizationId: Scalars['ID'];
  tokenId: Scalars['ID'];
};


export type DirectorQueryAccessibleTiktokAdAccountsArgs = {
  organizationId: Scalars['ID'];
  tokenId: Scalars['ID'];
};


export type DirectorQueryAccessibleYahooAdAccountsArgs = {
  organizationId: Scalars['ID'];
  tokenId: Scalars['ID'];
};


export type DirectorQueryAdAnalyticsDailyPerformanceArgs = {
  adMediaKeys: Array<AdMediaKey>;
  adPlacementKeys: Array<AdPlacementKey>;
  adPlatformKeys: Array<AdPlatformKey>;
  adVideoIds: Array<Scalars['ID']>;
  organizationId: Scalars['ID'];
};


export type DirectorQueryAdAnalyticsReportArgs = {
  id: Scalars['ID'];
};


export type DirectorQueryAdAnalyticsReportsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['ID'];
};


export type DirectorQueryAdAnalyticsVideosArgs = {
  adMediaKeys: Array<AdMediaKey>;
  adPlacementKeys: Array<AdPlacementKey>;
  adPlatformKeys: Array<AdPlatformKey>;
  adVideoIds?: InputMaybe<Array<Scalars['ID']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: Array<AdAnalyticsVideoFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['ID'];
  period: PerformanceReportPeriodPattern;
  sort?: InputMaybe<AdAnalyticsVideoSort>;
};


export type DirectorQueryAvailableDeliveryDueDatesArgs = {
  projectId: Scalars['ID'];
};


export type DirectorQueryCreationArgs = {
  id: Scalars['ID'];
};


export type DirectorQueryCreationSetArgs = {
  id: Scalars['ID'];
};


export type DirectorQueryCreationsByProjectArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['ID'];
};


export type DirectorQueryCreativePerformanceBrowsingAdsArgs = {
  adMediaKeys: Array<AdMediaKey>;
  adPlacementKeys: Array<AdPlacementKey>;
  adPlatformKeys: Array<AdPlatformKey>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<AdAnalyticsVideoFilter>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['ID'];
  period: PerformanceReportPeriodPattern;
  sort?: InputMaybe<AdAnalyticsVideoSort>;
};


export type DirectorQueryCreativePerformanceBrowsingCampaignsArgs = {
  adMediaKeys: Array<AdMediaKey>;
  adPlacementKeys: Array<AdPlacementKey>;
  adPlatformKeys: Array<AdPlatformKey>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<AdAnalyticsVideoFilter>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['ID'];
  period: PerformanceReportPeriodPattern;
  sort?: InputMaybe<AdAnalyticsVideoSort>;
};


export type DirectorQueryCreativePerformanceBrowsingCreativesArgs = {
  adMediaKeys: Array<AdMediaKey>;
  adPlacementKeys: Array<AdPlacementKey>;
  adPlatformKeys: Array<AdPlatformKey>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<AdAnalyticsVideoFilter>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['ID'];
  period: PerformanceReportPeriodPattern;
  sort?: InputMaybe<AdAnalyticsVideoSort>;
};


export type DirectorQueryDailySummaryPerformanceArgs = {
  reportId: Scalars['ID'];
  request: PerformanceReportSummaryRequest;
};


export type DirectorQueryFacebookAdAccountsArgs = {
  facebookAccessToken: Scalars['ID'];
};


export type DirectorQueryInsightCategoriesByOrganizationArgs = {
  language: Scalars['ID'];
  organizationId?: InputMaybe<Scalars['ID']>;
};


export type DirectorQueryIntegratedAmazonAdAccountsArgs = {
  organizationId: Scalars['ID'];
};


export type DirectorQueryIntegratedFacebookAdAccountsArgs = {
  organizationId: Scalars['ID'];
};


export type DirectorQueryIntegratedGoogleAdAccountsArgs = {
  organizationId: Scalars['ID'];
};


export type DirectorQueryIntegratedTiktokAdAccountsArgs = {
  organizationId: Scalars['ID'];
};


export type DirectorQueryIntegratedYahooAdAccountsArgs = {
  organizationId: Scalars['ID'];
};


export type DirectorQueryOrganizationArgs = {
  id: Scalars['ID'];
};


export type DirectorQueryPeriodicDetailPerformanceArgs = {
  reportId: Scalars['ID'];
  request: PerformanceReportDetailRequest;
};


export type DirectorQueryPeriodicImprovementPerformanceArgs = {
  reportId: Scalars['ID'];
  request: PerformanceReportImprovementRequest;
};


export type DirectorQueryPreparedMaterialCategoriesArgs = {
  preparedMaterialCategoryIds: Array<Scalars['ID']>;
};


export type DirectorQueryProjectArgs = {
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['ID']>;
};


export type DirectorQueryProjectChangeArgs = {
  projectId: Scalars['ID'];
};


export type DirectorQueryProjectTypeArgs = {
  key: Scalars['String'];
  language: Scalars['ID'];
  organizationId?: InputMaybe<Scalars['ID']>;
};


export type DirectorQueryProjectTypesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  language: Scalars['ID'];
  last?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['ID']>;
};


export type DirectorQueryProjectsByOrganizationArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  language?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ProjectOrder>;
  organizationId: Scalars['ID'];
};


export type DirectorQueryUploadedAmazonCreativesArgs = {
  creativeIds: Array<Scalars['ID']>;
  organizationId: Scalars['ID'];
};


export type DirectorQueryUploadedTiktokCreativesArgs = {
  creativeIds: Array<Scalars['ID']>;
  organizationId: Scalars['ID'];
};


export type DirectorQueryUploadedYahooCreativesArgs = {
  creativeIds: Array<Scalars['ID']>;
  organizationId: Scalars['ID'];
};

export type DisplaySize = {
  height: Scalars['Float'];
  width: Scalars['Float'];
};

export type DisplaySizeInput = {
  height: Scalars['Float'];
  width: Scalars['Float'];
};

export type DynamicSchemaDefinition = {
  id: Scalars['ID'];
  sections: Array<DynamicSchemaDefinitionSection>;
};

export type DynamicSchemaDefinitionChoice = {
  key: Scalars['String'];
  label: Scalars['String'];
};

export type DynamicSchemaDefinitionField = DynamicSchemaDefinitionFileIds | DynamicSchemaDefinitionFiles | DynamicSchemaDefinitionFixed | DynamicSchemaDefinitionMultiLineText | DynamicSchemaDefinitionPositiveInteger | DynamicSchemaDefinitionSelectMultiple | DynamicSchemaDefinitionSelectOne | DynamicSchemaDefinitionSingleLineText | DynamicSchemaDefinitionToggle;

export type DynamicSchemaDefinitionFieldInterface = {
  key: Scalars['String'];
  label: Scalars['String'];
  type: DynamicSchemaDefinitionFieldType;
};

export type DynamicSchemaDefinitionFieldType =
  | 'FILES'
  | 'FILE_IDS'
  | 'FIXED'
  | 'MULTI_LINE_TEXT'
  | 'POSITIVE_INTEGER'
  | 'SELECT_MULTIPLE'
  | 'SELECT_ONE'
  | 'SINGLE_LINE_TEXT'
  | 'TOGGLE';

export type DynamicSchemaDefinitionFileIds = DynamicSchemaDefinitionFieldInterface & {
  key: Scalars['String'];
  label: Scalars['String'];
  type: DynamicSchemaDefinitionFieldType;
};

export type DynamicSchemaDefinitionFiles = DynamicSchemaDefinitionFieldInterface & {
  helperText: Scalars['String'];
  key: Scalars['String'];
  label: Scalars['String'];
  type: DynamicSchemaDefinitionFieldType;
};

export type DynamicSchemaDefinitionFixed = DynamicSchemaDefinitionFieldInterface & {
  key: Scalars['String'];
  label: Scalars['String'];
  type: DynamicSchemaDefinitionFieldType;
  value: Scalars['String'];
};

export type DynamicSchemaDefinitionMultiLineText = DynamicSchemaDefinitionFieldInterface & {
  helperText: Scalars['String'];
  isRequired: Scalars['Boolean'];
  key: Scalars['String'];
  label: Scalars['String'];
  placeholder: Scalars['String'];
  type: DynamicSchemaDefinitionFieldType;
};

export type DynamicSchemaDefinitionPositiveInteger = DynamicSchemaDefinitionFieldInterface & {
  helperText: Scalars['String'];
  isRequired: Scalars['Boolean'];
  key: Scalars['String'];
  label: Scalars['String'];
  type: DynamicSchemaDefinitionFieldType;
};

export type DynamicSchemaDefinitionSection = {
  description: Scalars['String'];
  fields: Array<DynamicSchemaDefinitionField>;
  id: Scalars['ID'];
  label: Scalars['String'];
  meta?: Maybe<Scalars['KeyValueObject']>;
};

export type DynamicSchemaDefinitionSelectMultiple = DynamicSchemaDefinitionFieldInterface & {
  choices: Array<DynamicSchemaDefinitionChoice>;
  helperText: Scalars['String'];
  isRequiredToSelectAnything: Scalars['Boolean'];
  key: Scalars['String'];
  label: Scalars['String'];
  type: DynamicSchemaDefinitionFieldType;
};

export type DynamicSchemaDefinitionSelectOne = DynamicSchemaDefinitionFieldInterface & {
  choices: Array<DynamicSchemaDefinitionChoice>;
  helperText: Scalars['String'];
  key: Scalars['String'];
  label: Scalars['String'];
  type: DynamicSchemaDefinitionFieldType;
};

export type DynamicSchemaDefinitionSingleLineText = DynamicSchemaDefinitionFieldInterface & {
  helperText: Scalars['String'];
  isRequired: Scalars['Boolean'];
  key: Scalars['String'];
  label: Scalars['String'];
  placeholder: Scalars['String'];
  type: DynamicSchemaDefinitionFieldType;
};

export type DynamicSchemaDefinitionToggle = DynamicSchemaDefinitionFieldInterface & {
  checkedControlLabel: Scalars['String'];
  key: Scalars['String'];
  label: Scalars['String'];
  type: DynamicSchemaDefinitionFieldType;
  uncheckedControlLabel: Scalars['String'];
};

export type DynamicSchemaValuesInput = {
  fields: Scalars['KeyValueObject'];
};

export type FacebookAdAccount = {
  accountId: Scalars['ID'];
  business?: Maybe<BusinessAccount>;
  id: Scalars['ID'];
  myRole: Scalars['String'];
  name: Scalars['String'];
};

export type Feedback = {
  body: Scalars['String'];
  createdAt: Scalars['ISO8601String'];
  id: Scalars['ID'];
};

export type File = {
  attribute: FileAttributeType;
  fastStart?: Maybe<FileFastStart>;
  id: Scalars['ID'];
  mimeType: Scalars['String'];
  originalFileName: Scalars['String'];
  size: Scalars['Int'];
  thumbnailUrl?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type FileAspectRatioType = {
  size: FileDisplaySizeItemType;
};

export type FileAttributeType = {
  aspectRatio?: Maybe<FileAspectRatioType>;
  playbackTime?: Maybe<FilePlaybackTimeType>;
  volume?: Maybe<FileVolumeType>;
};

export type FileDisplaySizeItemType = {
  height: Scalars['Int'];
  width: Scalars['Int'];
};

export type FileFastStart = {
  enabled?: Maybe<Scalars['Boolean']>;
};

export type FilePlaybackTimeType = {
  seconds: Scalars['Float'];
};

export type FileVolumeType = {
  maxVolume?: Maybe<Scalars['Float']>;
};

export type GoogleAdAccount = {
  googleAccountId: Scalars['ID'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  thumbnailUrl: Scalars['ID'];
};

export type GoogleAdAccountInput = {
  googleAccountId: Scalars['ID'];
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  thumbnailUrl: Scalars['ID'];
};

export type ImagePreparedMaterial = {
  id: Scalars['ID'];
  lightWeightUrl: Scalars['String'];
  originalUrl: Scalars['String'];
};

export type ImprovementCreative = {
  adName: Scalars['String'];
  /** If creation is not null, it's a Kaizen Ad creative. */
  creation?: Maybe<Creation>;
  creativeId: Scalars['ID'];
  thumbnailImageUrl: Scalars['String'];
  values: ImprovementValues;
};

export type ImprovementValue = {
  /** データが存在しない指標の場合はnullになる */
  actualValue?: Maybe<PerformanceValue>;
  metric: PerformanceReportMetric;
  target: PerformanceReportComparisonTarget;
  /** データが存在しない指標の場合はnullになる */
  targetValue?: Maybe<PerformanceValue>;
};

export type ImprovementValues = {
  all: Array<ImprovementValue>;
  staticImage: Array<ImprovementValue>;
  video: Array<ImprovementValue>;
};

export type Index = {
  keyFrames: Array<Keyframe>;
  keywords: Array<Keyword>;
  watchingRatings: Array<WatchingRating>;
};

export type InspectionRequest = {
  createdAt: Scalars['ISO8601String'];
  id: Scalars['ID'];
  items: Array<InspectionRequestItem>;
  targetDeliverableId: Scalars['ID'];
};

export type InspectionRequestItem = {
  body: Scalars['String'];
  type: InspectionRequestItemType;
};

export type InspectionRequestItemType = {
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type Issue = {
  comments: Array<IssueComment>;
  createdAt: Scalars['ISO8601String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  resolved: Scalars['Boolean'];
};

export type IssueComment = {
  assetIds: Array<Scalars['String']>;
  body: Scalars['String'];
  createdAt: Scalars['ISO8601String'];
  id: Scalars['ID'];
  updatedAt: Scalars['ISO8601String'];
  user: User;
};

export type Keyframe = {
  end: Scalars['TimeObject'];
  start: Scalars['TimeObject'];
  thumbnailImageUrl: Scalars['String'];
};

export type Keyword = {
  sections?: Maybe<Array<KeywordSection>>;
  text: Scalars['String'];
};

export type KeywordSection = {
  end: Scalars['TimeObject'];
  start: Scalars['TimeObject'];
};

export type MatchingFormat =
  | 'auto'
  | 'competition';

export type MatchingFormatGroup = {
  adminAvailableFormats?: Maybe<Array<MatchingFormat>>;
  availableFormats: Array<MatchingFormat>;
  name?: Maybe<Scalars['String']>;
};

export type ModificationRequestDeliverable = {
  attachedThumbnail?: Maybe<Creative>;
  createdAt: Scalars['ISO8601String'];
  creative: Creative;
  id: Scalars['ID'];
  intent: Scalars['String'];
};

export type ModificationRequestFeeType =
  | 'fee'
  | 'no_fee';

export type ModificationRequestItemsInput = {
  assetIds: Array<Scalars['String']>;
  body: Scalars['String'];
  bucketId?: InputMaybe<Scalars['String']>;
  metadata: Scalars['KeyValueObject'];
  type?: InputMaybe<Scalars['ID']>;
};

export type OfferPricingDetail = {
  basicPricings: Array<OfferPricingDetailItem>;
  optionPricings: Array<OfferPricingDetailItem>;
};

export type OfferPricingDetailItem = {
  actionType: Scalars['String'];
  amount: Scalars['Int'];
  itemGroupKey?: Maybe<Scalars['String']>;
  itemGroupName?: Maybe<Scalars['String']>;
  itemType: Scalars['String'];
  point: Scalars['Int'];
  rewardAmount: Scalars['Int'];
  rewardCurrency: Scalars['String'];
};

export type Option = {
  displayToOptimizer: Scalars['Boolean'];
  helpUrlForDirector?: Maybe<Scalars['String']>;
  helpUrlForOptimizer?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  pricingTables: Array<PricingTable>;
};

export type OrderDirection =
  | 'asc'
  | 'desc';

export type Organization = {
  businessRegion: BusinessRegion;
  features: OrganizationFeatures;
  id: Scalars['ID'];
  name: Scalars['String'];
  pointBalance?: Maybe<Scalars['Int']>;
};

export type OrganizationFeatures = {
  canOpenOfferWhenDisagreed: Scalars['Boolean'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PerformanceReport = {
  adAccount: PerformanceReportAdAccount;
  campaigns: Array<PerformanceReportCampaign>;
  comparisonTargets: Array<PerformanceReportComparisonTarget>;
  dimensions: Array<PerformanceReportDimension>;
  id: Scalars['ID'];
  lastUpdatedAt: Scalars['ISO8601String'];
  metrics: Array<PerformanceReportMetric>;
  periodPatterns: Array<PerformanceReportPeriodPattern>;
};

export type PerformanceReportAdAccount = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  network: PerformanceReportNetwork;
};

export type PerformanceReportCampaign = {
  id: Scalars['ID'];
  /** キャンペーンの名前 */
  name: Scalars['String'];
};

export type PerformanceReportComparisonTarget =
  | 'all'
  | 'static_image'
  | 'video';

export type PerformanceReportDetailRequest = {
  /** キャンペーンを指定しない場合はすべてのキャンペーンを対象とする */
  campaignId?: InputMaybe<Scalars['ID']>;
  period: PerformanceReportPeriodPattern;
};

export type PerformanceReportDimension =
  | 'ad'
  | 'age'
  | 'gender'
  | 'placement';

export type PerformanceReportImprovementRequest = {
  period: PerformanceReportPeriodPattern;
};

export type PerformanceReportMetric =
  | 'click_through_rate'
  | 'clicks'
  | 'conversions'
  | 'cost_per_action'
  | 'cost_per_click'
  | 'cost_per_mille'
  | 'impressions'
  | 'return_on_advertising_spend'
  | 'sales'
  | 'spend'
  | 'video_view_rate_p25'
  | 'video_view_rate_p50'
  | 'video_view_rate_p75'
  | 'video_view_rate_p95'
  | 'video_view_rate_p100'
  | 'view_through_conversions'
  | 'view_through_cost_per_action';

export type PerformanceReportNetwork =
  | 'amazon'
  | 'facebook'
  | 'google'
  | 'yahoo';

export type PerformanceReportPeriod = {
  from: Scalars['ISO8601String'];
  to: Scalars['ISO8601String'];
};

export type PerformanceReportPeriodPattern =
  | 'last_7_days'
  | 'last_30_days'
  | 'last_month'
  | 'last_week'
  | 'lifetime';

export type PerformanceReportSummaryRequest = {
  /** キャンペーンを指定しない場合はすべてのキャンペーンを対象とする */
  campaignId?: InputMaybe<Scalars['ID']>;
  metric: PerformanceReportMetric;
  period: PerformanceReportPeriodPattern;
  target: PerformanceReportComparisonTarget;
};

export type PerformanceValue = {
  currency?: Maybe<Currency>;
  type: PerformanceValueType;
  value: Scalars['Float'];
};

export type PerformanceValueType =
  | 'currency'
  | 'decimal'
  | 'percentage';

export type PeriodicDetailPerformance = {
  creatives: Array<PeriodicDetailPerformanceCreative>;
  period: PerformanceReportPeriod;
};

export type PeriodicDetailPerformanceCreative = {
  adName: Scalars['String'];
  /** If creation is not null, it's a Kaizen Ad creative. */
  creation?: Maybe<Creation>;
  creativeId: Scalars['ID'];
  thumbnailImageUrl: Scalars['String'];
  values: Array<DetailPerformanceValue>;
};

export type PeriodicImprovementPerformance = {
  creatives: Array<ImprovementCreative>;
  period: PerformanceReportPeriod;
};

export type PersonalInformationStatus =
  | 'ACTIVE'
  | 'BLANK'
  | 'BLOCKED';

export type PlacementTypes = {
  periods: Array<PerformanceReportPeriodPattern>;
  platforms: Array<AdAnalyticsPlatform>;
};

export type PreparedMaterial = AudioPreparedMaterial | ImagePreparedMaterial | VideoPreparedMaterial;

export type PreparedMaterialCategory = {
  id: Scalars['ID'];
  name: Scalars['String'];
  preparedMaterials: Array<PreparedMaterial>;
  type: Scalars['String'];
};

export type PricingTable = {
  cells: Array<PricingTableCell>;
  creativeTypeId: Scalars['ID'];
};

export type PricingTableCell = {
  prices: Array<ProductPricing>;
  supportingAspectRatioKey: Scalars['String'];
  supportingPlaybackTimeLength?: Maybe<Scalars['String']>;
};

export type ProductOption = {
  amount: Scalars['Int'];
  name: Scalars['String'];
  points: Array<ProductOptionPoint>;
};

export type ProductOptionInput = {
  amount: Scalars['Int'];
  name: Scalars['String'];
  points: Array<ProductOptionPointInput>;
};

export type ProductOptionPoint = {
  key: Scalars['String'];
  point: Scalars['Int'];
  rewardAmount: Scalars['Int'];
  rewardCurrency: Scalars['String'];
};

export type ProductOptionPointInput = {
  key: Scalars['String'];
  point: Scalars['Int'];
  rewardAmount: Scalars['Int'];
  rewardCurrency: Scalars['String'];
};

export type ProductPricing = {
  key: Scalars['String'];
  point: Scalars['Int'];
  rewardAmount: Scalars['Int'];
  rewardCurrency: Scalars['String'];
};

export type Project = {
  adVideos: Array<Video>;
  assetCategoryDefinition?: Maybe<DynamicSchemaDefinition>;
  assetCategoryUpdatedAt?: Maybe<Scalars['ISO8601String']>;
  assetCategoryValues?: Maybe<Scalars['KeyValueObject']>;
  bucketId?: Maybe<Scalars['ID']>;
  canCreativeVisibilityOnProfile: Scalars['Boolean'];
  canIssueComment: Scalars['Boolean'];
  createdAt: Scalars['ISO8601String'];
  createdBy: UserDirector;
  creationSet?: Maybe<CreationSet>;
  creativeBriefDefinition: DynamicSchemaDefinition;
  creativeBriefUpdatedAt?: Maybe<Scalars['ISO8601String']>;
  creativeBriefValues: Scalars['KeyValueObject'];
  deliveryDueDate?: Maybe<Scalars['ISO8601String']>;
  demo: Scalars['Boolean'];
  designInspirationCase?: Maybe<DesignInspirationCase>;
  finalized: Scalars['Boolean'];
  hasChanges: Scalars['Boolean'];
  id: Scalars['ID'];
  issue?: Maybe<Issue>;
  matchingFormat: MatchingFormat;
  organization: Organization;
  originId: Scalars['ID'];
  parentId?: Maybe<Scalars['ID']>;
  performanceReports: Array<PerformanceReport>;
  progressSummary: ProjectProgressSummary;
  projectType: ProjectType;
  state: ProjectState;
  submittedAt?: Maybe<Scalars['ISO8601String']>;
  title: Scalars['String'];
  updatedAt: Scalars['ISO8601String'];
  versionId?: Maybe<Scalars['ID']>;
};

export type ProjectChange = {
  beforeVersion: ProjectDiff;
  latestVersion: ProjectDiff;
  updatedAt: Scalars['ISO8601String'];
};

/** The connection type for Project. */
export type ProjectConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Project>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ProjectDeleteProjectPayload = {
  success?: Maybe<Scalars['Boolean']>;
};

export type ProjectDiff = {
  assetCategory?: Maybe<Scalars['KeyValueObject']>;
  creativeBrief: Scalars['KeyValueObject'];
};

/** An edge in a connection. */
export type ProjectEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Project>;
};

export type ProjectFilter = {
  /** Only these strings are accepted. "all" | "in_progress" | "draft" | "finalized" */
  filterKey: Scalars['String'];
};

/** Argument to order by ProjectOrderTarget */
export type ProjectOrder = {
  /** default value is `asc` */
  direction?: InputMaybe<OrderDirection>;
  target: ProjectOrderTarget;
};

export type ProjectOrderTarget =
  | 'id'
  | 'submittedAt'
  | 'updatedAt';

export type ProjectProgressSummary = {
  approvedCount: Scalars['Int'];
  modificationRequestCount: Scalars['Int'];
  modificationRequestFeedbackCount: Scalars['Int'];
  orderCount: Scalars['Int'];
};

export type ProjectProjectWithUpdated = {
  project?: Maybe<Project>;
  updated: Scalars['Boolean'];
};

export type ProjectState =
  | 'assigned'
  | 'canceled'
  | 'draft'
  | 'submitted';

export type ProjectType = {
  assetCategoryDefinition?: Maybe<DynamicSchemaDefinition>;
  createdAt: Scalars['ISO8601String'];
  creativeBriefDefinition: DynamicSchemaDefinition;
  description: Scalars['String'];
  designInspirationCategories: Array<DesignInspirationCategory>;
  displayPriority: Scalars['Int'];
  expectedDeliveryPeriod: Scalars['String'];
  id: Scalars['ID'];
  key: Scalars['String'];
  matchingFormatGroup: MatchingFormatGroup;
  maxConceptCount: Scalars['Int'];
  minConceptCount: Scalars['Int'];
  minimumPoint: Scalars['Int'];
  outputSpecification: Scalars['String'];
  popularity: Scalars['Float'];
  pricingMerchandiseOptions: Array<Option>;
  published: Scalars['Boolean'];
  regulation: Scalars['String'];
  sampleVideoUrl?: Maybe<Scalars['String']>;
  supportingCreativeFormatNetworks: Array<SupportingCreativeFormatNetwork>;
  thumbnailImageUrl: Scalars['String'];
  title: Scalars['String'];
  version: Scalars['Int'];
};

/** The connection type for ProjectType. */
export type ProjectTypeConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProjectTypeEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectType>;
};

export type Report = {
  adVideos: Array<Video>;
  body?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601String'];
  createdBy: UserDirector;
  dailyPerfomances: Array<DailyPerformance>;
  id: Scalars['ID'];
  medias: Array<AdAnalyticsNetwork>;
  period: PerformanceReportPeriodPattern;
  placements: Array<AdAnalyticsPlacement>;
  platforms: Array<AdAnalyticsPlatform>;
  title: Scalars['String'];
};

/** OffersConnection type for Report */
export type ReportWithTotalCountArrayConnection = {
  edges: Array<ReportWithTotalCountArrayConnectionEdge>;
  pageInfo: WithTotalCountArrayPageInfo;
};

export type ReportWithTotalCountArrayConnectionEdge = {
  node: Report;
};

export type Request = {
  approvedAt?: Maybe<Scalars['ISO8601String']>;
  bucketId?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601String'];
  creation: Creation;
  deliverables: Array<ModificationRequestDeliverable>;
  deliveryDue?: Maybe<Scalars['ISO8601String']>;
  feeType: ModificationRequestFeeType;
  feedback?: Maybe<Feedback>;
  id: Scalars['ID'];
  items: Array<RequestItem>;
  offerPricingDetail?: Maybe<OfferPricingDetail>;
  sender: UserDirector;
  state: RequestState;
  submittedAt?: Maybe<Scalars['ISO8601String']>;
  targetDeliverableId: Scalars['ID'];
  touchedAt?: Maybe<Scalars['ISO8601String']>;
};

export type RequestItem = {
  assetIds: Array<Scalars['String']>;
  body: Scalars['String'];
  bucketId?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601String'];
  id: Scalars['ID'];
  issue?: Maybe<Issue>;
  metadata: Scalars['KeyValueObject'];
  sender: UserDirector;
  type?: Maybe<Scalars['Int']>;
  typeName?: Maybe<Scalars['String']>;
};

export type RequestState =
  | 'approved'
  | 'draft'
  | 'given_feedback'
  | 'responded'
  | 'submitted';

export type Reward = {
  amount: Scalars['Int'];
  currency: Currency;
  quota: Scalars['Int'];
};

export type SupportingCreativeFormatAspectRatio = {
  availables: Array<SupportingCreativeFormatAspectRatioItem>;
  id: Scalars['ID'];
};

export type SupportingCreativeFormatAspectRatioItem = {
  aspectRatio: AspectRatio;
  presetSize: DisplaySize;
  requiredOption?: Maybe<ProductOption>;
};

export type SupportingCreativeFormatAttribute = {
  aspectRatio?: Maybe<SupportingCreativeFormatAspectRatio>;
  fastStart?: Maybe<SupportingCreativeFormatFastStart>;
  playbackTime?: Maybe<SupportingCreativeFormatPlaybackTime>;
};

export type SupportingCreativeFormatCreativeType = {
  attribute: SupportingCreativeFormatAttribute;
  id: Scalars['ID'];
  key: CreativeFormatCreativeTypeKey;
  name: Scalars['String'];
  requiredPoints: Array<ProductPricing>;
};

export type SupportingCreativeFormatFastStart = {
  availables?: Maybe<Array<SupportingCreativeFormatFastStartItem>>;
  id: Scalars['ID'];
};

export type SupportingCreativeFormatFastStartItem = {
  enabled: Scalars['Boolean'];
};

export type SupportingCreativeFormatNetwork = {
  id: Scalars['ID'];
  key: CreativeFormatNetworkKey;
  name: Scalars['String'];
  placements: Array<SupportingCreativeFormatPlacement>;
};

export type SupportingCreativeFormatPlacement = {
  basicMerchandises: Array<Basic>;
  creativeTypes: Array<SupportingCreativeFormatCreativeType>;
  id: Scalars['ID'];
  key: Scalars['String'];
  name: Scalars['String'];
  pricingTables: Array<PricingTable>;
};

export type SupportingCreativeFormatPlaybackTime = {
  availables: Array<SupportingCreativeFormatPlaybackTimeItem>;
  id: Scalars['ID'];
};

export type SupportingCreativeFormatPlaybackTimeItem = {
  requiredOption?: Maybe<ProductOption>;
  seconds: Scalars['Int'];
};

export type SupportingCreativeType = {
  id: Scalars['ID'];
  key: CreativeFormatCreativeTypeKey;
  name: Scalars['String'];
};

export type TiktokAdAccount = {
  adAccountId: Scalars['ID'];
  countryCode: Scalars['String'];
  currencyCode: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type TiktokUploadedCreative = {
  creativeId: Scalars['ID'];
  mediaId: Scalars['String'];
  uploadedAt: Scalars['ISO8601String'];
};

export type User = UserDirector | UserOptimizer;

export type UserDirector = {
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  profileImageUrl: Scalars['String'];
};

export type UserOptimizer = {
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  personalInformationStatus?: Maybe<PersonalInformationStatus>;
  profileImageUrl: Scalars['String'];
};

export type Video = {
  adAnalyticsVideoIndex?: Maybe<Index>;
  adVideoId: Scalars['ID'];
  analyzingState: VideoAnalyzingState;
  clicks: Scalars['Float'];
  conversions: Scalars['Float'];
  conversionsKey?: Maybe<Scalars['String']>;
  cpa?: Maybe<Scalars['Float']>;
  cpaWithViewThroughConversions?: Maybe<Scalars['Float']>;
  cpc?: Maybe<Scalars['Float']>;
  cpm?: Maybe<Scalars['Float']>;
  ctr?: Maybe<Scalars['Float']>;
  currency: Scalars['String'];
  cvr: Scalars['Float'];
  duration: Scalars['Float'];
  impressions: Scalars['Float'];
  medias: Array<AdAnalyticsNetwork>;
  mobileAppInstalls?: Maybe<Scalars['Float']>;
  placements: Array<AdAnalyticsPlacement>;
  platforms: Array<AdAnalyticsPlatform>;
  project?: Maybe<Project>;
  spend: Scalars['Float'];
  thumbnailImageUrl: Scalars['String'];
  title: Scalars['String'];
  videoUrl: Scalars['String'];
  viewThroughConversions: Scalars['Float'];
};

export type VideoAnalyzingState =
  | 'not_analyze'
  | 'processed'
  | 'processing';

/** Current connection information */
export type VideoArrayPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  startCursor?: Maybe<Scalars['String']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type VideoPreparedMaterial = {
  id: Scalars['ID'];
  lightWeightUrl: Scalars['String'];
  originalUrl: Scalars['String'];
  thumbnailUrl: Scalars['String'];
};

/** VideoArrayConnection type for Video */
export type VideoVideoArrayConnection = {
  edges: Array<VideoVideoArrayConnectionEdge>;
  pageInfo: VideoArrayPageInfo;
};

export type VideoVideoArrayConnectionEdge = {
  node: Video;
};

export type WatchingRating = {
  rate: Scalars['Float'];
  until: Scalars['Int'];
};

/** Current connection information */
export type WithTotalCountArrayPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  startCursor?: Maybe<Scalars['String']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type YahooAdAccount = {
  adAccountId: Scalars['ID'];
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type YahooUploadedCreative = {
  creativeId: Scalars['ID'];
  mediaId: Scalars['String'];
  uploadedAt: Scalars['ISO8601String'];
};

export type GetCreationSetWithPricingQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCreationSetWithPricingQuery = { creationSet?: { id: string, expressDueDays?: number | null, creativeFormats: Array<{ id: string, resizeBaseId?: string | null, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null }, selectedPricingMerchandiseOptions: Array<{ pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }> }> } | null };

export type CreationSetWithPricingFragment = { id: string, expressDueDays?: number | null, creativeFormats: Array<{ id: string, resizeBaseId?: string | null, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null }, selectedPricingMerchandiseOptions: Array<{ pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }> }> };

export type AdoptProposalCreationsMutationVariables = Exact<{
  projectId: Scalars['ID'];
  proposalCreationIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type AdoptProposalCreationsMutation = { adoptProposalCreations?: { nodes?: Array<{ id: string } | null> | null } | null };

export type PurchaseProposalCreationsMutationVariables = Exact<{
  projectId: Scalars['ID'];
  proposalCreationIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type PurchaseProposalCreationsMutation = { purchaseProposalCreations?: { nodes?: Array<{ id: string } | null> | null } | null };

export type FinalizeCreationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FinalizeCreationMutation = { finalizeCreation?: { id: string } | null };

export type GetInsightCategoriesQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']>;
  language: Scalars['ID'];
}>;


export type GetInsightCategoriesQuery = { insightCategoriesByOrganization?: Array<{ id: string, name: string, description?: string | null, pcColumnCount: number, spColumnCount: number, rowCount: number, articles: Array<{ id: string, title?: string | null, url: string, thumbnailImageUrl: string }> }> | null };

export type DesignInspirationCategoryDetailFragment = { id: string, name: string, iconUrl: string, designInspirationCases: Array<{ id: string, name: string, description: string, url: string, thumbnailUrl?: string | null }> };

export type ProjectTypeDetailFragment = { id: string, key: string, title: string, description: string, thumbnailImageUrl: string, sampleVideoUrl?: string | null, expectedDeliveryPeriod: string, outputSpecification: string, regulation: string, designInspirationCategories: Array<{ id: string, name: string, iconUrl: string, designInspirationCases: Array<{ id: string, name: string, description: string, url: string, thumbnailUrl?: string | null }> }>, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string }> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, supportingCreativeFormatNetworks: Array<{ id: string, key: CreativeFormatNetworkKey, name: string, placements: Array<{ id: string, key: string, name: string, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }>, creativeTypes: Array<{ id: string, key: CreativeFormatCreativeTypeKey, name: string, attribute: { aspectRatio?: { id: string, availables: Array<{ aspectRatio: { width: number, height: number }, presetSize: { width: number, height: number }, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null, playbackTime?: { id: string, availables: Array<{ seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null } }> }> }> };

export type GetProjectTypeQueryVariables = Exact<{
  key: Scalars['String'];
  language: Scalars['ID'];
}>;


export type GetProjectTypeQuery = { projectType?: { id: string, key: string, title: string, description: string, thumbnailImageUrl: string, sampleVideoUrl?: string | null, expectedDeliveryPeriod: string, outputSpecification: string, regulation: string, designInspirationCategories: Array<{ id: string, name: string, iconUrl: string, designInspirationCases: Array<{ id: string, name: string, description: string, url: string, thumbnailUrl?: string | null }> }>, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string }> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, supportingCreativeFormatNetworks: Array<{ id: string, key: CreativeFormatNetworkKey, name: string, placements: Array<{ id: string, key: string, name: string, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }>, creativeTypes: Array<{ id: string, key: CreativeFormatCreativeTypeKey, name: string, attribute: { aspectRatio?: { id: string, availables: Array<{ aspectRatio: { width: number, height: number }, presetSize: { width: number, height: number }, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null, playbackTime?: { id: string, availables: Array<{ seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null } }> }> }> } | null };

export type GetProjectByIdForOptionScreenQueryVariables = Exact<{
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['ID']>;
}>;


export type GetProjectByIdForOptionScreenQuery = { project?: { id: string, versionId?: string | null, matchingFormat: MatchingFormat, originId: string, parentId?: string | null, title: string, state: ProjectState, bucketId?: string | null, createdAt: any, submittedAt?: any | null, organization: { id: string, name: string, pointBalance?: number | null, features: { canOpenOfferWhenDisagreed: boolean }, businessRegion: { key: BusinessRegionAdRegionKey, idBusinessRegion: BusinessRegionIdBusinessRegion, timeZone: string } }, creationSet?: { id: string, amount: number, additionalAmount: number, deliveryDueDate?: any | null, deliveryDueDays?: number | null, expressDueDays?: number | null, finalizedAt?: any | null, creativeFormats: Array<{ id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }> }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null }, selectedPricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }> }>, creations: Array<{ id: string, state: CreationState, createdAt: any, stateUpdatedAt: any, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, intent: string, state: DeliverableState, createdAt: any, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } }>, modificationRequests: Array<{ id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }> }>, creativeFormat: { id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null } } }> } | null, projectType: { id: string, key: string, published: boolean, version: number, title: string, description: string, thumbnailImageUrl: string, sampleVideoUrl?: string | null, expectedDeliveryPeriod: string, outputSpecification: string, regulation: string, minConceptCount: number, maxConceptCount: number, pricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }>, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string } | {}> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, meta?: any | null, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, supportingCreativeFormatNetworks: Array<{ id: string, key: CreativeFormatNetworkKey, name: string, placements: Array<{ id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }>, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }>, creativeTypes: Array<{ id: string, key: CreativeFormatCreativeTypeKey, name: string, attribute: { aspectRatio?: { id: string, availables: Array<{ aspectRatio: { width: number, height: number }, presetSize: { width: number, height: number }, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null, playbackTime?: { id: string, availables: Array<{ seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null } }> }> }>, matchingFormatGroup: { availableFormats: Array<MatchingFormat> } } } | null };

export type UpdateDraftProjectFromOptionScreenToPreviewScreenMutationVariables = Exact<{
  id: Scalars['ID'];
  title: Scalars['String'];
  matchingFormat: MatchingFormat;
  creationSet?: InputMaybe<CreationSetInput>;
  selectedPricingMerchandiseOptionIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type UpdateDraftProjectFromOptionScreenToPreviewScreenMutation = { updateProjectAsDraft?: { id: string, versionId?: string | null, matchingFormat: MatchingFormat, originId: string, parentId?: string | null, title: string, state: ProjectState, creativeBriefValues: any, bucketId?: string | null, assetCategoryValues?: any | null, createdAt: any, submittedAt?: any | null, organization: { id: string, name: string, pointBalance?: number | null, features: { canOpenOfferWhenDisagreed: boolean }, businessRegion: { key: BusinessRegionAdRegionKey, idBusinessRegion: BusinessRegionIdBusinessRegion, timeZone: string } }, createdBy: { id: string, name: string, profileImageUrl: string }, designInspirationCase?: { id: string, name: string, url: string, thumbnailUrl?: string | null } | null, projectType: { id: string, key: string, published: boolean, version: number, title: string, description: string, thumbnailImageUrl: string, sampleVideoUrl?: string | null, expectedDeliveryPeriod: string, outputSpecification: string, regulation: string, minConceptCount: number, maxConceptCount: number, pricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }>, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string } | {}> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, meta?: any | null, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, supportingCreativeFormatNetworks: Array<{ id: string, key: CreativeFormatNetworkKey, name: string, placements: Array<{ id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }>, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }>, creativeTypes: Array<{ id: string, key: CreativeFormatCreativeTypeKey, name: string, attribute: { aspectRatio?: { id: string, availables: Array<{ aspectRatio: { width: number, height: number }, presetSize: { width: number, height: number }, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null, playbackTime?: { id: string, availables: Array<{ seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null } }> }> }>, matchingFormatGroup: { availableFormats: Array<MatchingFormat> } }, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string }> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, meta?: any | null, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, creationSet?: { id: string, amount: number, additionalAmount: number, deliveryDueDate?: any | null, deliveryDueDays?: number | null, expressDueDays?: number | null, finalizedAt?: any | null, creativeFormats: Array<{ id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }> }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null }, selectedPricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }> }>, creations: Array<{ id: string, state: CreationState, createdAt: any, stateUpdatedAt: any, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, intent: string, state: DeliverableState, createdAt: any, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } }>, modificationRequests: Array<{ id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }> }>, creativeFormat: { id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null } } }> } | null, performanceReports: Array<{ id: string, lastUpdatedAt: any, periodPatterns: Array<PerformanceReportPeriodPattern>, metrics: Array<PerformanceReportMetric>, comparisonTargets: Array<PerformanceReportComparisonTarget>, dimensions: Array<PerformanceReportDimension>, adAccount: { id: string, network: PerformanceReportNetwork, accountId: string, name: string }, campaigns: Array<{ id: string, name: string }> }>, adVideos: Array<{ adVideoId: string, analyzingState: VideoAnalyzingState }> } | null };

export type UpdateDraftProjectOnOptionScreenMutationVariables = Exact<{
  id: Scalars['ID'];
  title: Scalars['String'];
  matchingFormat: MatchingFormat;
  creationSet?: InputMaybe<CreationSetInput>;
  selectedPricingMerchandiseOptionIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type UpdateDraftProjectOnOptionScreenMutation = { updateProjectAsDraft?: { id: string, versionId?: string | null, matchingFormat: MatchingFormat, originId: string, parentId?: string | null, title: string, state: ProjectState, creativeBriefValues: any, bucketId?: string | null, assetCategoryValues?: any | null, createdAt: any, submittedAt?: any | null, organization: { id: string, name: string, pointBalance?: number | null, features: { canOpenOfferWhenDisagreed: boolean }, businessRegion: { key: BusinessRegionAdRegionKey, idBusinessRegion: BusinessRegionIdBusinessRegion, timeZone: string } }, createdBy: { id: string, name: string, profileImageUrl: string }, designInspirationCase?: { id: string, name: string, url: string, thumbnailUrl?: string | null } | null, projectType: { id: string, key: string, published: boolean, version: number, title: string, description: string, thumbnailImageUrl: string, sampleVideoUrl?: string | null, expectedDeliveryPeriod: string, outputSpecification: string, regulation: string, minConceptCount: number, maxConceptCount: number, pricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }>, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string } | {}> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, meta?: any | null, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, supportingCreativeFormatNetworks: Array<{ id: string, key: CreativeFormatNetworkKey, name: string, placements: Array<{ id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }>, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }>, creativeTypes: Array<{ id: string, key: CreativeFormatCreativeTypeKey, name: string, attribute: { aspectRatio?: { id: string, availables: Array<{ aspectRatio: { width: number, height: number }, presetSize: { width: number, height: number }, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null, playbackTime?: { id: string, availables: Array<{ seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null } }> }> }>, matchingFormatGroup: { availableFormats: Array<MatchingFormat> } }, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string }> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, meta?: any | null, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, creationSet?: { id: string, amount: number, additionalAmount: number, deliveryDueDate?: any | null, deliveryDueDays?: number | null, expressDueDays?: number | null, finalizedAt?: any | null, creativeFormats: Array<{ id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }> }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null }, selectedPricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }> }>, creations: Array<{ id: string, state: CreationState, createdAt: any, stateUpdatedAt: any, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, intent: string, state: DeliverableState, createdAt: any, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } }>, modificationRequests: Array<{ id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }> }>, creativeFormat: { id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null } } }> } | null, performanceReports: Array<{ id: string, lastUpdatedAt: any, periodPatterns: Array<PerformanceReportPeriodPattern>, metrics: Array<PerformanceReportMetric>, comparisonTargets: Array<PerformanceReportComparisonTarget>, dimensions: Array<PerformanceReportDimension>, adAccount: { id: string, network: PerformanceReportNetwork, accountId: string, name: string }, campaigns: Array<{ id: string, name: string }> }>, adVideos: Array<{ adVideoId: string, analyzingState: VideoAnalyzingState }> } | null };

export type UpdateDraftProjectToOptionScreenMutationVariables = Exact<{
  id: Scalars['ID'];
  title: Scalars['String'];
  matchingFormat: MatchingFormat;
  creationSet?: InputMaybe<CreationSetInput>;
  creativeBriefValues?: InputMaybe<DynamicSchemaValuesInput>;
  assetCategoryValues?: InputMaybe<DynamicSchemaValuesInput>;
  designInspirationCaseId?: InputMaybe<Scalars['ID']>;
  selectedPricingMerchandiseOptionIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type UpdateDraftProjectToOptionScreenMutation = { updateProjectAsDraft?: { id: string, versionId?: string | null, matchingFormat: MatchingFormat, originId: string, parentId?: string | null, title: string, state: ProjectState, bucketId?: string | null, createdAt: any, submittedAt?: any | null, organization: { id: string, name: string, pointBalance?: number | null, features: { canOpenOfferWhenDisagreed: boolean }, businessRegion: { key: BusinessRegionAdRegionKey, idBusinessRegion: BusinessRegionIdBusinessRegion, timeZone: string } }, creationSet?: { id: string, amount: number, additionalAmount: number, deliveryDueDate?: any | null, deliveryDueDays?: number | null, expressDueDays?: number | null, finalizedAt?: any | null, creativeFormats: Array<{ id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }> }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null }, selectedPricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }> }>, creations: Array<{ id: string, state: CreationState, createdAt: any, stateUpdatedAt: any, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, intent: string, state: DeliverableState, createdAt: any, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } }>, modificationRequests: Array<{ id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }> }>, creativeFormat: { id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null } } }> } | null, projectType: { id: string, key: string, published: boolean, version: number, title: string, description: string, thumbnailImageUrl: string, sampleVideoUrl?: string | null, expectedDeliveryPeriod: string, outputSpecification: string, regulation: string, minConceptCount: number, maxConceptCount: number, pricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }>, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string } | {}> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, meta?: any | null, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, supportingCreativeFormatNetworks: Array<{ id: string, key: CreativeFormatNetworkKey, name: string, placements: Array<{ id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }>, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }>, creativeTypes: Array<{ id: string, key: CreativeFormatCreativeTypeKey, name: string, attribute: { aspectRatio?: { id: string, availables: Array<{ aspectRatio: { width: number, height: number }, presetSize: { width: number, height: number }, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null, playbackTime?: { id: string, availables: Array<{ seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null } }> }> }>, matchingFormatGroup: { availableFormats: Array<MatchingFormat> } } } | null };

export type ProjectDetailsForOptionScreenFragment = { id: string, versionId?: string | null, matchingFormat: MatchingFormat, originId: string, parentId?: string | null, title: string, state: ProjectState, bucketId?: string | null, createdAt: any, submittedAt?: any | null, organization: { id: string, name: string, pointBalance?: number | null, features: { canOpenOfferWhenDisagreed: boolean }, businessRegion: { key: BusinessRegionAdRegionKey, idBusinessRegion: BusinessRegionIdBusinessRegion, timeZone: string } }, creationSet?: { id: string, amount: number, additionalAmount: number, deliveryDueDate?: any | null, deliveryDueDays?: number | null, expressDueDays?: number | null, finalizedAt?: any | null, creativeFormats: Array<{ id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }> }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null }, selectedPricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }> }>, creations: Array<{ id: string, state: CreationState, createdAt: any, stateUpdatedAt: any, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, intent: string, state: DeliverableState, createdAt: any, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } }>, modificationRequests: Array<{ id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }> }>, creativeFormat: { id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null } } }> } | null, projectType: { id: string, key: string, published: boolean, version: number, title: string, description: string, thumbnailImageUrl: string, sampleVideoUrl?: string | null, expectedDeliveryPeriod: string, outputSpecification: string, regulation: string, minConceptCount: number, maxConceptCount: number, pricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }>, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string } | {}> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, meta?: any | null, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, supportingCreativeFormatNetworks: Array<{ id: string, key: CreativeFormatNetworkKey, name: string, placements: Array<{ id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }>, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }>, creativeTypes: Array<{ id: string, key: CreativeFormatCreativeTypeKey, name: string, attribute: { aspectRatio?: { id: string, availables: Array<{ aspectRatio: { width: number, height: number }, presetSize: { width: number, height: number }, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null, playbackTime?: { id: string, availables: Array<{ seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null } }> }> }>, matchingFormatGroup: { availableFormats: Array<MatchingFormat> } } };

export type ProjectDetailsFragment = { id: string, versionId?: string | null, matchingFormat: MatchingFormat, originId: string, parentId?: string | null, title: string, state: ProjectState, creativeBriefValues: any, bucketId?: string | null, assetCategoryValues?: any | null, createdAt: any, submittedAt?: any | null, organization: { id: string, name: string, pointBalance?: number | null, features: { canOpenOfferWhenDisagreed: boolean }, businessRegion: { key: BusinessRegionAdRegionKey, idBusinessRegion: BusinessRegionIdBusinessRegion, timeZone: string } }, createdBy: { id: string, name: string, profileImageUrl: string }, designInspirationCase?: { id: string, name: string, url: string, thumbnailUrl?: string | null } | null, projectType: { id: string, key: string, published: boolean, version: number, title: string, description: string, thumbnailImageUrl: string, sampleVideoUrl?: string | null, expectedDeliveryPeriod: string, outputSpecification: string, regulation: string, minConceptCount: number, maxConceptCount: number, pricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }>, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string } | {}> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, meta?: any | null, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, supportingCreativeFormatNetworks: Array<{ id: string, key: CreativeFormatNetworkKey, name: string, placements: Array<{ id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }>, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }>, creativeTypes: Array<{ id: string, key: CreativeFormatCreativeTypeKey, name: string, attribute: { aspectRatio?: { id: string, availables: Array<{ aspectRatio: { width: number, height: number }, presetSize: { width: number, height: number }, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null, playbackTime?: { id: string, availables: Array<{ seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null } }> }> }>, matchingFormatGroup: { availableFormats: Array<MatchingFormat> } }, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string }> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, meta?: any | null, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, creationSet?: { id: string, amount: number, additionalAmount: number, deliveryDueDate?: any | null, deliveryDueDays?: number | null, expressDueDays?: number | null, finalizedAt?: any | null, creativeFormats: Array<{ id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }> }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null }, selectedPricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }> }>, creations: Array<{ id: string, state: CreationState, createdAt: any, stateUpdatedAt: any, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, intent: string, state: DeliverableState, createdAt: any, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } }>, modificationRequests: Array<{ id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }> }>, creativeFormat: { id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null } } }> } | null, performanceReports: Array<{ id: string, lastUpdatedAt: any, periodPatterns: Array<PerformanceReportPeriodPattern>, metrics: Array<PerformanceReportMetric>, comparisonTargets: Array<PerformanceReportComparisonTarget>, dimensions: Array<PerformanceReportDimension>, adAccount: { id: string, network: PerformanceReportNetwork, accountId: string, name: string }, campaigns: Array<{ id: string, name: string }> }>, adVideos: Array<{ adVideoId: string, analyzingState: VideoAnalyzingState }> };

export type ProjectDetailsWithoutPricingDataFragment = { id: string, versionId?: string | null, matchingFormat: MatchingFormat, originId: string, parentId?: string | null, title: string, state: ProjectState, creativeBriefValues: any, bucketId?: string | null, assetCategoryValues?: any | null, createdAt: any, submittedAt?: any | null, organization: { id: string, name: string, pointBalance?: number | null, features: { canOpenOfferWhenDisagreed: boolean }, businessRegion: { key: BusinessRegionAdRegionKey, idBusinessRegion: BusinessRegionIdBusinessRegion, timeZone: string } }, createdBy: { id: string, name: string, profileImageUrl: string }, designInspirationCase?: { id: string, name: string, url: string, thumbnailUrl?: string | null } | null, projectType: { id: string, key: string, published: boolean, version: number, title: string, description: string, thumbnailImageUrl: string, sampleVideoUrl?: string | null, expectedDeliveryPeriod: string, outputSpecification: string, regulation: string, minConceptCount: number, maxConceptCount: number, pricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }>, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string } | {}> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, meta?: any | null, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, supportingCreativeFormatNetworks: Array<{ id: string, key: CreativeFormatNetworkKey, name: string, placements: Array<{ id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }>, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }>, creativeTypes: Array<{ id: string, key: CreativeFormatCreativeTypeKey, name: string, attribute: { aspectRatio?: { id: string, availables: Array<{ aspectRatio: { width: number, height: number }, presetSize: { width: number, height: number }, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null, playbackTime?: { id: string, availables: Array<{ seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null } }> }> }>, matchingFormatGroup: { availableFormats: Array<MatchingFormat> } }, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string }> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, meta?: any | null, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, creationSet?: { id: string, amount: number, additionalAmount: number, deliveryDueDate?: any | null, deliveryDueDays?: number | null, expressDueDays?: number | null, finalizedAt?: any | null, creativeFormats: Array<{ id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }> }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null }, selectedPricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }> }>, creations: Array<{ id: string, state: CreationState, createdAt: any, stateUpdatedAt: any, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, intent: string, state: DeliverableState, createdAt: any, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } }>, modificationRequests: Array<{ id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }> }>, creativeFormat: { id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null } } }> } | null, performanceReports: Array<{ id: string, lastUpdatedAt: any, periodPatterns: Array<PerformanceReportPeriodPattern>, metrics: Array<PerformanceReportMetric>, comparisonTargets: Array<PerformanceReportComparisonTarget>, dimensions: Array<PerformanceReportDimension>, adAccount: { id: string, network: PerformanceReportNetwork, accountId: string, name: string }, campaigns: Array<{ id: string, name: string }> }>, adVideos: Array<{ adVideoId: string, analyzingState: VideoAnalyzingState }> };

export type GetProjectByIdQueryVariables = Exact<{
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['ID']>;
}>;


export type GetProjectByIdQuery = { project?: { id: string, versionId?: string | null, matchingFormat: MatchingFormat, originId: string, parentId?: string | null, title: string, state: ProjectState, creativeBriefValues: any, bucketId?: string | null, assetCategoryValues?: any | null, createdAt: any, submittedAt?: any | null, organization: { id: string, name: string, pointBalance?: number | null, features: { canOpenOfferWhenDisagreed: boolean }, businessRegion: { key: BusinessRegionAdRegionKey, idBusinessRegion: BusinessRegionIdBusinessRegion, timeZone: string } }, createdBy: { id: string, name: string, profileImageUrl: string }, designInspirationCase?: { id: string, name: string, url: string, thumbnailUrl?: string | null } | null, projectType: { id: string, key: string, published: boolean, version: number, title: string, description: string, thumbnailImageUrl: string, sampleVideoUrl?: string | null, expectedDeliveryPeriod: string, outputSpecification: string, regulation: string, minConceptCount: number, maxConceptCount: number, pricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }>, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string } | {}> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, meta?: any | null, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, supportingCreativeFormatNetworks: Array<{ id: string, key: CreativeFormatNetworkKey, name: string, placements: Array<{ id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }>, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }>, creativeTypes: Array<{ id: string, key: CreativeFormatCreativeTypeKey, name: string, attribute: { aspectRatio?: { id: string, availables: Array<{ aspectRatio: { width: number, height: number }, presetSize: { width: number, height: number }, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null, playbackTime?: { id: string, availables: Array<{ seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null } }> }> }>, matchingFormatGroup: { availableFormats: Array<MatchingFormat> } }, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string }> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, meta?: any | null, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, creationSet?: { id: string, amount: number, additionalAmount: number, deliveryDueDate?: any | null, deliveryDueDays?: number | null, expressDueDays?: number | null, finalizedAt?: any | null, creativeFormats: Array<{ id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }> }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null }, selectedPricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }> }>, creations: Array<{ id: string, state: CreationState, createdAt: any, stateUpdatedAt: any, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, intent: string, state: DeliverableState, createdAt: any, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } }>, modificationRequests: Array<{ id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }> }>, creativeFormat: { id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null } } }> } | null, performanceReports: Array<{ id: string, lastUpdatedAt: any, periodPatterns: Array<PerformanceReportPeriodPattern>, metrics: Array<PerformanceReportMetric>, comparisonTargets: Array<PerformanceReportComparisonTarget>, dimensions: Array<PerformanceReportDimension>, adAccount: { id: string, network: PerformanceReportNetwork, accountId: string, name: string }, campaigns: Array<{ id: string, name: string }> }>, adVideos: Array<{ adVideoId: string, analyzingState: VideoAnalyzingState }> } | null };

export type GetProjectByIdWithoutPricingDataQueryVariables = Exact<{
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['ID']>;
}>;


export type GetProjectByIdWithoutPricingDataQuery = { project?: { id: string, versionId?: string | null, matchingFormat: MatchingFormat, originId: string, parentId?: string | null, title: string, state: ProjectState, creativeBriefValues: any, bucketId?: string | null, assetCategoryValues?: any | null, createdAt: any, submittedAt?: any | null, organization: { id: string, name: string, pointBalance?: number | null, features: { canOpenOfferWhenDisagreed: boolean }, businessRegion: { key: BusinessRegionAdRegionKey, idBusinessRegion: BusinessRegionIdBusinessRegion, timeZone: string } }, createdBy: { id: string, name: string, profileImageUrl: string }, designInspirationCase?: { id: string, name: string, url: string, thumbnailUrl?: string | null } | null, projectType: { id: string, key: string, published: boolean, version: number, title: string, description: string, thumbnailImageUrl: string, sampleVideoUrl?: string | null, expectedDeliveryPeriod: string, outputSpecification: string, regulation: string, minConceptCount: number, maxConceptCount: number, pricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }>, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string } | {}> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, meta?: any | null, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, supportingCreativeFormatNetworks: Array<{ id: string, key: CreativeFormatNetworkKey, name: string, placements: Array<{ id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }>, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }>, creativeTypes: Array<{ id: string, key: CreativeFormatCreativeTypeKey, name: string, attribute: { aspectRatio?: { id: string, availables: Array<{ aspectRatio: { width: number, height: number }, presetSize: { width: number, height: number }, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null, playbackTime?: { id: string, availables: Array<{ seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null } }> }> }>, matchingFormatGroup: { availableFormats: Array<MatchingFormat> } }, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string }> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, meta?: any | null, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, creationSet?: { id: string, amount: number, additionalAmount: number, deliveryDueDate?: any | null, deliveryDueDays?: number | null, expressDueDays?: number | null, finalizedAt?: any | null, creativeFormats: Array<{ id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }> }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null }, selectedPricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }> }>, creations: Array<{ id: string, state: CreationState, createdAt: any, stateUpdatedAt: any, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, intent: string, state: DeliverableState, createdAt: any, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } }>, modificationRequests: Array<{ id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }> }>, creativeFormat: { id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null } } }> } | null, performanceReports: Array<{ id: string, lastUpdatedAt: any, periodPatterns: Array<PerformanceReportPeriodPattern>, metrics: Array<PerformanceReportMetric>, comparisonTargets: Array<PerformanceReportComparisonTarget>, dimensions: Array<PerformanceReportDimension>, adAccount: { id: string, network: PerformanceReportNetwork, accountId: string, name: string }, campaigns: Array<{ id: string, name: string }> }>, adVideos: Array<{ adVideoId: string, analyzingState: VideoAnalyzingState }> } | null };

export type GetAvailableDeliveryDueDatesQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type GetAvailableDeliveryDueDatesQuery = { availableDeliveryDueDates: Array<{ days: number, dueDate: any, expressDueDays: number }> };

export type CreateProjectAsDraftMutationVariables = Exact<{
  title: Scalars['String'];
  matchingFormat: MatchingFormat;
  organizationId: Scalars['ID'];
  projectTypeId: Scalars['ID'];
  creationSet?: InputMaybe<CreationSetInput>;
  creativeBriefDefinitionId: Scalars['ID'];
  creativeBriefValues?: InputMaybe<DynamicSchemaValuesInput>;
  assetCategoryDefinitionId: Scalars['ID'];
  assetCategoryValues?: InputMaybe<DynamicSchemaValuesInput>;
  parentProjectId?: InputMaybe<Scalars['ID']>;
  designInspirationCaseId?: InputMaybe<Scalars['ID']>;
}>;


export type CreateProjectAsDraftMutation = { createProjectAsDraft?: { id: string } | null };

export type UpdateDraftProjectMutationVariables = Exact<{
  id: Scalars['ID'];
  title: Scalars['String'];
  matchingFormat: MatchingFormat;
  creationSet?: InputMaybe<CreationSetInput>;
  creativeBriefValues?: InputMaybe<DynamicSchemaValuesInput>;
  assetCategoryValues?: InputMaybe<DynamicSchemaValuesInput>;
  designInspirationCaseId?: InputMaybe<Scalars['ID']>;
  selectedPricingMerchandiseOptionIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type UpdateDraftProjectMutation = { updateProjectAsDraft?: { id: string, versionId?: string | null, matchingFormat: MatchingFormat, originId: string, parentId?: string | null, title: string, state: ProjectState, creativeBriefValues: any, bucketId?: string | null, assetCategoryValues?: any | null, createdAt: any, submittedAt?: any | null, organization: { id: string, name: string, pointBalance?: number | null, features: { canOpenOfferWhenDisagreed: boolean }, businessRegion: { key: BusinessRegionAdRegionKey, idBusinessRegion: BusinessRegionIdBusinessRegion, timeZone: string } }, createdBy: { id: string, name: string, profileImageUrl: string }, designInspirationCase?: { id: string, name: string, url: string, thumbnailUrl?: string | null } | null, projectType: { id: string, key: string, published: boolean, version: number, title: string, description: string, thumbnailImageUrl: string, sampleVideoUrl?: string | null, expectedDeliveryPeriod: string, outputSpecification: string, regulation: string, minConceptCount: number, maxConceptCount: number, pricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }>, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string } | {}> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, meta?: any | null, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, supportingCreativeFormatNetworks: Array<{ id: string, key: CreativeFormatNetworkKey, name: string, placements: Array<{ id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }>, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }>, creativeTypes: Array<{ id: string, key: CreativeFormatCreativeTypeKey, name: string, attribute: { aspectRatio?: { id: string, availables: Array<{ aspectRatio: { width: number, height: number }, presetSize: { width: number, height: number }, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null, playbackTime?: { id: string, availables: Array<{ seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null } }> }> }>, matchingFormatGroup: { availableFormats: Array<MatchingFormat> } }, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string }> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, meta?: any | null, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, creationSet?: { id: string, amount: number, additionalAmount: number, deliveryDueDate?: any | null, deliveryDueDays?: number | null, expressDueDays?: number | null, finalizedAt?: any | null, creativeFormats: Array<{ id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }> }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null }, selectedPricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }> }>, creations: Array<{ id: string, state: CreationState, createdAt: any, stateUpdatedAt: any, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, intent: string, state: DeliverableState, createdAt: any, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } }>, modificationRequests: Array<{ id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }> }>, creativeFormat: { id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null } } }> } | null, performanceReports: Array<{ id: string, lastUpdatedAt: any, periodPatterns: Array<PerformanceReportPeriodPattern>, metrics: Array<PerformanceReportMetric>, comparisonTargets: Array<PerformanceReportComparisonTarget>, dimensions: Array<PerformanceReportDimension>, adAccount: { id: string, network: PerformanceReportNetwork, accountId: string, name: string }, campaigns: Array<{ id: string, name: string }> }>, adVideos: Array<{ adVideoId: string, analyzingState: VideoAnalyzingState }> } | null };

export type UpdateProjectAssetCategoryValueMutationVariables = Exact<{
  id: Scalars['ID'];
  assetCategoryValues?: InputMaybe<DynamicSchemaValuesInput>;
}>;


export type UpdateProjectAssetCategoryValueMutation = { updateProjectAsDraft?: { id: string } | null };

export type SubmitProjectMutationVariables = Exact<{
  id: Scalars['ID'];
  code?: InputMaybe<Scalars['String']>;
  agreedWithCreativeVisibility: Scalars['Boolean'];
}>;


export type SubmitProjectMutation = { submitProject?: { id: string, versionId?: string | null, matchingFormat: MatchingFormat, originId: string, parentId?: string | null, title: string, state: ProjectState, creativeBriefValues: any, bucketId?: string | null, assetCategoryValues?: any | null, createdAt: any, submittedAt?: any | null, organization: { id: string, name: string, pointBalance?: number | null, features: { canOpenOfferWhenDisagreed: boolean }, businessRegion: { key: BusinessRegionAdRegionKey, idBusinessRegion: BusinessRegionIdBusinessRegion, timeZone: string } }, createdBy: { id: string, name: string, profileImageUrl: string }, designInspirationCase?: { id: string, name: string, url: string, thumbnailUrl?: string | null } | null, projectType: { id: string, key: string, published: boolean, version: number, title: string, description: string, thumbnailImageUrl: string, sampleVideoUrl?: string | null, expectedDeliveryPeriod: string, outputSpecification: string, regulation: string, minConceptCount: number, maxConceptCount: number, pricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }>, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string } | {}> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, meta?: any | null, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, supportingCreativeFormatNetworks: Array<{ id: string, key: CreativeFormatNetworkKey, name: string, placements: Array<{ id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }>, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }>, creativeTypes: Array<{ id: string, key: CreativeFormatCreativeTypeKey, name: string, attribute: { aspectRatio?: { id: string, availables: Array<{ aspectRatio: { width: number, height: number }, presetSize: { width: number, height: number }, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null, playbackTime?: { id: string, availables: Array<{ seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null } }> }> }>, matchingFormatGroup: { availableFormats: Array<MatchingFormat> } }, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string }> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, meta?: any | null, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, creationSet?: { id: string, amount: number, additionalAmount: number, deliveryDueDate?: any | null, deliveryDueDays?: number | null, expressDueDays?: number | null, finalizedAt?: any | null, creativeFormats: Array<{ id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }> }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null }, selectedPricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }> }>, creations: Array<{ id: string, state: CreationState, createdAt: any, stateUpdatedAt: any, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, intent: string, state: DeliverableState, createdAt: any, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } }>, modificationRequests: Array<{ id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }> }>, creativeFormat: { id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null } } }> } | null, performanceReports: Array<{ id: string, lastUpdatedAt: any, periodPatterns: Array<PerformanceReportPeriodPattern>, metrics: Array<PerformanceReportMetric>, comparisonTargets: Array<PerformanceReportComparisonTarget>, dimensions: Array<PerformanceReportDimension>, adAccount: { id: string, network: PerformanceReportNetwork, accountId: string, name: string }, campaigns: Array<{ id: string, name: string }> }>, adVideos: Array<{ adVideoId: string, analyzingState: VideoAnalyzingState }> } | null };

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['ID'];
  versionId: Scalars['ID'];
  title: Scalars['String'];
  creativeBriefValues?: InputMaybe<DynamicSchemaValuesInput>;
  assetCategoryValues?: InputMaybe<DynamicSchemaValuesInput>;
}>;


export type UpdateProjectMutation = { updateProject?: { updated: boolean, project?: { id: string, versionId?: string | null, matchingFormat: MatchingFormat, originId: string, parentId?: string | null, title: string, state: ProjectState, creativeBriefValues: any, bucketId?: string | null, assetCategoryValues?: any | null, createdAt: any, submittedAt?: any | null, organization: { id: string, name: string, pointBalance?: number | null, features: { canOpenOfferWhenDisagreed: boolean }, businessRegion: { key: BusinessRegionAdRegionKey, idBusinessRegion: BusinessRegionIdBusinessRegion, timeZone: string } }, createdBy: { id: string, name: string, profileImageUrl: string }, designInspirationCase?: { id: string, name: string, url: string, thumbnailUrl?: string | null } | null, projectType: { id: string, key: string, published: boolean, version: number, title: string, description: string, thumbnailImageUrl: string, sampleVideoUrl?: string | null, expectedDeliveryPeriod: string, outputSpecification: string, regulation: string, minConceptCount: number, maxConceptCount: number, pricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }>, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string } | {}> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, meta?: any | null, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, supportingCreativeFormatNetworks: Array<{ id: string, key: CreativeFormatNetworkKey, name: string, placements: Array<{ id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }>, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }>, creativeTypes: Array<{ id: string, key: CreativeFormatCreativeTypeKey, name: string, attribute: { aspectRatio?: { id: string, availables: Array<{ aspectRatio: { width: number, height: number }, presetSize: { width: number, height: number }, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null, playbackTime?: { id: string, availables: Array<{ seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null } }> }> }>, matchingFormatGroup: { availableFormats: Array<MatchingFormat> } }, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string }> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, meta?: any | null, label: string, description: string, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, creationSet?: { id: string, amount: number, additionalAmount: number, deliveryDueDate?: any | null, deliveryDueDays?: number | null, expressDueDays?: number | null, finalizedAt?: any | null, creativeFormats: Array<{ id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }> }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null }, selectedPricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }> }> }>, creations: Array<{ id: string, state: CreationState, createdAt: any, stateUpdatedAt: any, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, intent: string, state: DeliverableState, createdAt: any, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } }>, modificationRequests: Array<{ id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }> }>, creativeFormat: { id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null } | null } } }> } | null, performanceReports: Array<{ id: string, lastUpdatedAt: any, periodPatterns: Array<PerformanceReportPeriodPattern>, metrics: Array<PerformanceReportMetric>, comparisonTargets: Array<PerformanceReportComparisonTarget>, dimensions: Array<PerformanceReportDimension>, adAccount: { id: string, network: PerformanceReportNetwork, accountId: string, name: string }, campaigns: Array<{ id: string, name: string }> }>, adVideos: Array<{ adVideoId: string, analyzingState: VideoAnalyzingState }> } | null } | null };

export type SingleCreationSetFragment = { id: string, amount: number, deliveryDueDate?: any | null, deliveryDueDays?: number | null, expressDueDays?: number | null, creativeFormats: Array<{ id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string }, attribute: { aspectRatio?: { supportingAspectRatioId: string, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number } | null } }>, creations: Array<{ id: string, state: CreationState, createdAt: any, stateUpdatedAt: any, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, intent: string, state: DeliverableState, createdAt: any, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } }>, modificationRequests: Array<{ id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, submittedAt?: any | null, approvedAt?: any | null, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }>, deliverables: Array<{ id: string, createdAt: any, intent: string, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } | null }> }>, creativeFormat: { id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string }, attribute: { aspectRatio?: { supportingAspectRatioId: string, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number } | null } } }> };

export type GetCreationSetByIdQueryVariables = Exact<{
  creationSetId: Scalars['ID'];
}>;


export type GetCreationSetByIdQuery = { creationSet?: { id: string, amount: number, deliveryDueDate?: any | null, deliveryDueDays?: number | null, expressDueDays?: number | null, creativeFormats: Array<{ id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string }, attribute: { aspectRatio?: { supportingAspectRatioId: string, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number } | null } }>, creations: Array<{ id: string, state: CreationState, createdAt: any, stateUpdatedAt: any, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, intent: string, state: DeliverableState, createdAt: any, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } }>, modificationRequests: Array<{ id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, submittedAt?: any | null, approvedAt?: any | null, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }>, deliverables: Array<{ id: string, createdAt: any, intent: string, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } | null }> }>, creativeFormat: { id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string }, attribute: { aspectRatio?: { supportingAspectRatioId: string, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number } | null } } }> } | null };

export type ModificationRequestDeliverableForDetailFragment = { id: string, createdAt: any, intent: string, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } | null };

export type ModificationRequestItemIssueCommentForDetailFragment = { id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } };

export type ModificationRequestItemIssueForDetailFragment = { id: string, name: string, resolved: boolean, createdAt: any, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> };

export type ModificationRequestItemForDetailFragment = { id: string, bucketId?: string | null, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, createdAt: any, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null };

export type ModificationRequestForDetailFragment = { id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, submittedAt?: any | null, approvedAt?: any | null, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, bucketId?: string | null, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, createdAt: any, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }>, deliverables: Array<{ id: string, createdAt: any, intent: string, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } | null }> };

export type CreativeForCreationDetailFragment = { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } };

export type DeliverableForCraetionDetailFragment = { id: string, intent: string, state: DeliverableState, uploadedAdPlatformKeys: Array<string>, createdAt: any, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } | null };

export type CreationDetailFragment = { id: string, assignmentId: string, projectId: string, creationSetId: string, latestDeliverableUrl?: string | null, finalized: boolean, finalizedAt?: any | null, state: CreationState, proposed: boolean, submittedAt?: any | null, createdAt: any, stateUpdatedAt: any, modificationRequestExpired: boolean, modificationRequestFreeExpiredAt?: any | null, modificationRequestPoint: number, modificationRequestFreeLimit: number, isNextModificationRequestForAFee: boolean, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, intent: string, state: DeliverableState, uploadedAdPlatformKeys: Array<string>, createdAt: any, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } | null }>, modificationRequests: Array<{ id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, submittedAt?: any | null, approvedAt?: any | null, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, bucketId?: string | null, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, createdAt: any, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }>, deliverables: Array<{ id: string, createdAt: any, intent: string, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } | null }> }>, creativeFormat: { id: string, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string, basicMerchandises: Array<{ isModificationRequestable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, size: { height: number, width: number }, aspectRatio: { height: number, width: number }, requiredOption?: { amount: number, points: Array<{ key: string, point: number }> } | null } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { amount: number, points: Array<{ key: string, point: number }> } | null } | null }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }, organization: { id: string, name: string, pointBalance?: number | null, features: { canOpenOfferWhenDisagreed: boolean }, businessRegion: { key: BusinessRegionAdRegionKey, idBusinessRegion: BusinessRegionIdBusinessRegion, timeZone: string } } };

export type GetCreationByIdQueryVariables = Exact<{
  creationId: Scalars['ID'];
}>;


export type GetCreationByIdQuery = { creation?: { id: string, assignmentId: string, projectId: string, creationSetId: string, latestDeliverableUrl?: string | null, finalized: boolean, finalizedAt?: any | null, state: CreationState, proposed: boolean, submittedAt?: any | null, createdAt: any, stateUpdatedAt: any, modificationRequestExpired: boolean, modificationRequestFreeExpiredAt?: any | null, modificationRequestPoint: number, modificationRequestFreeLimit: number, isNextModificationRequestForAFee: boolean, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, intent: string, state: DeliverableState, uploadedAdPlatformKeys: Array<string>, createdAt: any, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } | null }>, modificationRequests: Array<{ id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, submittedAt?: any | null, approvedAt?: any | null, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, bucketId?: string | null, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, createdAt: any, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }>, deliverables: Array<{ id: string, createdAt: any, intent: string, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } | null }> }>, creativeFormat: { id: string, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string, basicMerchandises: Array<{ isModificationRequestable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, size: { height: number, width: number }, aspectRatio: { height: number, width: number }, requiredOption?: { amount: number, points: Array<{ key: string, point: number }> } | null } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { amount: number, points: Array<{ key: string, point: number }> } | null } | null }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }, organization: { id: string, name: string, pointBalance?: number | null, features: { canOpenOfferWhenDisagreed: boolean }, businessRegion: { key: BusinessRegionAdRegionKey, idBusinessRegion: BusinessRegionIdBusinessRegion, timeZone: string } } } | null };

export type CreateModificationRequestAsDraftMutationVariables = Exact<{
  targetDeliverableId: Scalars['ID'];
}>;


export type CreateModificationRequestAsDraftMutation = { createModificationRequestAsDraft?: { id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, submittedAt?: any | null, approvedAt?: any | null, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, bucketId?: string | null, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, createdAt: any, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }>, deliverables: Array<{ id: string, createdAt: any, intent: string, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } | null }> } | null };

export type SubmitModificationRequestMutationVariables = Exact<{
  modificationRequestId: Scalars['ID'];
  feeType?: InputMaybe<ModificationRequestFeeType>;
}>;


export type SubmitModificationRequestMutation = { submitModificationRequest?: { id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, submittedAt?: any | null, approvedAt?: any | null, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, bucketId?: string | null, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, createdAt: any, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }>, deliverables: Array<{ id: string, createdAt: any, intent: string, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } | null }> } | null };

export type CancelCreatingDraftModificationRequestMutationVariables = Exact<{
  modificationRequestId: Scalars['ID'];
}>;


export type CancelCreatingDraftModificationRequestMutation = { cancelCreatingDraftModificationRequest?: { id: string, assignmentId: string, projectId: string, creationSetId: string, latestDeliverableUrl?: string | null, finalized: boolean, finalizedAt?: any | null, state: CreationState, proposed: boolean, submittedAt?: any | null, createdAt: any, stateUpdatedAt: any, modificationRequestExpired: boolean, modificationRequestFreeExpiredAt?: any | null, modificationRequestPoint: number, modificationRequestFreeLimit: number, isNextModificationRequestForAFee: boolean, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, intent: string, state: DeliverableState, uploadedAdPlatformKeys: Array<string>, createdAt: any, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } | null }>, modificationRequests: Array<{ id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, submittedAt?: any | null, approvedAt?: any | null, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, bucketId?: string | null, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, createdAt: any, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }>, deliverables: Array<{ id: string, createdAt: any, intent: string, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } | null }> }>, creativeFormat: { id: string, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string, basicMerchandises: Array<{ isModificationRequestable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }> }, attribute: { aspectRatio?: { supportingAspectRatioId: string, size: { height: number, width: number }, aspectRatio: { height: number, width: number }, requiredOption?: { amount: number, points: Array<{ key: string, point: number }> } | null } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number, requiredOption?: { amount: number, points: Array<{ key: string, point: number }> } | null } | null }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }, organization: { id: string, name: string, pointBalance?: number | null, features: { canOpenOfferWhenDisagreed: boolean }, businessRegion: { key: BusinessRegionAdRegionKey, idBusinessRegion: BusinessRegionIdBusinessRegion, timeZone: string } } } | null };

export type CreateModificationRequestItemMutationVariables = Exact<{
  modificationRequestId: Scalars['ID'];
  body: ModificationRequestItemsInput;
}>;


export type CreateModificationRequestItemMutation = { createModificationRequestItem?: { id: string, bucketId?: string | null, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, createdAt: any, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null } | null };

export type EditModificationRequestItemMutationVariables = Exact<{
  modificationRequestItemId: Scalars['ID'];
  body: ModificationRequestItemsInput;
}>;


export type EditModificationRequestItemMutation = { editModificationRequestItem?: { id: string, bucketId?: string | null, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, createdAt: any, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null } | null };

export type DeleteModificationRequestItemMutationVariables = Exact<{
  modificationRequestItemId: Scalars['ID'];
}>;


export type DeleteModificationRequestItemMutation = { deleteModificationRequestItem?: { id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, submittedAt?: any | null, approvedAt?: any | null, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, bucketId?: string | null, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, createdAt: any, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }>, deliverables: Array<{ id: string, createdAt: any, intent: string, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } | null }> } | null };

export type AddModificationRequestItemAssetMutationVariables = Exact<{
  modificationRequestItemId: Scalars['ID'];
  assetId: Scalars['String'];
}>;


export type AddModificationRequestItemAssetMutation = { addModificationRequestItemAsset: boolean };

export type DeleteModificationRequestItemAssetsMutationVariables = Exact<{
  modificationRequestItemId: Scalars['ID'];
  assetIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type DeleteModificationRequestItemAssetsMutation = { deleteModificationRequestItemAssets: boolean };

export type CreateModificationRequestItemIssueMutationVariables = Exact<{
  modificationRequestItemId: Scalars['ID'];
  name: Scalars['String'];
  body: Scalars['String'];
  bucketId?: InputMaybe<Scalars['String']>;
  assetIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type CreateModificationRequestItemIssueMutation = { createModificationRequestItemIssue?: { id: string, name: string, resolved: boolean, createdAt: any, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null };

export type CreateModificationRequestItemIssueCommentMutationVariables = Exact<{
  issueId: Scalars['ID'];
  body: Scalars['String'];
  bucketId?: InputMaybe<Scalars['String']>;
  assetIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type CreateModificationRequestItemIssueCommentMutation = { createModificationRequestItemIssueComment?: { id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } } | null };

export type ResolveModificationRequestIssueMutationVariables = Exact<{
  issueId: Scalars['ID'];
}>;


export type ResolveModificationRequestIssueMutation = { resolveModificationRequestIssue?: any | null };

export type ReopenModificationRequestIssueMutationVariables = Exact<{
  issueId: Scalars['ID'];
}>;


export type ReopenModificationRequestIssueMutation = { reopenModificationRequestIssue?: { id: string, name: string, resolved: boolean, createdAt: any, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null };

export type ApproveModificationRequestMutationVariables = Exact<{
  modificationRequestId: Scalars['ID'];
}>;


export type ApproveModificationRequestMutation = { approveModificationRequest?: { id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, submittedAt?: any | null, approvedAt?: any | null, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, bucketId?: string | null, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, createdAt: any, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }>, deliverables: Array<{ id: string, createdAt: any, intent: string, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } | null }> } | null };

export type OrganizationDetailFragment = { id: string, name: string, pointBalance?: number | null, features: { canOpenOfferWhenDisagreed: boolean }, businessRegion: { key: BusinessRegionAdRegionKey, idBusinessRegion: BusinessRegionIdBusinessRegion, timeZone: string } };

export type GetOrganizationByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOrganizationByIdQuery = { organization?: { id: string, name: string, pointBalance?: number | null, features: { canOpenOfferWhenDisagreed: boolean }, businessRegion: { key: BusinessRegionAdRegionKey, idBusinessRegion: BusinessRegionIdBusinessRegion, timeZone: string } } | null };

export type DailySummaryPerformanceWithAllFieldsFragment = { metric: PerformanceReportMetric, period: { from: any, to: any }, basis: { values: Array<{ date: any, actualValue: { value: number, type: PerformanceValueType, currency?: Currency | null } }> }, creatives: Array<{ creativeId: string, adName: string, thumbnailImageUrl: string, values: Array<{ date: any, actualValue: { value: number, type: PerformanceValueType, currency?: Currency | null } }>, creation: { id: string, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, createdAt: any, intent: string, state: DeliverableState, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, thumbnailUrl?: string | null, mimeType: string, size: number } } }> } }> };

export type PeriodicDetailPerformanceWithAllFieldsFragment = { period: { from: any, to: any }, creatives: Array<{ creativeId: string, adName: string, thumbnailImageUrl: string, creation?: { id: string, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, createdAt: any, intent: string, state: DeliverableState, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, thumbnailUrl?: string | null, mimeType: string, size: number } } }> } | null, values: Array<{ metric: PerformanceReportMetric, actualValue?: { value: number, type: PerformanceValueType, currency?: Currency | null } | null }> }> };

export type CreativeForPeriodicImprovementPerformanceWithAllFieldsFragment = { creativeId: string, adName: string, thumbnailImageUrl: string, values: { all: Array<{ metric: PerformanceReportMetric, target: PerformanceReportComparisonTarget, targetValue?: { value: number, type: PerformanceValueType, currency?: Currency | null } | null, actualValue?: { value: number, type: PerformanceValueType, currency?: Currency | null } | null }>, staticImage: Array<{ metric: PerformanceReportMetric, target: PerformanceReportComparisonTarget, targetValue?: { value: number, type: PerformanceValueType, currency?: Currency | null } | null, actualValue?: { value: number, type: PerformanceValueType, currency?: Currency | null } | null }>, video: Array<{ metric: PerformanceReportMetric, target: PerformanceReportComparisonTarget, targetValue?: { value: number, type: PerformanceValueType, currency?: Currency | null } | null, actualValue?: { value: number, type: PerformanceValueType, currency?: Currency | null } | null }> }, creation?: { id: string, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, createdAt: any, intent: string, state: DeliverableState, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, thumbnailUrl?: string | null, mimeType: string, size: number } } }> } | null };

export type PeriodicImprovementPerformanceWithAllFieldsFragment = { period: { from: any, to: any }, creatives: Array<{ creativeId: string, adName: string, thumbnailImageUrl: string, values: { all: Array<{ metric: PerformanceReportMetric, target: PerformanceReportComparisonTarget, targetValue?: { value: number, type: PerformanceValueType, currency?: Currency | null } | null, actualValue?: { value: number, type: PerformanceValueType, currency?: Currency | null } | null }>, staticImage: Array<{ metric: PerformanceReportMetric, target: PerformanceReportComparisonTarget, targetValue?: { value: number, type: PerformanceValueType, currency?: Currency | null } | null, actualValue?: { value: number, type: PerformanceValueType, currency?: Currency | null } | null }>, video: Array<{ metric: PerformanceReportMetric, target: PerformanceReportComparisonTarget, targetValue?: { value: number, type: PerformanceValueType, currency?: Currency | null } | null, actualValue?: { value: number, type: PerformanceValueType, currency?: Currency | null } | null }> }, creation?: { id: string, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, createdAt: any, intent: string, state: DeliverableState, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, thumbnailUrl?: string | null, mimeType: string, size: number } } }> } | null }> };

export type GetDailySummaryPerformanceQueryVariables = Exact<{
  reportId: Scalars['ID'];
  request: PerformanceReportSummaryRequest;
}>;


export type GetDailySummaryPerformanceQuery = { dailySummaryPerformance?: { metric: PerformanceReportMetric, period: { from: any, to: any }, basis: { values: Array<{ date: any, actualValue: { value: number, type: PerformanceValueType, currency?: Currency | null } }> }, creatives: Array<{ creativeId: string, adName: string, thumbnailImageUrl: string, values: Array<{ date: any, actualValue: { value: number, type: PerformanceValueType, currency?: Currency | null } }>, creation: { id: string, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, createdAt: any, intent: string, state: DeliverableState, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, thumbnailUrl?: string | null, mimeType: string, size: number } } }> } }> } | null };

export type GetPeriodicDetailPerformanceQueryVariables = Exact<{
  reportId: Scalars['ID'];
  request: PerformanceReportDetailRequest;
}>;


export type GetPeriodicDetailPerformanceQuery = { periodicDetailPerformance?: { period: { from: any, to: any }, creatives: Array<{ creativeId: string, adName: string, thumbnailImageUrl: string, creation?: { id: string, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, createdAt: any, intent: string, state: DeliverableState, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, thumbnailUrl?: string | null, mimeType: string, size: number } } }> } | null, values: Array<{ metric: PerformanceReportMetric, actualValue?: { value: number, type: PerformanceValueType, currency?: Currency | null } | null }> }> } | null };

export type GetPeriodicImprovementPerformanceQueryVariables = Exact<{
  reportId: Scalars['ID'];
  request: PerformanceReportImprovementRequest;
}>;


export type GetPeriodicImprovementPerformanceQuery = { periodicImprovementPerformance?: { period: { from: any, to: any }, creatives: Array<{ creativeId: string, adName: string, thumbnailImageUrl: string, values: { all: Array<{ metric: PerformanceReportMetric, target: PerformanceReportComparisonTarget, targetValue?: { value: number, type: PerformanceValueType, currency?: Currency | null } | null, actualValue?: { value: number, type: PerformanceValueType, currency?: Currency | null } | null }>, staticImage: Array<{ metric: PerformanceReportMetric, target: PerformanceReportComparisonTarget, targetValue?: { value: number, type: PerformanceValueType, currency?: Currency | null } | null, actualValue?: { value: number, type: PerformanceValueType, currency?: Currency | null } | null }>, video: Array<{ metric: PerformanceReportMetric, target: PerformanceReportComparisonTarget, targetValue?: { value: number, type: PerformanceValueType, currency?: Currency | null } | null, actualValue?: { value: number, type: PerformanceValueType, currency?: Currency | null } | null }> }, creation?: { id: string, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, createdAt: any, intent: string, state: DeliverableState, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, thumbnailUrl?: string | null, mimeType: string, size: number } } }> } | null }> } | null };

export type GetProjectChangeQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type GetProjectChangeQuery = { projectChange?: { updatedAt: any, latestVersion: { creativeBrief: any, assetCategory?: any | null }, beforeVersion: { creativeBrief: any, assetCategory?: any | null } } | null };

export type ProjectTypeForListFragment = { id: string, key: string, title: string, description: string, thumbnailImageUrl: string, sampleVideoUrl?: string | null, expectedDeliveryPeriod: string, outputSpecification: string, regulation: string, createdAt: any, popularity: number, displayPriority: number, minimumPoint: number, supportingCreativeFormatNetworks: Array<{ id: string, key: CreativeFormatNetworkKey, name: string, placements: Array<{ id: string, key: string, name: string, creativeTypes: Array<{ id: string, key: CreativeFormatCreativeTypeKey, name: string }> }> }>, matchingFormatGroup: { availableFormats: Array<MatchingFormat> } };

export type GetProjectTypesByRegionQueryVariables = Exact<{
  language: Scalars['ID'];
  organizationId?: InputMaybe<Scalars['ID']>;
}>;


export type GetProjectTypesByRegionQuery = { projectTypes?: { edges?: Array<{ node?: { id: string, key: string, title: string, description: string, thumbnailImageUrl: string, sampleVideoUrl?: string | null, expectedDeliveryPeriod: string, outputSpecification: string, regulation: string, createdAt: any, popularity: number, displayPriority: number, minimumPoint: number, supportingCreativeFormatNetworks: Array<{ id: string, key: CreativeFormatNetworkKey, name: string, placements: Array<{ id: string, key: string, name: string, creativeTypes: Array<{ id: string, key: CreativeFormatCreativeTypeKey, name: string }> }> }>, matchingFormatGroup: { availableFormats: Array<MatchingFormat> } } | null } | null> | null } | null };

export type GetProjectType2QueryVariables = Exact<{
  key: Scalars['String'];
  language: Scalars['ID'];
}>;


export type GetProjectType2Query = { projectType?: { id: string, key: string, title: string, description: string, thumbnailImageUrl: string, sampleVideoUrl?: string | null, expectedDeliveryPeriod: string, outputSpecification: string, regulation: string, designInspirationCategories: Array<{ id: string, name: string, iconUrl: string, designInspirationCases: Array<{ id: string, name: string, description: string, url: string, thumbnailUrl?: string | null }> }>, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string }> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, supportingCreativeFormatNetworks: Array<{ id: string, key: CreativeFormatNetworkKey, name: string, placements: Array<{ id: string, key: string, name: string, pricingTables: Array<{ creativeTypeId: string, cells: Array<{ supportingPlaybackTimeLength?: string | null, supportingAspectRatioKey: string, prices: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> }> }>, creativeTypes: Array<{ id: string, key: CreativeFormatCreativeTypeKey, name: string, attribute: { aspectRatio?: { id: string, availables: Array<{ aspectRatio: { width: number, height: number }, presetSize: { width: number, height: number }, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null, playbackTime?: { id: string, availables: Array<{ seconds: number, requiredOption?: { name: string, amount: number, points: Array<{ key: string, point: number, rewardAmount: number, rewardCurrency: string }> } | null }> } | null } }> }> }> } | null };

export type IssueCommentForProjectFragment = { id: string, body: string, createdAt: any, updatedAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } };

export type IssueForProjectFragment = { id: string, name: string, comments: Array<{ id: string, body: string, createdAt: any, updatedAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> };

export type CreativeBriefDefinitionForProjectFragment = { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string }> }> };

export type AssetCategoryDefinitionForProjectFragment = { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> };

export type CreativeFormatForShowFragment = { id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }> }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number }> }, selectedPricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null }>, attribute: { aspectRatio?: { supportingAspectRatioId: string, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number } | null } };

export type CreationForShowFragment = { id: string, latestDeliverableUrl?: string | null, latestDeliverableSubmittedAt?: any | null, modificationRequestExpired: boolean, assignmentId: string, state: CreationState, proposed: boolean, createdAt: any, stateUpdatedAt: any, submittedAt?: any | null, finalized: boolean, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, uploadedAdPlatformKeys: Array<string>, intent: string, state: DeliverableState, createdAt: any, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { file: { url?: string | null } } | null }>, modificationRequests: Array<{ id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, submittedAt?: any | null, approvedAt?: any | null, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }>, deliverables: Array<{ id: string, createdAt: any, intent: string, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } | null }> }>, creativeFormat: { id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string }, attribute: { aspectRatio?: { supportingAspectRatioId: string, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number } | null } } };

export type CreationSetForShowFragment = { id: string, offerId?: string | null, amount: number, additionalAmount: number, deliveryDueDate?: any | null, deliveryDueDays?: number | null, expressDueDays?: number | null, finalizedAt?: any | null, creativeFormats: Array<{ id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }> }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number }> }, selectedPricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null }>, attribute: { aspectRatio?: { supportingAspectRatioId: string, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number } | null } }>, creations: Array<{ id: string, latestDeliverableUrl?: string | null, latestDeliverableSubmittedAt?: any | null, modificationRequestExpired: boolean, assignmentId: string, state: CreationState, proposed: boolean, createdAt: any, stateUpdatedAt: any, submittedAt?: any | null, finalized: boolean, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, uploadedAdPlatformKeys: Array<string>, intent: string, state: DeliverableState, createdAt: any, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { file: { url?: string | null } } | null }>, modificationRequests: Array<{ id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, submittedAt?: any | null, approvedAt?: any | null, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }>, deliverables: Array<{ id: string, createdAt: any, intent: string, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } | null }> }>, creativeFormat: { id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string }, attribute: { aspectRatio?: { supportingAspectRatioId: string, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number } | null } } }> };

export type ProjectDetailsForEditFragment = { id: string, versionId?: string | null, matchingFormat: MatchingFormat, originId: string, parentId?: string | null, title: string, state: ProjectState, finalized: boolean, deliveryDueDate?: any | null, creativeBriefValues: any, bucketId?: string | null, assetCategoryValues?: any | null, createdAt: any, submittedAt?: any | null, organization: { id: string, name: string, pointBalance?: number | null, features: { canOpenOfferWhenDisagreed: boolean }, businessRegion: { key: BusinessRegionAdRegionKey, idBusinessRegion: BusinessRegionIdBusinessRegion, timeZone: string } }, createdBy: { id: string, name: string, profileImageUrl: string }, designInspirationCase?: { id: string, name: string, url: string, thumbnailUrl?: string | null } | null, projectType: { id: string, published: boolean, version: number, title: string, description: string, thumbnailImageUrl: string, sampleVideoUrl?: string | null, expectedDeliveryPeriod: string, outputSpecification: string, regulation: string, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string }> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, supportingCreativeFormatNetworks: Array<{ id: string, key: CreativeFormatNetworkKey, name: string, placements: Array<{ id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }>, creativeTypes: Array<{ id: string, key: CreativeFormatCreativeTypeKey, name: string, attribute: { aspectRatio?: { id: string, availables: Array<{ aspectRatio: { width: number, height: number }, presetSize: { width: number, height: number } }> } | null, playbackTime?: { id: string, availables: Array<{ seconds: number }> } | null } }> }> }> }, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string }> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, creationSet?: { id: string, offerId?: string | null, amount: number, additionalAmount: number, deliveryDueDate?: any | null, deliveryDueDays?: number | null, expressDueDays?: number | null, finalizedAt?: any | null, creativeFormats: Array<{ id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }> }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number }> }, selectedPricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null }>, attribute: { aspectRatio?: { supportingAspectRatioId: string, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number } | null } }>, creations: Array<{ id: string, latestDeliverableUrl?: string | null, latestDeliverableSubmittedAt?: any | null, modificationRequestExpired: boolean, assignmentId: string, state: CreationState, proposed: boolean, createdAt: any, stateUpdatedAt: any, submittedAt?: any | null, finalized: boolean, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, uploadedAdPlatformKeys: Array<string>, intent: string, state: DeliverableState, createdAt: any, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { file: { url?: string | null } } | null }>, modificationRequests: Array<{ id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, submittedAt?: any | null, approvedAt?: any | null, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }>, deliverables: Array<{ id: string, createdAt: any, intent: string, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } | null }> }>, creativeFormat: { id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string }, attribute: { aspectRatio?: { supportingAspectRatioId: string, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number } | null } } }> } | null, performanceReports: Array<{ id: string, lastUpdatedAt: any, periodPatterns: Array<PerformanceReportPeriodPattern>, metrics: Array<PerformanceReportMetric>, comparisonTargets: Array<PerformanceReportComparisonTarget>, dimensions: Array<PerformanceReportDimension>, adAccount: { id: string, network: PerformanceReportNetwork, accountId: string, name: string }, campaigns: Array<{ id: string, name: string }> }>, adVideos: Array<{ adVideoId: string, analyzingState: VideoAnalyzingState }>, issue?: { id: string, name: string, comments: Array<{ id: string, body: string, createdAt: any, updatedAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null };

export type ProjectDetailsForShowFragment = { id: string, hasChanges: boolean, versionId?: string | null, matchingFormat: MatchingFormat, originId: string, parentId?: string | null, title: string, state: ProjectState, finalized: boolean, deliveryDueDate?: any | null, creativeBriefValues: any, bucketId?: string | null, assetCategoryValues?: any | null, createdAt: any, submittedAt?: any | null, organization: { id: string, name: string, pointBalance?: number | null, features: { canOpenOfferWhenDisagreed: boolean }, businessRegion: { key: BusinessRegionAdRegionKey, idBusinessRegion: BusinessRegionIdBusinessRegion, timeZone: string } }, createdBy: { id: string, name: string, profileImageUrl: string }, designInspirationCase?: { id: string, name: string, url: string, thumbnailUrl?: string | null } | null, projectType: { id: string, published: boolean, version: number, title: string, description: string, thumbnailImageUrl: string, sampleVideoUrl?: string | null, expectedDeliveryPeriod: string, outputSpecification: string, regulation: string }, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string }> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, creationSet?: { id: string, offerId?: string | null, amount: number, additionalAmount: number, deliveryDueDate?: any | null, deliveryDueDays?: number | null, expressDueDays?: number | null, finalizedAt?: any | null, creativeFormats: Array<{ id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }> }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number }> }, selectedPricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null }>, attribute: { aspectRatio?: { supportingAspectRatioId: string, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number } | null } }>, creations: Array<{ id: string, latestDeliverableUrl?: string | null, latestDeliverableSubmittedAt?: any | null, modificationRequestExpired: boolean, assignmentId: string, state: CreationState, proposed: boolean, createdAt: any, stateUpdatedAt: any, submittedAt?: any | null, finalized: boolean, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, uploadedAdPlatformKeys: Array<string>, intent: string, state: DeliverableState, createdAt: any, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { file: { url?: string | null } } | null }>, modificationRequests: Array<{ id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, submittedAt?: any | null, approvedAt?: any | null, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }>, deliverables: Array<{ id: string, createdAt: any, intent: string, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } | null }> }>, creativeFormat: { id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string }, attribute: { aspectRatio?: { supportingAspectRatioId: string, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number } | null } } }> } | null, performanceReports: Array<{ id: string, lastUpdatedAt: any, periodPatterns: Array<PerformanceReportPeriodPattern>, metrics: Array<PerformanceReportMetric>, comparisonTargets: Array<PerformanceReportComparisonTarget>, dimensions: Array<PerformanceReportDimension>, adAccount: { id: string, network: PerformanceReportNetwork, accountId: string, name: string }, campaigns: Array<{ id: string, name: string }> }>, adVideos: Array<{ adVideoId: string, analyzingState: VideoAnalyzingState }>, issue?: { id: string, name: string, comments: Array<{ id: string, body: string, createdAt: any, updatedAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null };

export type ProjectForAllOfOrganizationFragment = { id: string, title: string, state: ProjectState, finalized: boolean, deliveryDueDate?: any | null, matchingFormat: MatchingFormat, createdAt: any, updatedAt: any, submittedAt?: any | null, projectType: { id: string, title: string }, createdBy: { id: string, name: string, profileImageUrl: string }, progressSummary: { orderCount: number, approvedCount: number, modificationRequestCount: number, modificationRequestFeedbackCount: number } };

export type GetByIdForEditQueryVariables = Exact<{
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['ID']>;
}>;


export type GetByIdForEditQuery = { project?: { id: string, versionId?: string | null, matchingFormat: MatchingFormat, originId: string, parentId?: string | null, title: string, state: ProjectState, finalized: boolean, deliveryDueDate?: any | null, creativeBriefValues: any, bucketId?: string | null, assetCategoryValues?: any | null, createdAt: any, submittedAt?: any | null, organization: { id: string, name: string, pointBalance?: number | null, features: { canOpenOfferWhenDisagreed: boolean }, businessRegion: { key: BusinessRegionAdRegionKey, idBusinessRegion: BusinessRegionIdBusinessRegion, timeZone: string } }, createdBy: { id: string, name: string, profileImageUrl: string }, designInspirationCase?: { id: string, name: string, url: string, thumbnailUrl?: string | null } | null, projectType: { id: string, published: boolean, version: number, title: string, description: string, thumbnailImageUrl: string, sampleVideoUrl?: string | null, expectedDeliveryPeriod: string, outputSpecification: string, regulation: string, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string }> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, supportingCreativeFormatNetworks: Array<{ id: string, key: CreativeFormatNetworkKey, name: string, placements: Array<{ id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }>, creativeTypes: Array<{ id: string, key: CreativeFormatCreativeTypeKey, name: string, attribute: { aspectRatio?: { id: string, availables: Array<{ aspectRatio: { width: number, height: number }, presetSize: { width: number, height: number } }> } | null, playbackTime?: { id: string, availables: Array<{ seconds: number }> } | null } }> }> }> }, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string }> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, creationSet?: { id: string, offerId?: string | null, amount: number, additionalAmount: number, deliveryDueDate?: any | null, deliveryDueDays?: number | null, expressDueDays?: number | null, finalizedAt?: any | null, creativeFormats: Array<{ id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }> }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number }> }, selectedPricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null }>, attribute: { aspectRatio?: { supportingAspectRatioId: string, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number } | null } }>, creations: Array<{ id: string, latestDeliverableUrl?: string | null, latestDeliverableSubmittedAt?: any | null, modificationRequestExpired: boolean, assignmentId: string, state: CreationState, proposed: boolean, createdAt: any, stateUpdatedAt: any, submittedAt?: any | null, finalized: boolean, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, uploadedAdPlatformKeys: Array<string>, intent: string, state: DeliverableState, createdAt: any, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { file: { url?: string | null } } | null }>, modificationRequests: Array<{ id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, submittedAt?: any | null, approvedAt?: any | null, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }>, deliverables: Array<{ id: string, createdAt: any, intent: string, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } | null }> }>, creativeFormat: { id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string }, attribute: { aspectRatio?: { supportingAspectRatioId: string, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number } | null } } }> } | null, performanceReports: Array<{ id: string, lastUpdatedAt: any, periodPatterns: Array<PerformanceReportPeriodPattern>, metrics: Array<PerformanceReportMetric>, comparisonTargets: Array<PerformanceReportComparisonTarget>, dimensions: Array<PerformanceReportDimension>, adAccount: { id: string, network: PerformanceReportNetwork, accountId: string, name: string }, campaigns: Array<{ id: string, name: string }> }>, adVideos: Array<{ adVideoId: string, analyzingState: VideoAnalyzingState }>, issue?: { id: string, name: string, comments: Array<{ id: string, body: string, createdAt: any, updatedAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null } | null };

export type GetProjectByIdForShowPageQueryVariables = Exact<{
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['ID']>;
}>;


export type GetProjectByIdForShowPageQuery = { project?: { id: string, hasChanges: boolean, versionId?: string | null, matchingFormat: MatchingFormat, originId: string, parentId?: string | null, title: string, state: ProjectState, finalized: boolean, deliveryDueDate?: any | null, creativeBriefValues: any, bucketId?: string | null, assetCategoryValues?: any | null, createdAt: any, submittedAt?: any | null, organization: { id: string, name: string, pointBalance?: number | null, features: { canOpenOfferWhenDisagreed: boolean }, businessRegion: { key: BusinessRegionAdRegionKey, idBusinessRegion: BusinessRegionIdBusinessRegion, timeZone: string } }, createdBy: { id: string, name: string, profileImageUrl: string }, designInspirationCase?: { id: string, name: string, url: string, thumbnailUrl?: string | null } | null, projectType: { id: string, published: boolean, version: number, title: string, description: string, thumbnailImageUrl: string, sampleVideoUrl?: string | null, expectedDeliveryPeriod: string, outputSpecification: string, regulation: string }, creativeBriefDefinition: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, value: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, isRequiredToSelectAnything: boolean, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, checkedControlLabel: string, uncheckedControlLabel: string }> }> }, assetCategoryDefinition?: { id: string, sections: Array<{ id: string, label: string, description: string, meta?: any | null, fields: Array<{ key: string, type: DynamicSchemaDefinitionFieldType, label: string } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, helperText: string, choices: Array<{ key: string, label: string }> } | { key: string, type: DynamicSchemaDefinitionFieldType, label: string, placeholder: string, helperText: string, isRequired: boolean } | {}> }> } | null, creationSet?: { id: string, offerId?: string | null, amount: number, additionalAmount: number, deliveryDueDate?: any | null, deliveryDueDays?: number | null, expressDueDays?: number | null, finalizedAt?: any | null, creativeFormats: Array<{ id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string, basicMerchandises: Array<{ isResizable: boolean, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string } }> }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string, requiredPoints: Array<{ key: string, point: number }> }, selectedPricingMerchandiseOptions: Array<{ id: string, name: string, helpUrlForDirector?: string | null }>, attribute: { aspectRatio?: { supportingAspectRatioId: string, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number } | null } }>, creations: Array<{ id: string, latestDeliverableUrl?: string | null, latestDeliverableSubmittedAt?: any | null, modificationRequestExpired: boolean, assignmentId: string, state: CreationState, proposed: boolean, createdAt: any, stateUpdatedAt: any, submittedAt?: any | null, finalized: boolean, assignee?: { id: string, name: string, profileImageUrl: string } | null, deliverables: Array<{ id: string, uploadedAdPlatformKeys: Array<string>, intent: string, state: DeliverableState, createdAt: any, stateUpdatedAt: any, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { file: { url?: string | null } } | null }>, modificationRequests: Array<{ id: string, bucketId?: string | null, state: RequestState, targetDeliverableId: string, feeType: ModificationRequestFeeType, createdAt: any, submittedAt?: any | null, approvedAt?: any | null, deliveryDue?: any | null, feedback?: { id: string, body: string, createdAt: any } | null, sender: { id: string, name: string, profileImageUrl: string }, items: Array<{ id: string, type?: number | null, typeName?: string | null, assetIds: Array<string>, body: string, metadata: any, sender: { id: string, name: string, profileImageUrl: string }, issue?: { id: string, name: string, resolved: boolean, comments: Array<{ id: string, body: string, assetIds: Array<string>, createdAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null }>, deliverables: Array<{ id: string, createdAt: any, intent: string, creative: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } }, attachedThumbnail?: { id: string, file: { id: string, originalFileName: string, url?: string | null, mimeType: string, size: number } } | null }> }>, creativeFormat: { id: string, resizeBaseId?: string | null, network: { id: string, key: CreativeFormatNetworkKey, name: string }, placement: { id: string, key: string, name: string }, creativeType: { id: string, key: CreativeFormatCreativeTypeKey, name: string }, attribute: { aspectRatio?: { supportingAspectRatioId: string, aspectRatio: { width: number, height: number }, size: { width: number, height: number } } | null, playbackTime?: { supportingPlaybackTimeId: string, seconds: number } | null } } }> } | null, performanceReports: Array<{ id: string, lastUpdatedAt: any, periodPatterns: Array<PerformanceReportPeriodPattern>, metrics: Array<PerformanceReportMetric>, comparisonTargets: Array<PerformanceReportComparisonTarget>, dimensions: Array<PerformanceReportDimension>, adAccount: { id: string, network: PerformanceReportNetwork, accountId: string, name: string }, campaigns: Array<{ id: string, name: string }> }>, adVideos: Array<{ adVideoId: string, analyzingState: VideoAnalyzingState }>, issue?: { id: string, name: string, comments: Array<{ id: string, body: string, createdAt: any, updatedAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null } | null };

export type GetProjectsByOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  order?: InputMaybe<ProjectOrder>;
  filter?: InputMaybe<ProjectFilter>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type GetProjectsByOrganizationQuery = { projectsByOrganization?: { nodes?: Array<{ id: string, title: string, state: ProjectState, finalized: boolean, deliveryDueDate?: any | null, matchingFormat: MatchingFormat, createdAt: any, updatedAt: any, submittedAt?: any | null, projectType: { id: string, title: string }, createdBy: { id: string, name: string, profileImageUrl: string }, progressSummary: { orderCount: number, approvedCount: number, modificationRequestCount: number, modificationRequestFeedbackCount: number } } | null> | null, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type CreateProjectAsDraft2MutationVariables = Exact<{
  title: Scalars['String'];
  matchingFormat: MatchingFormat;
  organizationId: Scalars['ID'];
  projectTypeId: Scalars['ID'];
  creationSet?: InputMaybe<CreationSetInput>;
  creativeBriefDefinitionId: Scalars['ID'];
  creativeBriefValues?: InputMaybe<DynamicSchemaValuesInput>;
  assetCategoryDefinitionId: Scalars['ID'];
  assetCategoryValues?: InputMaybe<DynamicSchemaValuesInput>;
  parentProjectId?: InputMaybe<Scalars['ID']>;
  designInspirationCaseId?: InputMaybe<Scalars['ID']>;
}>;


export type CreateProjectAsDraft2Mutation = { createProjectAsDraft?: { id: string } | null };

export type DeleteDraftProjectMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteDraftProjectMutation = { deleteProject?: { success?: boolean | null } | null };

export type CreateProjectIssueMutationVariables = Exact<{
  projectId: Scalars['ID'];
  name: Scalars['String'];
  body: Scalars['String'];
}>;


export type CreateProjectIssueMutation = { createProjectIssue?: { id: string, name: string, comments: Array<{ id: string, body: string, createdAt: any, updatedAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null };

export type CreateProjectIssueCommentMutationVariables = Exact<{
  issueId: Scalars['ID'];
  body: Scalars['String'];
}>;


export type CreateProjectIssueCommentMutation = { createProjectIssueComment?: { id: string, body: string, createdAt: any, updatedAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } } | null };

export type UpdateProjectIssueCommentMutationVariables = Exact<{
  commentId: Scalars['ID'];
  body: Scalars['String'];
}>;


export type UpdateProjectIssueCommentMutation = { updateProjectIssueComment?: { id: string, body: string, createdAt: any, updatedAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } } | null };

export type DeleteProjectIssueCommentMutationVariables = Exact<{
  commentId: Scalars['ID'];
}>;


export type DeleteProjectIssueCommentMutation = { deleteProjectIssueComment?: { id: string, name: string, comments: Array<{ id: string, body: string, createdAt: any, updatedAt: any, user: { id: string, name: string, email?: string | null, profileImageUrl: string } | { id: string, name: string, email?: string | null, profileImageUrl: string } }> } | null };

export type SingleDirectorUserFragment = { id: string, name: string, email?: string | null, profileImageUrl: string };

export type DirectorUserQueryVariables = Exact<{ [key: string]: never; }>;


export type DirectorUserQuery = { me?: { id: string, name: string, email?: string | null, profileImageUrl: string } | {} | null };

export const CreationSetWithPricingFragmentDoc = gql`
    fragment CreationSetWithPricing on CreationSet {
  id
  creativeFormats {
    id
    creativeType {
      id
      key
      name
      requiredPoints {
        key
        point
        rewardAmount
        rewardCurrency
      }
    }
    attribute {
      aspectRatio {
        requiredOption {
          name
          amount
          points {
            key
            point
            rewardAmount
            rewardCurrency
          }
        }
        size {
          width
          height
        }
      }
      playbackTime {
        supportingPlaybackTimeId
        requiredOption {
          name
          amount
          points {
            key
            point
            rewardAmount
            rewardCurrency
          }
        }
        seconds
      }
    }
    selectedPricingMerchandiseOptions {
      pricingTables {
        creativeTypeId
        cells {
          supportingPlaybackTimeLength
          supportingAspectRatioKey
          prices {
            key
            point
            rewardAmount
            rewardCurrency
          }
        }
      }
    }
    resizeBaseId
  }
  expressDueDays
}
    `;
export const DesignInspirationCategoryDetailFragmentDoc = gql`
    fragment DesignInspirationCategoryDetail on DesignInspirationCategory {
  id
  name
  iconUrl
  designInspirationCases {
    id
    name
    description
    url
    thumbnailUrl
  }
}
    `;
export const CreativeBriefDefinitionForProjectFragmentDoc = gql`
    fragment CreativeBriefDefinitionForProject on DynamicSchemaDefinition {
  id
  sections {
    id
    label
    description
    meta
    fields {
      ... on DynamicSchemaDefinitionSelectOne {
        key
        type
        label
        choices {
          key
          label
        }
        helperText
      }
      ... on DynamicSchemaDefinitionSelectMultiple {
        key
        type
        label
        choices {
          key
          label
        }
        helperText
        isRequiredToSelectAnything
      }
      ... on DynamicSchemaDefinitionToggle {
        key
        type
        label
        checkedControlLabel
        uncheckedControlLabel
      }
      ... on DynamicSchemaDefinitionSingleLineText {
        key
        type
        label
        placeholder
        helperText
        isRequired
      }
      ... on DynamicSchemaDefinitionMultiLineText {
        key
        type
        label
        placeholder
        helperText
        isRequired
      }
      ... on DynamicSchemaDefinitionPositiveInteger {
        key
        type
        label
        helperText
        isRequired
      }
      ... on DynamicSchemaDefinitionFiles {
        key
        type
        label
        helperText
      }
      ... on DynamicSchemaDefinitionFixed {
        key
        type
        label
        value
      }
      ... on DynamicSchemaDefinitionFileIds {
        key
        type
        label
      }
    }
  }
}
    `;
export const AssetCategoryDefinitionForProjectFragmentDoc = gql`
    fragment AssetCategoryDefinitionForProject on DynamicSchemaDefinition {
  id
  sections {
    id
    label
    description
    meta
    fields {
      ... on DynamicSchemaDefinitionSelectOne {
        key
        type
        label
        choices {
          key
          label
        }
        helperText
      }
      ... on DynamicSchemaDefinitionSingleLineText {
        key
        type
        label
        placeholder
        helperText
        isRequired
      }
      ... on DynamicSchemaDefinitionMultiLineText {
        key
        type
        label
        placeholder
        helperText
        isRequired
      }
      ... on DynamicSchemaDefinitionFileIds {
        key
        type
        label
      }
    }
  }
}
    `;
export const ProjectTypeDetailFragmentDoc = gql`
    fragment ProjectTypeDetail on ProjectType {
  id
  key
  title
  description
  thumbnailImageUrl
  sampleVideoUrl
  expectedDeliveryPeriod
  outputSpecification
  regulation
  designInspirationCategories {
    ...DesignInspirationCategoryDetail
  }
  creativeBriefDefinition {
    ...CreativeBriefDefinitionForProject
  }
  assetCategoryDefinition {
    ...AssetCategoryDefinitionForProject
  }
  supportingCreativeFormatNetworks {
    id
    key
    name
    placements {
      id
      key
      name
      pricingTables {
        creativeTypeId
        cells {
          supportingPlaybackTimeLength
          supportingAspectRatioKey
          prices {
            key
            point
            rewardAmount
            rewardCurrency
          }
        }
      }
      creativeTypes {
        id
        key
        name
        attribute {
          aspectRatio {
            id
            availables {
              aspectRatio {
                width
                height
              }
              presetSize {
                width
                height
              }
              requiredOption {
                name
                amount
                points {
                  key
                  point
                  rewardAmount
                  rewardCurrency
                }
              }
            }
          }
          playbackTime {
            id
            availables {
              requiredOption {
                name
                amount
                points {
                  key
                  point
                  rewardAmount
                  rewardCurrency
                }
              }
              seconds
            }
          }
        }
      }
    }
  }
}
    ${DesignInspirationCategoryDetailFragmentDoc}
${CreativeBriefDefinitionForProjectFragmentDoc}
${AssetCategoryDefinitionForProjectFragmentDoc}`;
export const ProjectDetailsForOptionScreenFragmentDoc = gql`
    fragment ProjectDetailsForOptionScreen on Project {
  id
  versionId
  matchingFormat
  organization {
    id
    name
    pointBalance
    features {
      canOpenOfferWhenDisagreed
    }
    businessRegion {
      key
      idBusinessRegion
      timeZone
    }
  }
  originId
  parentId
  title
  state
  bucketId
  creationSet {
    id
    creativeFormats {
      id
      network {
        id
        key
        name
      }
      placement {
        id
        key
        name
        basicMerchandises {
          isResizable
          creativeType {
            id
            key
            name
          }
        }
      }
      creativeType {
        id
        key
        name
        requiredPoints {
          key
          point
          rewardAmount
          rewardCurrency
        }
      }
      attribute {
        aspectRatio {
          supportingAspectRatioId
          requiredOption {
            name
            amount
            points {
              key
              point
              rewardAmount
              rewardCurrency
            }
          }
          aspectRatio {
            width
            height
          }
          size {
            width
            height
          }
        }
        playbackTime {
          supportingPlaybackTimeId
          requiredOption {
            name
            amount
            points {
              key
              point
              rewardAmount
              rewardCurrency
            }
          }
          seconds
        }
      }
      selectedPricingMerchandiseOptions {
        id
        name
        helpUrlForDirector
        pricingTables {
          creativeTypeId
          cells {
            supportingPlaybackTimeLength
            supportingAspectRatioKey
            prices {
              key
              point
              rewardAmount
              rewardCurrency
            }
          }
        }
      }
      resizeBaseId
    }
    creations {
      id
      assignee {
        id
        name
        profileImageUrl
      }
      deliverables {
        id
        creative {
          id
          file {
            id
            originalFileName
            url
            mimeType
            size
          }
        }
        intent
        state
        createdAt
        stateUpdatedAt
      }
      modificationRequests {
        id
        bucketId
        state
        targetDeliverableId
        feeType
        createdAt
        deliveryDue
        feedback {
          id
          body
          createdAt
        }
        sender {
          id
          name
          profileImageUrl
        }
        items {
          id
          type
          typeName
          assetIds
          body
          metadata
          sender {
            id
            name
            profileImageUrl
          }
          issue {
            id
            name
            resolved
            comments {
              id
              body
              assetIds
              createdAt
              user {
                ... on UserDirector {
                  id
                  name
                  email
                  profileImageUrl
                }
                ... on UserOptimizer {
                  id
                  name
                  email
                  profileImageUrl
                }
              }
            }
          }
        }
      }
      creativeFormat {
        id
        network {
          id
          key
          name
        }
        placement {
          id
          key
          name
        }
        creativeType {
          id
          key
          name
          requiredPoints {
            key
            point
            rewardAmount
            rewardCurrency
          }
        }
        attribute {
          aspectRatio {
            supportingAspectRatioId
            requiredOption {
              name
              amount
              points {
                key
                point
                rewardAmount
                rewardCurrency
              }
            }
            aspectRatio {
              width
              height
            }
            size {
              width
              height
            }
          }
          playbackTime {
            supportingPlaybackTimeId
            requiredOption {
              name
              amount
              points {
                key
                point
                rewardAmount
                rewardCurrency
              }
            }
            seconds
          }
        }
        resizeBaseId
      }
      state
      createdAt
      stateUpdatedAt
    }
    amount
    additionalAmount
    deliveryDueDate
    deliveryDueDays
    expressDueDays
    finalizedAt
  }
  projectType {
    id
    key
    published
    version
    title
    description
    thumbnailImageUrl
    sampleVideoUrl
    expectedDeliveryPeriod
    outputSpecification
    regulation
    minConceptCount
    maxConceptCount
    pricingMerchandiseOptions {
      id
      name
      helpUrlForDirector
      pricingTables {
        creativeTypeId
        cells {
          supportingPlaybackTimeLength
          supportingAspectRatioKey
          prices {
            key
            point
            rewardAmount
            rewardCurrency
          }
        }
      }
    }
    creativeBriefDefinition {
      id
      sections {
        id
        label
        description
        fields {
          ... on DynamicSchemaDefinitionSelectOne {
            key
            type
            label
            choices {
              key
              label
            }
            helperText
          }
          ... on DynamicSchemaDefinitionSelectMultiple {
            key
            type
            label
            choices {
              key
              label
            }
            helperText
            isRequiredToSelectAnything
          }
          ... on DynamicSchemaDefinitionToggle {
            key
            type
            label
            checkedControlLabel
            uncheckedControlLabel
          }
          ... on DynamicSchemaDefinitionSingleLineText {
            key
            type
            label
            placeholder
            helperText
            isRequired
          }
          ... on DynamicSchemaDefinitionMultiLineText {
            key
            type
            label
            placeholder
            helperText
            isRequired
          }
          ... on DynamicSchemaDefinitionPositiveInteger {
            key
            type
            label
            helperText
            isRequired
          }
          ... on DynamicSchemaDefinitionFiles {
            key
            type
            label
            helperText
          }
          ... on DynamicSchemaDefinitionFixed {
            key
            type
            label
            value
          }
        }
      }
    }
    assetCategoryDefinition {
      id
      sections {
        id
        meta
        label
        description
        fields {
          ... on DynamicSchemaDefinitionSelectOne {
            key
            type
            label
            choices {
              key
              label
            }
            helperText
          }
          ... on DynamicSchemaDefinitionSingleLineText {
            key
            type
            label
            placeholder
            helperText
            isRequired
          }
          ... on DynamicSchemaDefinitionMultiLineText {
            key
            type
            label
            placeholder
            helperText
            isRequired
          }
          ... on DynamicSchemaDefinitionFileIds {
            key
            type
            label
          }
        }
      }
    }
    supportingCreativeFormatNetworks {
      id
      key
      name
      placements {
        id
        key
        name
        basicMerchandises {
          isResizable
          creativeType {
            id
            key
            name
          }
        }
        pricingTables {
          creativeTypeId
          cells {
            supportingPlaybackTimeLength
            supportingAspectRatioKey
            prices {
              key
              point
              rewardAmount
              rewardCurrency
            }
          }
        }
        creativeTypes {
          id
          key
          name
          attribute {
            aspectRatio {
              id
              availables {
                aspectRatio {
                  width
                  height
                }
                presetSize {
                  width
                  height
                }
                requiredOption {
                  name
                  amount
                  points {
                    key
                    point
                    rewardAmount
                    rewardCurrency
                  }
                }
              }
            }
            playbackTime {
              id
              availables {
                requiredOption {
                  name
                  amount
                  points {
                    key
                    point
                    rewardAmount
                    rewardCurrency
                  }
                }
                seconds
              }
            }
          }
        }
      }
    }
    matchingFormatGroup {
      availableFormats
    }
  }
  createdAt
  submittedAt
}
    `;
export const ProjectDetailsFragmentDoc = gql`
    fragment ProjectDetails on Project {
  id
  versionId
  matchingFormat
  organization {
    id
    name
    pointBalance
    features {
      canOpenOfferWhenDisagreed
    }
    businessRegion {
      key
      idBusinessRegion
      timeZone
    }
  }
  originId
  parentId
  title
  state
  createdBy {
    id
    name
    profileImageUrl
  }
  designInspirationCase {
    id
    name
    url
    thumbnailUrl
  }
  projectType {
    id
    key
    published
    version
    title
    description
    thumbnailImageUrl
    sampleVideoUrl
    expectedDeliveryPeriod
    outputSpecification
    regulation
    minConceptCount
    maxConceptCount
    pricingMerchandiseOptions {
      id
      name
      helpUrlForDirector
      pricingTables {
        creativeTypeId
        cells {
          supportingPlaybackTimeLength
          supportingAspectRatioKey
          prices {
            key
            point
            rewardAmount
            rewardCurrency
          }
        }
      }
    }
    creativeBriefDefinition {
      id
      sections {
        id
        label
        description
        fields {
          ... on DynamicSchemaDefinitionSelectOne {
            key
            type
            label
            choices {
              key
              label
            }
            helperText
          }
          ... on DynamicSchemaDefinitionSelectMultiple {
            key
            type
            label
            choices {
              key
              label
            }
            helperText
            isRequiredToSelectAnything
          }
          ... on DynamicSchemaDefinitionToggle {
            key
            type
            label
            checkedControlLabel
            uncheckedControlLabel
          }
          ... on DynamicSchemaDefinitionSingleLineText {
            key
            type
            label
            placeholder
            helperText
            isRequired
          }
          ... on DynamicSchemaDefinitionMultiLineText {
            key
            type
            label
            placeholder
            helperText
            isRequired
          }
          ... on DynamicSchemaDefinitionPositiveInteger {
            key
            type
            label
            helperText
            isRequired
          }
          ... on DynamicSchemaDefinitionFiles {
            key
            type
            label
            helperText
          }
          ... on DynamicSchemaDefinitionFixed {
            key
            type
            label
            value
          }
        }
      }
    }
    assetCategoryDefinition {
      id
      sections {
        id
        meta
        label
        description
        fields {
          ... on DynamicSchemaDefinitionSelectOne {
            key
            type
            label
            choices {
              key
              label
            }
            helperText
          }
          ... on DynamicSchemaDefinitionSingleLineText {
            key
            type
            label
            placeholder
            helperText
            isRequired
          }
          ... on DynamicSchemaDefinitionMultiLineText {
            key
            type
            label
            placeholder
            helperText
            isRequired
          }
          ... on DynamicSchemaDefinitionFileIds {
            key
            type
            label
          }
        }
      }
    }
    supportingCreativeFormatNetworks {
      id
      key
      name
      placements {
        id
        key
        name
        basicMerchandises {
          isResizable
          creativeType {
            id
            key
            name
          }
        }
        pricingTables {
          creativeTypeId
          cells {
            supportingPlaybackTimeLength
            supportingAspectRatioKey
            prices {
              key
              point
              rewardAmount
              rewardCurrency
            }
          }
        }
        creativeTypes {
          id
          key
          name
          attribute {
            aspectRatio {
              id
              availables {
                aspectRatio {
                  width
                  height
                }
                presetSize {
                  width
                  height
                }
                requiredOption {
                  name
                  amount
                  points {
                    key
                    point
                    rewardAmount
                    rewardCurrency
                  }
                }
              }
            }
            playbackTime {
              id
              availables {
                requiredOption {
                  name
                  amount
                  points {
                    key
                    point
                    rewardAmount
                    rewardCurrency
                  }
                }
                seconds
              }
            }
          }
        }
      }
    }
    matchingFormatGroup {
      availableFormats
    }
  }
  creativeBriefDefinition {
    id
    sections {
      id
      label
      description
      meta
      fields {
        ... on DynamicSchemaDefinitionSelectOne {
          key
          type
          label
          choices {
            key
            label
          }
          helperText
        }
        ... on DynamicSchemaDefinitionSelectMultiple {
          key
          type
          label
          choices {
            key
            label
          }
          helperText
          isRequiredToSelectAnything
        }
        ... on DynamicSchemaDefinitionToggle {
          key
          type
          label
          checkedControlLabel
          uncheckedControlLabel
        }
        ... on DynamicSchemaDefinitionSingleLineText {
          key
          type
          label
          placeholder
          helperText
          isRequired
        }
        ... on DynamicSchemaDefinitionMultiLineText {
          key
          type
          label
          placeholder
          helperText
          isRequired
        }
        ... on DynamicSchemaDefinitionPositiveInteger {
          key
          type
          label
          helperText
          isRequired
        }
        ... on DynamicSchemaDefinitionFiles {
          key
          type
          label
          helperText
        }
        ... on DynamicSchemaDefinitionFixed {
          key
          type
          label
          value
        }
        ... on DynamicSchemaDefinitionFileIds {
          key
          type
          label
        }
      }
    }
  }
  creativeBriefValues
  bucketId
  assetCategoryDefinition {
    id
    sections {
      id
      meta
      label
      description
      meta
      fields {
        ... on DynamicSchemaDefinitionSelectOne {
          key
          type
          label
          choices {
            key
            label
          }
          helperText
        }
        ... on DynamicSchemaDefinitionSingleLineText {
          key
          type
          label
          placeholder
          helperText
          isRequired
        }
        ... on DynamicSchemaDefinitionMultiLineText {
          key
          type
          label
          placeholder
          helperText
          isRequired
        }
        ... on DynamicSchemaDefinitionFileIds {
          key
          type
          label
        }
      }
    }
  }
  assetCategoryValues
  creationSet {
    id
    creativeFormats {
      id
      network {
        id
        key
        name
      }
      placement {
        id
        key
        name
        basicMerchandises {
          isResizable
          creativeType {
            id
            key
            name
          }
        }
      }
      creativeType {
        id
        key
        name
        requiredPoints {
          key
          point
          rewardAmount
          rewardCurrency
        }
      }
      attribute {
        aspectRatio {
          supportingAspectRatioId
          requiredOption {
            name
            amount
            points {
              key
              point
              rewardAmount
              rewardCurrency
            }
          }
          aspectRatio {
            width
            height
          }
          size {
            width
            height
          }
        }
        playbackTime {
          supportingPlaybackTimeId
          requiredOption {
            name
            amount
            points {
              key
              point
              rewardAmount
              rewardCurrency
            }
          }
          seconds
        }
      }
      selectedPricingMerchandiseOptions {
        id
        name
        helpUrlForDirector
        pricingTables {
          creativeTypeId
          cells {
            supportingPlaybackTimeLength
            supportingAspectRatioKey
            prices {
              key
              point
              rewardAmount
              rewardCurrency
            }
          }
        }
      }
      resizeBaseId
    }
    creations {
      id
      assignee {
        id
        name
        profileImageUrl
      }
      deliverables {
        id
        creative {
          id
          file {
            id
            originalFileName
            url
            mimeType
            size
          }
        }
        intent
        state
        createdAt
        stateUpdatedAt
      }
      modificationRequests {
        id
        bucketId
        state
        targetDeliverableId
        feeType
        createdAt
        deliveryDue
        feedback {
          id
          body
          createdAt
        }
        sender {
          id
          name
          profileImageUrl
        }
        items {
          id
          type
          typeName
          assetIds
          body
          metadata
          sender {
            id
            name
            profileImageUrl
          }
          issue {
            id
            name
            resolved
            comments {
              id
              body
              assetIds
              createdAt
              user {
                ... on UserDirector {
                  id
                  name
                  email
                  profileImageUrl
                }
                ... on UserOptimizer {
                  id
                  name
                  email
                  profileImageUrl
                }
              }
            }
          }
        }
      }
      creativeFormat {
        id
        network {
          id
          key
          name
        }
        placement {
          id
          key
          name
        }
        creativeType {
          id
          key
          name
          requiredPoints {
            key
            point
            rewardAmount
            rewardCurrency
          }
        }
        attribute {
          aspectRatio {
            supportingAspectRatioId
            requiredOption {
              name
              amount
              points {
                key
                point
                rewardAmount
                rewardCurrency
              }
            }
            aspectRatio {
              width
              height
            }
            size {
              width
              height
            }
          }
          playbackTime {
            supportingPlaybackTimeId
            requiredOption {
              name
              amount
              points {
                key
                point
                rewardAmount
                rewardCurrency
              }
            }
            seconds
          }
        }
        resizeBaseId
      }
      state
      createdAt
      stateUpdatedAt
    }
    amount
    additionalAmount
    deliveryDueDate
    deliveryDueDays
    expressDueDays
    finalizedAt
  }
  performanceReports {
    id
    adAccount {
      id
      network
      accountId
      name
    }
    lastUpdatedAt
    campaigns {
      id
      name
    }
    periodPatterns
    metrics
    comparisonTargets
    dimensions
  }
  createdAt
  submittedAt
  adVideos {
    adVideoId
    analyzingState
  }
}
    `;
export const ProjectDetailsWithoutPricingDataFragmentDoc = gql`
    fragment ProjectDetailsWithoutPricingData on Project {
  id
  versionId
  matchingFormat
  organization {
    id
    name
    pointBalance
    features {
      canOpenOfferWhenDisagreed
    }
    businessRegion {
      key
      idBusinessRegion
      timeZone
    }
  }
  originId
  parentId
  title
  state
  createdBy {
    id
    name
    profileImageUrl
  }
  designInspirationCase {
    id
    name
    url
    thumbnailUrl
  }
  projectType {
    id
    key
    published
    version
    title
    description
    thumbnailImageUrl
    sampleVideoUrl
    expectedDeliveryPeriod
    outputSpecification
    regulation
    minConceptCount
    maxConceptCount
    pricingMerchandiseOptions {
      id
      name
      helpUrlForDirector
      pricingTables {
        creativeTypeId
        cells {
          supportingPlaybackTimeLength
          supportingAspectRatioKey
          prices {
            key
            point
            rewardAmount
            rewardCurrency
          }
        }
      }
    }
    creativeBriefDefinition {
      id
      sections {
        id
        label
        description
        fields {
          ... on DynamicSchemaDefinitionSelectOne {
            key
            type
            label
            choices {
              key
              label
            }
            helperText
          }
          ... on DynamicSchemaDefinitionSelectMultiple {
            key
            type
            label
            choices {
              key
              label
            }
            helperText
            isRequiredToSelectAnything
          }
          ... on DynamicSchemaDefinitionToggle {
            key
            type
            label
            checkedControlLabel
            uncheckedControlLabel
          }
          ... on DynamicSchemaDefinitionSingleLineText {
            key
            type
            label
            placeholder
            helperText
            isRequired
          }
          ... on DynamicSchemaDefinitionMultiLineText {
            key
            type
            label
            placeholder
            helperText
            isRequired
          }
          ... on DynamicSchemaDefinitionPositiveInteger {
            key
            type
            label
            helperText
            isRequired
          }
          ... on DynamicSchemaDefinitionFiles {
            key
            type
            label
            helperText
          }
          ... on DynamicSchemaDefinitionFixed {
            key
            type
            label
            value
          }
        }
      }
    }
    assetCategoryDefinition {
      id
      sections {
        id
        meta
        label
        description
        fields {
          ... on DynamicSchemaDefinitionSelectOne {
            key
            type
            label
            choices {
              key
              label
            }
            helperText
          }
          ... on DynamicSchemaDefinitionSingleLineText {
            key
            type
            label
            placeholder
            helperText
            isRequired
          }
          ... on DynamicSchemaDefinitionMultiLineText {
            key
            type
            label
            placeholder
            helperText
            isRequired
          }
          ... on DynamicSchemaDefinitionFileIds {
            key
            type
            label
          }
        }
      }
    }
    supportingCreativeFormatNetworks {
      id
      key
      name
      placements {
        id
        key
        name
        basicMerchandises {
          isResizable
          creativeType {
            id
            key
            name
          }
        }
        pricingTables {
          creativeTypeId
          cells {
            supportingPlaybackTimeLength
            supportingAspectRatioKey
            prices {
              key
              point
              rewardAmount
              rewardCurrency
            }
          }
        }
        creativeTypes {
          id
          key
          name
          attribute {
            aspectRatio {
              id
              availables {
                aspectRatio {
                  width
                  height
                }
                presetSize {
                  width
                  height
                }
                requiredOption {
                  name
                  amount
                  points {
                    key
                    point
                    rewardAmount
                    rewardCurrency
                  }
                }
              }
            }
            playbackTime {
              id
              availables {
                requiredOption {
                  name
                  amount
                  points {
                    key
                    point
                    rewardAmount
                    rewardCurrency
                  }
                }
                seconds
              }
            }
          }
        }
      }
    }
    matchingFormatGroup {
      availableFormats
    }
  }
  creativeBriefDefinition {
    id
    sections {
      id
      label
      description
      meta
      fields {
        ... on DynamicSchemaDefinitionSelectOne {
          key
          type
          label
          choices {
            key
            label
          }
          helperText
        }
        ... on DynamicSchemaDefinitionSelectMultiple {
          key
          type
          label
          choices {
            key
            label
          }
          helperText
          isRequiredToSelectAnything
        }
        ... on DynamicSchemaDefinitionToggle {
          key
          type
          label
          checkedControlLabel
          uncheckedControlLabel
        }
        ... on DynamicSchemaDefinitionSingleLineText {
          key
          type
          label
          placeholder
          helperText
          isRequired
        }
        ... on DynamicSchemaDefinitionMultiLineText {
          key
          type
          label
          placeholder
          helperText
          isRequired
        }
        ... on DynamicSchemaDefinitionPositiveInteger {
          key
          type
          label
          helperText
          isRequired
        }
        ... on DynamicSchemaDefinitionFiles {
          key
          type
          label
          helperText
        }
        ... on DynamicSchemaDefinitionFixed {
          key
          type
          label
          value
        }
        ... on DynamicSchemaDefinitionFileIds {
          key
          type
          label
        }
      }
    }
  }
  creativeBriefValues
  bucketId
  assetCategoryDefinition {
    id
    sections {
      id
      meta
      label
      description
      meta
      fields {
        ... on DynamicSchemaDefinitionSelectOne {
          key
          type
          label
          choices {
            key
            label
          }
          helperText
        }
        ... on DynamicSchemaDefinitionSingleLineText {
          key
          type
          label
          placeholder
          helperText
          isRequired
        }
        ... on DynamicSchemaDefinitionMultiLineText {
          key
          type
          label
          placeholder
          helperText
          isRequired
        }
        ... on DynamicSchemaDefinitionFileIds {
          key
          type
          label
        }
      }
    }
  }
  assetCategoryValues
  creationSet {
    id
    creativeFormats {
      id
      network {
        id
        key
        name
      }
      placement {
        id
        key
        name
        basicMerchandises {
          isResizable
          creativeType {
            id
            key
            name
          }
        }
      }
      creativeType {
        id
        key
        name
        requiredPoints {
          key
          point
          rewardAmount
          rewardCurrency
        }
      }
      attribute {
        aspectRatio {
          supportingAspectRatioId
          requiredOption {
            name
            amount
            points {
              key
              point
              rewardAmount
              rewardCurrency
            }
          }
          aspectRatio {
            width
            height
          }
          size {
            width
            height
          }
        }
        playbackTime {
          supportingPlaybackTimeId
          requiredOption {
            name
            amount
            points {
              key
              point
              rewardAmount
              rewardCurrency
            }
          }
          seconds
        }
      }
      selectedPricingMerchandiseOptions {
        id
        name
        helpUrlForDirector
        pricingTables {
          creativeTypeId
          cells {
            supportingPlaybackTimeLength
            supportingAspectRatioKey
            prices {
              key
              point
              rewardAmount
              rewardCurrency
            }
          }
        }
      }
      resizeBaseId
    }
    creations {
      id
      assignee {
        id
        name
        profileImageUrl
      }
      deliverables {
        id
        creative {
          id
          file {
            id
            originalFileName
            url
            mimeType
            size
          }
        }
        intent
        state
        createdAt
        stateUpdatedAt
      }
      modificationRequests {
        id
        bucketId
        state
        targetDeliverableId
        feeType
        createdAt
        deliveryDue
        feedback {
          id
          body
          createdAt
        }
        sender {
          id
          name
          profileImageUrl
        }
        items {
          id
          type
          typeName
          assetIds
          body
          metadata
          sender {
            id
            name
            profileImageUrl
          }
          issue {
            id
            name
            resolved
            comments {
              id
              body
              assetIds
              createdAt
              user {
                ... on UserDirector {
                  id
                  name
                  email
                  profileImageUrl
                }
                ... on UserOptimizer {
                  id
                  name
                  email
                  profileImageUrl
                }
              }
            }
          }
        }
      }
      creativeFormat {
        id
        network {
          id
          key
          name
        }
        placement {
          id
          key
          name
        }
        creativeType {
          id
          key
          name
          requiredPoints {
            key
            point
            rewardAmount
            rewardCurrency
          }
        }
        attribute {
          aspectRatio {
            supportingAspectRatioId
            requiredOption {
              name
              amount
              points {
                key
                point
                rewardAmount
                rewardCurrency
              }
            }
            aspectRatio {
              width
              height
            }
            size {
              width
              height
            }
          }
          playbackTime {
            supportingPlaybackTimeId
            requiredOption {
              name
              amount
              points {
                key
                point
                rewardAmount
                rewardCurrency
              }
            }
            seconds
          }
        }
        resizeBaseId
      }
      state
      createdAt
      stateUpdatedAt
    }
    amount
    additionalAmount
    deliveryDueDate
    deliveryDueDays
    expressDueDays
    finalizedAt
  }
  performanceReports {
    id
    adAccount {
      id
      network
      accountId
      name
    }
    lastUpdatedAt
    campaigns {
      id
      name
    }
    periodPatterns
    metrics
    comparisonTargets
    dimensions
  }
  createdAt
  submittedAt
  adVideos {
    adVideoId
    analyzingState
  }
}
    `;
export const SingleCreationSetFragmentDoc = gql`
    fragment SingleCreationSet on CreationSet {
  id
  creativeFormats {
    id
    network {
      id
      key
      name
    }
    placement {
      id
      key
      name
    }
    creativeType {
      id
      key
      name
    }
    attribute {
      aspectRatio {
        supportingAspectRatioId
        aspectRatio {
          width
          height
        }
        size {
          width
          height
        }
      }
      playbackTime {
        supportingPlaybackTimeId
        seconds
      }
    }
    resizeBaseId
  }
  creations {
    id
    assignee {
      id
      name
      profileImageUrl
    }
    deliverables {
      id
      creative {
        id
        file {
          id
          originalFileName
          url
          mimeType
          size
        }
      }
      intent
      state
      createdAt
      stateUpdatedAt
    }
    modificationRequests {
      id
      bucketId
      state
      targetDeliverableId
      feeType
      createdAt
      submittedAt
      approvedAt
      deliveryDue
      feedback {
        id
        body
        createdAt
      }
      sender {
        id
        name
        profileImageUrl
      }
      items {
        id
        type
        typeName
        assetIds
        body
        metadata
        sender {
          id
          name
          profileImageUrl
        }
        issue {
          id
          name
          resolved
          comments {
            id
            body
            assetIds
            createdAt
            user {
              ... on UserDirector {
                id
                name
                email
                profileImageUrl
              }
              ... on UserOptimizer {
                id
                name
                email
                profileImageUrl
              }
            }
          }
        }
      }
      deliverables {
        id
        createdAt
        creative {
          id
          file {
            id
            originalFileName
            url
            mimeType
            size
          }
        }
        attachedThumbnail {
          id
          file {
            id
            originalFileName
            url
            mimeType
            size
          }
        }
        intent
      }
    }
    creativeFormat {
      id
      network {
        id
        key
        name
      }
      placement {
        id
        key
        name
      }
      creativeType {
        id
        key
        name
      }
      attribute {
        aspectRatio {
          supportingAspectRatioId
          aspectRatio {
            width
            height
          }
          size {
            width
            height
          }
        }
        playbackTime {
          supportingPlaybackTimeId
          seconds
        }
      }
      resizeBaseId
    }
    state
    createdAt
    stateUpdatedAt
  }
  amount
  deliveryDueDate
  deliveryDueDays
  expressDueDays
}
    `;
export const CreativeForCreationDetailFragmentDoc = gql`
    fragment CreativeForCreationDetail on Creative {
  id
  file {
    id
    originalFileName
    url
    mimeType
    size
  }
}
    `;
export const DeliverableForCraetionDetailFragmentDoc = gql`
    fragment DeliverableForCraetionDetail on Deliverable {
  id
  creative {
    ...CreativeForCreationDetail
  }
  attachedThumbnail {
    id
    file {
      id
      originalFileName
      url
      mimeType
      size
    }
  }
  intent
  state
  uploadedAdPlatformKeys
  createdAt
  stateUpdatedAt
}
    ${CreativeForCreationDetailFragmentDoc}`;
export const ModificationRequestItemIssueCommentForDetailFragmentDoc = gql`
    fragment ModificationRequestItemIssueCommentForDetail on IssueComment {
  id
  body
  assetIds
  createdAt
  user {
    ... on UserDirector {
      id
      name
      email
      profileImageUrl
    }
    ... on UserOptimizer {
      id
      name
      email
      profileImageUrl
    }
  }
}
    `;
export const ModificationRequestItemIssueForDetailFragmentDoc = gql`
    fragment ModificationRequestItemIssueForDetail on Issue {
  id
  name
  resolved
  createdAt
  comments {
    ...ModificationRequestItemIssueCommentForDetail
  }
}
    ${ModificationRequestItemIssueCommentForDetailFragmentDoc}`;
export const ModificationRequestItemForDetailFragmentDoc = gql`
    fragment ModificationRequestItemForDetail on RequestItem {
  id
  bucketId
  type
  typeName
  assetIds
  body
  metadata
  sender {
    id
    name
    profileImageUrl
  }
  issue {
    ...ModificationRequestItemIssueForDetail
  }
}
    ${ModificationRequestItemIssueForDetailFragmentDoc}`;
export const ModificationRequestDeliverableForDetailFragmentDoc = gql`
    fragment ModificationRequestDeliverableForDetail on ModificationRequestDeliverable {
  id
  createdAt
  creative {
    id
    file {
      id
      originalFileName
      url
      mimeType
      size
    }
  }
  attachedThumbnail {
    id
    file {
      id
      originalFileName
      url
      mimeType
      size
    }
  }
  intent
}
    `;
export const ModificationRequestForDetailFragmentDoc = gql`
    fragment ModificationRequestForDetail on Request {
  id
  bucketId
  state
  targetDeliverableId
  feeType
  createdAt
  submittedAt
  approvedAt
  deliveryDue
  feedback {
    id
    body
    createdAt
  }
  sender {
    id
    name
    profileImageUrl
  }
  items {
    ...ModificationRequestItemForDetail
  }
  deliverables {
    ...ModificationRequestDeliverableForDetail
  }
}
    ${ModificationRequestItemForDetailFragmentDoc}
${ModificationRequestDeliverableForDetailFragmentDoc}`;
export const CreationDetailFragmentDoc = gql`
    fragment CreationDetail on Creation {
  id
  assignmentId
  projectId
  creationSetId
  latestDeliverableUrl
  assignee {
    id
    name
    profileImageUrl
  }
  finalized
  finalizedAt
  deliverables {
    ...DeliverableForCraetionDetail
  }
  modificationRequests {
    ...ModificationRequestForDetail
  }
  state
  proposed
  submittedAt
  createdAt
  stateUpdatedAt
  modificationRequestExpired
  modificationRequestFreeExpiredAt
  modificationRequestPoint
  modificationRequestFreeLimit
  isNextModificationRequestForAFee
  creativeFormat {
    id
    network {
      id
      key
      name
    }
    placement {
      id
      key
      name
      basicMerchandises {
        isModificationRequestable
        creativeType {
          id
          key
          name
        }
      }
    }
    attribute {
      aspectRatio {
        supportingAspectRatioId
        size {
          height
          width
        }
        aspectRatio {
          height
          width
        }
        requiredOption {
          amount
          points {
            key
            point
          }
        }
      }
      playbackTime {
        supportingPlaybackTimeId
        seconds
        requiredOption {
          amount
          points {
            key
            point
          }
        }
      }
    }
    creativeType {
      id
      key
      name
    }
  }
  organization {
    id
    name
    pointBalance
    features {
      canOpenOfferWhenDisagreed
    }
    businessRegion {
      key
      idBusinessRegion
      timeZone
    }
  }
}
    ${DeliverableForCraetionDetailFragmentDoc}
${ModificationRequestForDetailFragmentDoc}`;
export const OrganizationDetailFragmentDoc = gql`
    fragment OrganizationDetail on Organization {
  id
  name
  pointBalance
  features {
    canOpenOfferWhenDisagreed
  }
  businessRegion {
    key
    idBusinessRegion
    timeZone
  }
}
    `;
export const DailySummaryPerformanceWithAllFieldsFragmentDoc = gql`
    fragment DailySummaryPerformanceWithAllFields on DailySummaryPerformance {
  period {
    from
    to
  }
  metric
  basis {
    values {
      date
      actualValue {
        value
        type
        currency
      }
    }
  }
  creatives {
    creativeId
    values {
      date
      actualValue {
        value
        type
        currency
      }
    }
    adName
    thumbnailImageUrl
    creation {
      id
      assignee {
        id
        name
        profileImageUrl
      }
      deliverables {
        id
        createdAt
        creative {
          id
          file {
            id
            originalFileName
            url
            thumbnailUrl
            mimeType
            size
          }
        }
        intent
        state
        stateUpdatedAt
      }
    }
  }
}
    `;
export const PeriodicDetailPerformanceWithAllFieldsFragmentDoc = gql`
    fragment PeriodicDetailPerformanceWithAllFields on PeriodicDetailPerformance {
  period {
    from
    to
  }
  creatives {
    creativeId
    adName
    thumbnailImageUrl
    creation {
      id
      assignee {
        id
        name
        profileImageUrl
      }
      deliverables {
        id
        createdAt
        creative {
          id
          file {
            id
            originalFileName
            url
            thumbnailUrl
            mimeType
            size
          }
        }
        intent
        state
        stateUpdatedAt
      }
    }
    values {
      metric
      actualValue {
        value
        type
        currency
      }
    }
  }
}
    `;
export const CreativeForPeriodicImprovementPerformanceWithAllFieldsFragmentDoc = gql`
    fragment CreativeForPeriodicImprovementPerformanceWithAllFields on ImprovementCreative {
  creativeId
  adName
  thumbnailImageUrl
  values {
    all {
      metric
      target
      targetValue {
        value
        type
        currency
      }
      actualValue {
        value
        type
        currency
      }
    }
    staticImage {
      metric
      target
      targetValue {
        value
        type
        currency
      }
      actualValue {
        value
        type
        currency
      }
    }
    video {
      metric
      target
      targetValue {
        value
        type
        currency
      }
      actualValue {
        value
        type
        currency
      }
    }
  }
  creation {
    id
    assignee {
      id
      name
      profileImageUrl
    }
    deliverables {
      id
      createdAt
      creative {
        id
        file {
          id
          originalFileName
          url
          thumbnailUrl
          mimeType
          size
        }
      }
      intent
      state
      stateUpdatedAt
    }
  }
}
    `;
export const PeriodicImprovementPerformanceWithAllFieldsFragmentDoc = gql`
    fragment PeriodicImprovementPerformanceWithAllFields on PeriodicImprovementPerformance {
  period {
    from
    to
  }
  creatives {
    ...CreativeForPeriodicImprovementPerformanceWithAllFields
  }
}
    ${CreativeForPeriodicImprovementPerformanceWithAllFieldsFragmentDoc}`;
export const ProjectTypeForListFragmentDoc = gql`
    fragment ProjectTypeForList on ProjectType {
  id
  key
  title
  description
  thumbnailImageUrl
  sampleVideoUrl
  expectedDeliveryPeriod
  outputSpecification
  regulation
  createdAt
  popularity
  displayPriority
  minimumPoint
  supportingCreativeFormatNetworks {
    id
    key
    name
    placements {
      id
      key
      name
      creativeTypes {
        id
        key
        name
      }
    }
  }
  matchingFormatGroup {
    availableFormats
  }
}
    `;
export const CreativeFormatForShowFragmentDoc = gql`
    fragment CreativeFormatForShow on CreativeFormat {
  id
  network {
    id
    key
    name
  }
  placement {
    id
    key
    name
    basicMerchandises {
      isResizable
      creativeType {
        id
        key
        name
      }
    }
  }
  creativeType {
    requiredPoints {
      key
      point
    }
    id
    key
    name
  }
  selectedPricingMerchandiseOptions {
    id
    name
    helpUrlForDirector
  }
  attribute {
    aspectRatio {
      supportingAspectRatioId
      aspectRatio {
        width
        height
      }
      size {
        width
        height
      }
    }
    playbackTime {
      supportingPlaybackTimeId
      seconds
    }
  }
  resizeBaseId
}
    `;
export const CreationForShowFragmentDoc = gql`
    fragment CreationForShow on Creation {
  id
  latestDeliverableUrl
  latestDeliverableSubmittedAt
  modificationRequestExpired
  assignmentId
  assignee {
    id
    name
    profileImageUrl
  }
  deliverables {
    id
    creative {
      id
      file {
        id
        originalFileName
        url
        mimeType
        size
      }
    }
    attachedThumbnail {
      file {
        url
      }
    }
    uploadedAdPlatformKeys
    intent
    state
    createdAt
    stateUpdatedAt
  }
  modificationRequests {
    id
    bucketId
    state
    targetDeliverableId
    feeType
    createdAt
    submittedAt
    approvedAt
    deliveryDue
    feedback {
      id
      body
      createdAt
    }
    sender {
      id
      name
      profileImageUrl
    }
    items {
      id
      type
      typeName
      assetIds
      body
      metadata
      sender {
        id
        name
        profileImageUrl
      }
      issue {
        id
        name
        resolved
        comments {
          id
          body
          assetIds
          createdAt
          user {
            ... on UserDirector {
              id
              name
              email
              profileImageUrl
            }
            ... on UserOptimizer {
              id
              name
              email
              profileImageUrl
            }
          }
        }
      }
    }
    deliverables {
      id
      createdAt
      creative {
        id
        file {
          id
          originalFileName
          url
          mimeType
          size
        }
      }
      attachedThumbnail {
        id
        file {
          id
          originalFileName
          url
          mimeType
          size
        }
      }
      intent
    }
  }
  creativeFormat {
    id
    network {
      id
      key
      name
    }
    placement {
      id
      key
      name
    }
    creativeType {
      id
      key
      name
    }
    attribute {
      aspectRatio {
        supportingAspectRatioId
        aspectRatio {
          width
          height
        }
        size {
          width
          height
        }
      }
      playbackTime {
        supportingPlaybackTimeId
        seconds
      }
    }
    resizeBaseId
  }
  state
  proposed
  createdAt
  stateUpdatedAt
  submittedAt
  finalized
}
    `;
export const CreationSetForShowFragmentDoc = gql`
    fragment CreationSetForShow on CreationSet {
  id
  offerId
  creativeFormats {
    ...CreativeFormatForShow
  }
  creations {
    ...CreationForShow
  }
  amount
  additionalAmount
  deliveryDueDate
  deliveryDueDays
  expressDueDays
  finalizedAt
}
    ${CreativeFormatForShowFragmentDoc}
${CreationForShowFragmentDoc}`;
export const IssueCommentForProjectFragmentDoc = gql`
    fragment IssueCommentForProject on IssueComment {
  id
  body
  createdAt
  updatedAt
  user {
    ... on UserDirector {
      id
      name
      email
      profileImageUrl
    }
    ... on UserOptimizer {
      id
      name
      email
      profileImageUrl
    }
  }
}
    `;
export const IssueForProjectFragmentDoc = gql`
    fragment IssueForProject on Issue {
  id
  name
  comments {
    ...IssueCommentForProject
  }
}
    ${IssueCommentForProjectFragmentDoc}`;
export const ProjectDetailsForEditFragmentDoc = gql`
    fragment ProjectDetailsForEdit on Project {
  id
  versionId
  matchingFormat
  organization {
    id
    name
    pointBalance
    features {
      canOpenOfferWhenDisagreed
    }
    businessRegion {
      key
      idBusinessRegion
      timeZone
    }
  }
  originId
  parentId
  title
  state
  finalized
  deliveryDueDate
  createdBy {
    id
    name
    profileImageUrl
  }
  designInspirationCase {
    id
    name
    url
    thumbnailUrl
  }
  projectType {
    id
    published
    version
    title
    description
    thumbnailImageUrl
    sampleVideoUrl
    expectedDeliveryPeriod
    outputSpecification
    regulation
    creativeBriefDefinition {
      ...CreativeBriefDefinitionForProject
    }
    assetCategoryDefinition {
      ...AssetCategoryDefinitionForProject
    }
    supportingCreativeFormatNetworks {
      id
      key
      name
      placements {
        id
        key
        name
        basicMerchandises {
          isResizable
          creativeType {
            id
            key
            name
          }
        }
        creativeTypes {
          id
          key
          name
          attribute {
            aspectRatio {
              id
              availables {
                aspectRatio {
                  width
                  height
                }
                presetSize {
                  width
                  height
                }
              }
            }
            playbackTime {
              id
              availables {
                seconds
              }
            }
          }
        }
      }
    }
  }
  creativeBriefDefinition {
    ...CreativeBriefDefinitionForProject
  }
  creativeBriefValues
  bucketId
  assetCategoryDefinition {
    ...AssetCategoryDefinitionForProject
  }
  assetCategoryValues
  creationSet {
    ...CreationSetForShow
  }
  performanceReports {
    id
    adAccount {
      id
      network
      accountId
      name
    }
    lastUpdatedAt
    campaigns {
      id
      name
    }
    periodPatterns
    metrics
    comparisonTargets
    dimensions
  }
  createdAt
  submittedAt
  adVideos {
    adVideoId
    analyzingState
  }
  issue {
    ...IssueForProject
  }
}
    ${CreativeBriefDefinitionForProjectFragmentDoc}
${AssetCategoryDefinitionForProjectFragmentDoc}
${CreationSetForShowFragmentDoc}
${IssueForProjectFragmentDoc}`;
export const ProjectDetailsForShowFragmentDoc = gql`
    fragment ProjectDetailsForShow on Project {
  id
  hasChanges
  versionId
  matchingFormat
  organization {
    id
    name
    pointBalance
    features {
      canOpenOfferWhenDisagreed
    }
    businessRegion {
      key
      idBusinessRegion
      timeZone
    }
  }
  originId
  parentId
  title
  state
  finalized
  deliveryDueDate
  createdBy {
    id
    name
    profileImageUrl
  }
  designInspirationCase {
    id
    name
    url
    thumbnailUrl
  }
  projectType {
    id
    published
    version
    title
    description
    thumbnailImageUrl
    sampleVideoUrl
    expectedDeliveryPeriod
    outputSpecification
    regulation
  }
  creativeBriefDefinition {
    ...CreativeBriefDefinitionForProject
  }
  creativeBriefValues
  bucketId
  assetCategoryDefinition {
    ...AssetCategoryDefinitionForProject
  }
  assetCategoryValues
  creationSet {
    ...CreationSetForShow
  }
  performanceReports {
    id
    adAccount {
      id
      network
      accountId
      name
    }
    lastUpdatedAt
    campaigns {
      id
      name
    }
    periodPatterns
    metrics
    comparisonTargets
    dimensions
  }
  createdAt
  submittedAt
  adVideos {
    adVideoId
    analyzingState
  }
  issue {
    ...IssueForProject
  }
}
    ${CreativeBriefDefinitionForProjectFragmentDoc}
${AssetCategoryDefinitionForProjectFragmentDoc}
${CreationSetForShowFragmentDoc}
${IssueForProjectFragmentDoc}`;
export const ProjectForAllOfOrganizationFragmentDoc = gql`
    fragment ProjectForAllOfOrganization on Project {
  id
  title
  state
  finalized
  deliveryDueDate
  projectType {
    id
    title
  }
  createdBy {
    id
    name
    profileImageUrl
  }
  matchingFormat
  createdAt
  updatedAt
  submittedAt
  progressSummary {
    orderCount
    approvedCount
    modificationRequestCount
    modificationRequestFeedbackCount
  }
}
    `;
export const SingleDirectorUserFragmentDoc = gql`
    fragment SingleDirectorUser on UserDirector {
  id
  name
  email
  profileImageUrl
}
    `;
export const GetCreationSetWithPricingDocument = gql`
    query getCreationSetWithPricing($id: ID!) {
  creationSet(id: $id) {
    ...CreationSetWithPricing
  }
}
    ${CreationSetWithPricingFragmentDoc}`;

/**
 * __useGetCreationSetWithPricingQuery__
 *
 * To run a query within a React component, call `useGetCreationSetWithPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreationSetWithPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreationSetWithPricingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCreationSetWithPricingQuery(baseOptions: Apollo.QueryHookOptions<GetCreationSetWithPricingQuery, GetCreationSetWithPricingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreationSetWithPricingQuery, GetCreationSetWithPricingQueryVariables>(GetCreationSetWithPricingDocument, options);
      }
export function useGetCreationSetWithPricingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreationSetWithPricingQuery, GetCreationSetWithPricingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreationSetWithPricingQuery, GetCreationSetWithPricingQueryVariables>(GetCreationSetWithPricingDocument, options);
        }
export type GetCreationSetWithPricingQueryHookResult = ReturnType<typeof useGetCreationSetWithPricingQuery>;
export type GetCreationSetWithPricingLazyQueryHookResult = ReturnType<typeof useGetCreationSetWithPricingLazyQuery>;
export type GetCreationSetWithPricingQueryResult = Apollo.QueryResult<GetCreationSetWithPricingQuery, GetCreationSetWithPricingQueryVariables>;
export const AdoptProposalCreationsDocument = gql`
    mutation adoptProposalCreations($projectId: ID!, $proposalCreationIds: [ID!]) {
  adoptProposalCreations(
    projectId: $projectId
    proposalCreationIds: $proposalCreationIds
  ) {
    nodes {
      id
    }
  }
}
    `;
export type AdoptProposalCreationsMutationFn = Apollo.MutationFunction<AdoptProposalCreationsMutation, AdoptProposalCreationsMutationVariables>;

/**
 * __useAdoptProposalCreationsMutation__
 *
 * To run a mutation, you first call `useAdoptProposalCreationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdoptProposalCreationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adoptProposalCreationsMutation, { data, loading, error }] = useAdoptProposalCreationsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      proposalCreationIds: // value for 'proposalCreationIds'
 *   },
 * });
 */
export function useAdoptProposalCreationsMutation(baseOptions?: Apollo.MutationHookOptions<AdoptProposalCreationsMutation, AdoptProposalCreationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdoptProposalCreationsMutation, AdoptProposalCreationsMutationVariables>(AdoptProposalCreationsDocument, options);
      }
export type AdoptProposalCreationsMutationHookResult = ReturnType<typeof useAdoptProposalCreationsMutation>;
export type AdoptProposalCreationsMutationResult = Apollo.MutationResult<AdoptProposalCreationsMutation>;
export type AdoptProposalCreationsMutationOptions = Apollo.BaseMutationOptions<AdoptProposalCreationsMutation, AdoptProposalCreationsMutationVariables>;
export const PurchaseProposalCreationsDocument = gql`
    mutation purchaseProposalCreations($projectId: ID!, $proposalCreationIds: [ID!]) {
  purchaseProposalCreations(
    projectId: $projectId
    proposalCreationIds: $proposalCreationIds
  ) {
    nodes {
      id
    }
  }
}
    `;
export type PurchaseProposalCreationsMutationFn = Apollo.MutationFunction<PurchaseProposalCreationsMutation, PurchaseProposalCreationsMutationVariables>;

/**
 * __usePurchaseProposalCreationsMutation__
 *
 * To run a mutation, you first call `usePurchaseProposalCreationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseProposalCreationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseProposalCreationsMutation, { data, loading, error }] = usePurchaseProposalCreationsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      proposalCreationIds: // value for 'proposalCreationIds'
 *   },
 * });
 */
export function usePurchaseProposalCreationsMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseProposalCreationsMutation, PurchaseProposalCreationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseProposalCreationsMutation, PurchaseProposalCreationsMutationVariables>(PurchaseProposalCreationsDocument, options);
      }
export type PurchaseProposalCreationsMutationHookResult = ReturnType<typeof usePurchaseProposalCreationsMutation>;
export type PurchaseProposalCreationsMutationResult = Apollo.MutationResult<PurchaseProposalCreationsMutation>;
export type PurchaseProposalCreationsMutationOptions = Apollo.BaseMutationOptions<PurchaseProposalCreationsMutation, PurchaseProposalCreationsMutationVariables>;
export const FinalizeCreationDocument = gql`
    mutation finalizeCreation($id: ID!) {
  finalizeCreation(id: $id) {
    id
  }
}
    `;
export type FinalizeCreationMutationFn = Apollo.MutationFunction<FinalizeCreationMutation, FinalizeCreationMutationVariables>;

/**
 * __useFinalizeCreationMutation__
 *
 * To run a mutation, you first call `useFinalizeCreationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeCreationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeCreationMutation, { data, loading, error }] = useFinalizeCreationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFinalizeCreationMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeCreationMutation, FinalizeCreationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeCreationMutation, FinalizeCreationMutationVariables>(FinalizeCreationDocument, options);
      }
export type FinalizeCreationMutationHookResult = ReturnType<typeof useFinalizeCreationMutation>;
export type FinalizeCreationMutationResult = Apollo.MutationResult<FinalizeCreationMutation>;
export type FinalizeCreationMutationOptions = Apollo.BaseMutationOptions<FinalizeCreationMutation, FinalizeCreationMutationVariables>;
export const GetInsightCategoriesDocument = gql`
    query GetInsightCategories($organizationId: ID, $language: ID!) {
  insightCategoriesByOrganization(
    organizationId: $organizationId
    language: $language
  ) {
    id
    name
    description
    pcColumnCount
    spColumnCount
    rowCount
    articles {
      id
      title
      url
      thumbnailImageUrl
    }
  }
}
    `;

/**
 * __useGetInsightCategoriesQuery__
 *
 * To run a query within a React component, call `useGetInsightCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightCategoriesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGetInsightCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetInsightCategoriesQuery, GetInsightCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsightCategoriesQuery, GetInsightCategoriesQueryVariables>(GetInsightCategoriesDocument, options);
      }
export function useGetInsightCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsightCategoriesQuery, GetInsightCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsightCategoriesQuery, GetInsightCategoriesQueryVariables>(GetInsightCategoriesDocument, options);
        }
export type GetInsightCategoriesQueryHookResult = ReturnType<typeof useGetInsightCategoriesQuery>;
export type GetInsightCategoriesLazyQueryHookResult = ReturnType<typeof useGetInsightCategoriesLazyQuery>;
export type GetInsightCategoriesQueryResult = Apollo.QueryResult<GetInsightCategoriesQuery, GetInsightCategoriesQueryVariables>;
export const GetProjectTypeDocument = gql`
    query getProjectType($key: String!, $language: ID!) {
  projectType(key: $key, language: $language) {
    ...ProjectTypeDetail
    id
  }
}
    ${ProjectTypeDetailFragmentDoc}`;

/**
 * __useGetProjectTypeQuery__
 *
 * To run a query within a React component, call `useGetProjectTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectTypeQuery({
 *   variables: {
 *      key: // value for 'key'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGetProjectTypeQuery(baseOptions: Apollo.QueryHookOptions<GetProjectTypeQuery, GetProjectTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectTypeQuery, GetProjectTypeQueryVariables>(GetProjectTypeDocument, options);
      }
export function useGetProjectTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectTypeQuery, GetProjectTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectTypeQuery, GetProjectTypeQueryVariables>(GetProjectTypeDocument, options);
        }
export type GetProjectTypeQueryHookResult = ReturnType<typeof useGetProjectTypeQuery>;
export type GetProjectTypeLazyQueryHookResult = ReturnType<typeof useGetProjectTypeLazyQuery>;
export type GetProjectTypeQueryResult = Apollo.QueryResult<GetProjectTypeQuery, GetProjectTypeQueryVariables>;
export const GetProjectByIdForOptionScreenDocument = gql`
    query getProjectByIdForOptionScreen($id: ID!, $language: ID) {
  project(id: $id, language: $language) {
    ...ProjectDetailsForOptionScreen
  }
}
    ${ProjectDetailsForOptionScreenFragmentDoc}`;

/**
 * __useGetProjectByIdForOptionScreenQuery__
 *
 * To run a query within a React component, call `useGetProjectByIdForOptionScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectByIdForOptionScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectByIdForOptionScreenQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGetProjectByIdForOptionScreenQuery(baseOptions: Apollo.QueryHookOptions<GetProjectByIdForOptionScreenQuery, GetProjectByIdForOptionScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectByIdForOptionScreenQuery, GetProjectByIdForOptionScreenQueryVariables>(GetProjectByIdForOptionScreenDocument, options);
      }
export function useGetProjectByIdForOptionScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectByIdForOptionScreenQuery, GetProjectByIdForOptionScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectByIdForOptionScreenQuery, GetProjectByIdForOptionScreenQueryVariables>(GetProjectByIdForOptionScreenDocument, options);
        }
export type GetProjectByIdForOptionScreenQueryHookResult = ReturnType<typeof useGetProjectByIdForOptionScreenQuery>;
export type GetProjectByIdForOptionScreenLazyQueryHookResult = ReturnType<typeof useGetProjectByIdForOptionScreenLazyQuery>;
export type GetProjectByIdForOptionScreenQueryResult = Apollo.QueryResult<GetProjectByIdForOptionScreenQuery, GetProjectByIdForOptionScreenQueryVariables>;
export const UpdateDraftProjectFromOptionScreenToPreviewScreenDocument = gql`
    mutation updateDraftProjectFromOptionScreenToPreviewScreen($id: ID!, $title: String!, $matchingFormat: MatchingFormat!, $creationSet: CreationSetInput, $selectedPricingMerchandiseOptionIds: [ID!]) {
  updateProjectAsDraft(
    id: $id
    title: $title
    matchingFormat: $matchingFormat
    creationSet: $creationSet
    selectedPricingMerchandiseOptionIds: $selectedPricingMerchandiseOptionIds
  ) {
    ...ProjectDetails
  }
}
    ${ProjectDetailsFragmentDoc}`;
export type UpdateDraftProjectFromOptionScreenToPreviewScreenMutationFn = Apollo.MutationFunction<UpdateDraftProjectFromOptionScreenToPreviewScreenMutation, UpdateDraftProjectFromOptionScreenToPreviewScreenMutationVariables>;

/**
 * __useUpdateDraftProjectFromOptionScreenToPreviewScreenMutation__
 *
 * To run a mutation, you first call `useUpdateDraftProjectFromOptionScreenToPreviewScreenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftProjectFromOptionScreenToPreviewScreenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDraftProjectFromOptionScreenToPreviewScreenMutation, { data, loading, error }] = useUpdateDraftProjectFromOptionScreenToPreviewScreenMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      matchingFormat: // value for 'matchingFormat'
 *      creationSet: // value for 'creationSet'
 *      selectedPricingMerchandiseOptionIds: // value for 'selectedPricingMerchandiseOptionIds'
 *   },
 * });
 */
export function useUpdateDraftProjectFromOptionScreenToPreviewScreenMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDraftProjectFromOptionScreenToPreviewScreenMutation, UpdateDraftProjectFromOptionScreenToPreviewScreenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDraftProjectFromOptionScreenToPreviewScreenMutation, UpdateDraftProjectFromOptionScreenToPreviewScreenMutationVariables>(UpdateDraftProjectFromOptionScreenToPreviewScreenDocument, options);
      }
export type UpdateDraftProjectFromOptionScreenToPreviewScreenMutationHookResult = ReturnType<typeof useUpdateDraftProjectFromOptionScreenToPreviewScreenMutation>;
export type UpdateDraftProjectFromOptionScreenToPreviewScreenMutationResult = Apollo.MutationResult<UpdateDraftProjectFromOptionScreenToPreviewScreenMutation>;
export type UpdateDraftProjectFromOptionScreenToPreviewScreenMutationOptions = Apollo.BaseMutationOptions<UpdateDraftProjectFromOptionScreenToPreviewScreenMutation, UpdateDraftProjectFromOptionScreenToPreviewScreenMutationVariables>;
export const UpdateDraftProjectOnOptionScreenDocument = gql`
    mutation updateDraftProjectOnOptionScreen($id: ID!, $title: String!, $matchingFormat: MatchingFormat!, $creationSet: CreationSetInput, $selectedPricingMerchandiseOptionIds: [ID!]) {
  updateProjectAsDraft(
    id: $id
    title: $title
    matchingFormat: $matchingFormat
    creationSet: $creationSet
    selectedPricingMerchandiseOptionIds: $selectedPricingMerchandiseOptionIds
  ) {
    ...ProjectDetails
  }
}
    ${ProjectDetailsFragmentDoc}`;
export type UpdateDraftProjectOnOptionScreenMutationFn = Apollo.MutationFunction<UpdateDraftProjectOnOptionScreenMutation, UpdateDraftProjectOnOptionScreenMutationVariables>;

/**
 * __useUpdateDraftProjectOnOptionScreenMutation__
 *
 * To run a mutation, you first call `useUpdateDraftProjectOnOptionScreenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftProjectOnOptionScreenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDraftProjectOnOptionScreenMutation, { data, loading, error }] = useUpdateDraftProjectOnOptionScreenMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      matchingFormat: // value for 'matchingFormat'
 *      creationSet: // value for 'creationSet'
 *      selectedPricingMerchandiseOptionIds: // value for 'selectedPricingMerchandiseOptionIds'
 *   },
 * });
 */
export function useUpdateDraftProjectOnOptionScreenMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDraftProjectOnOptionScreenMutation, UpdateDraftProjectOnOptionScreenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDraftProjectOnOptionScreenMutation, UpdateDraftProjectOnOptionScreenMutationVariables>(UpdateDraftProjectOnOptionScreenDocument, options);
      }
export type UpdateDraftProjectOnOptionScreenMutationHookResult = ReturnType<typeof useUpdateDraftProjectOnOptionScreenMutation>;
export type UpdateDraftProjectOnOptionScreenMutationResult = Apollo.MutationResult<UpdateDraftProjectOnOptionScreenMutation>;
export type UpdateDraftProjectOnOptionScreenMutationOptions = Apollo.BaseMutationOptions<UpdateDraftProjectOnOptionScreenMutation, UpdateDraftProjectOnOptionScreenMutationVariables>;
export const UpdateDraftProjectToOptionScreenDocument = gql`
    mutation updateDraftProjectToOptionScreen($id: ID!, $title: String!, $matchingFormat: MatchingFormat!, $creationSet: CreationSetInput, $creativeBriefValues: DynamicSchemaValuesInput, $assetCategoryValues: DynamicSchemaValuesInput, $designInspirationCaseId: ID, $selectedPricingMerchandiseOptionIds: [ID!]) {
  updateProjectAsDraft(
    id: $id
    title: $title
    matchingFormat: $matchingFormat
    creationSet: $creationSet
    creativeBriefValues: $creativeBriefValues
    assetCategoryValues: $assetCategoryValues
    designInspirationCaseId: $designInspirationCaseId
    selectedPricingMerchandiseOptionIds: $selectedPricingMerchandiseOptionIds
  ) {
    ...ProjectDetailsForOptionScreen
  }
}
    ${ProjectDetailsForOptionScreenFragmentDoc}`;
export type UpdateDraftProjectToOptionScreenMutationFn = Apollo.MutationFunction<UpdateDraftProjectToOptionScreenMutation, UpdateDraftProjectToOptionScreenMutationVariables>;

/**
 * __useUpdateDraftProjectToOptionScreenMutation__
 *
 * To run a mutation, you first call `useUpdateDraftProjectToOptionScreenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftProjectToOptionScreenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDraftProjectToOptionScreenMutation, { data, loading, error }] = useUpdateDraftProjectToOptionScreenMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      matchingFormat: // value for 'matchingFormat'
 *      creationSet: // value for 'creationSet'
 *      creativeBriefValues: // value for 'creativeBriefValues'
 *      assetCategoryValues: // value for 'assetCategoryValues'
 *      designInspirationCaseId: // value for 'designInspirationCaseId'
 *      selectedPricingMerchandiseOptionIds: // value for 'selectedPricingMerchandiseOptionIds'
 *   },
 * });
 */
export function useUpdateDraftProjectToOptionScreenMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDraftProjectToOptionScreenMutation, UpdateDraftProjectToOptionScreenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDraftProjectToOptionScreenMutation, UpdateDraftProjectToOptionScreenMutationVariables>(UpdateDraftProjectToOptionScreenDocument, options);
      }
export type UpdateDraftProjectToOptionScreenMutationHookResult = ReturnType<typeof useUpdateDraftProjectToOptionScreenMutation>;
export type UpdateDraftProjectToOptionScreenMutationResult = Apollo.MutationResult<UpdateDraftProjectToOptionScreenMutation>;
export type UpdateDraftProjectToOptionScreenMutationOptions = Apollo.BaseMutationOptions<UpdateDraftProjectToOptionScreenMutation, UpdateDraftProjectToOptionScreenMutationVariables>;
export const GetProjectByIdDocument = gql`
    query getProjectById($id: ID!, $language: ID) {
  project(id: $id, language: $language) {
    ...ProjectDetails
  }
}
    ${ProjectDetailsFragmentDoc}`;

/**
 * __useGetProjectByIdQuery__
 *
 * To run a query within a React component, call `useGetProjectByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGetProjectByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProjectByIdQuery, GetProjectByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectByIdQuery, GetProjectByIdQueryVariables>(GetProjectByIdDocument, options);
      }
export function useGetProjectByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectByIdQuery, GetProjectByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectByIdQuery, GetProjectByIdQueryVariables>(GetProjectByIdDocument, options);
        }
export type GetProjectByIdQueryHookResult = ReturnType<typeof useGetProjectByIdQuery>;
export type GetProjectByIdLazyQueryHookResult = ReturnType<typeof useGetProjectByIdLazyQuery>;
export type GetProjectByIdQueryResult = Apollo.QueryResult<GetProjectByIdQuery, GetProjectByIdQueryVariables>;
export const GetProjectByIdWithoutPricingDataDocument = gql`
    query getProjectByIdWithoutPricingData($id: ID!, $language: ID) {
  project(id: $id, language: $language) {
    ...ProjectDetailsWithoutPricingData
  }
}
    ${ProjectDetailsWithoutPricingDataFragmentDoc}`;

/**
 * __useGetProjectByIdWithoutPricingDataQuery__
 *
 * To run a query within a React component, call `useGetProjectByIdWithoutPricingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectByIdWithoutPricingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectByIdWithoutPricingDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGetProjectByIdWithoutPricingDataQuery(baseOptions: Apollo.QueryHookOptions<GetProjectByIdWithoutPricingDataQuery, GetProjectByIdWithoutPricingDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectByIdWithoutPricingDataQuery, GetProjectByIdWithoutPricingDataQueryVariables>(GetProjectByIdWithoutPricingDataDocument, options);
      }
export function useGetProjectByIdWithoutPricingDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectByIdWithoutPricingDataQuery, GetProjectByIdWithoutPricingDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectByIdWithoutPricingDataQuery, GetProjectByIdWithoutPricingDataQueryVariables>(GetProjectByIdWithoutPricingDataDocument, options);
        }
export type GetProjectByIdWithoutPricingDataQueryHookResult = ReturnType<typeof useGetProjectByIdWithoutPricingDataQuery>;
export type GetProjectByIdWithoutPricingDataLazyQueryHookResult = ReturnType<typeof useGetProjectByIdWithoutPricingDataLazyQuery>;
export type GetProjectByIdWithoutPricingDataQueryResult = Apollo.QueryResult<GetProjectByIdWithoutPricingDataQuery, GetProjectByIdWithoutPricingDataQueryVariables>;
export const GetAvailableDeliveryDueDatesDocument = gql`
    query getAvailableDeliveryDueDates($projectId: ID!) {
  availableDeliveryDueDates(projectId: $projectId) {
    days
    dueDate
    expressDueDays
  }
}
    `;

/**
 * __useGetAvailableDeliveryDueDatesQuery__
 *
 * To run a query within a React component, call `useGetAvailableDeliveryDueDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableDeliveryDueDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableDeliveryDueDatesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetAvailableDeliveryDueDatesQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableDeliveryDueDatesQuery, GetAvailableDeliveryDueDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableDeliveryDueDatesQuery, GetAvailableDeliveryDueDatesQueryVariables>(GetAvailableDeliveryDueDatesDocument, options);
      }
export function useGetAvailableDeliveryDueDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableDeliveryDueDatesQuery, GetAvailableDeliveryDueDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableDeliveryDueDatesQuery, GetAvailableDeliveryDueDatesQueryVariables>(GetAvailableDeliveryDueDatesDocument, options);
        }
export type GetAvailableDeliveryDueDatesQueryHookResult = ReturnType<typeof useGetAvailableDeliveryDueDatesQuery>;
export type GetAvailableDeliveryDueDatesLazyQueryHookResult = ReturnType<typeof useGetAvailableDeliveryDueDatesLazyQuery>;
export type GetAvailableDeliveryDueDatesQueryResult = Apollo.QueryResult<GetAvailableDeliveryDueDatesQuery, GetAvailableDeliveryDueDatesQueryVariables>;
export const CreateProjectAsDraftDocument = gql`
    mutation createProjectAsDraft($title: String!, $matchingFormat: MatchingFormat!, $organizationId: ID!, $projectTypeId: ID!, $creationSet: CreationSetInput, $creativeBriefDefinitionId: ID!, $creativeBriefValues: DynamicSchemaValuesInput, $assetCategoryDefinitionId: ID!, $assetCategoryValues: DynamicSchemaValuesInput, $parentProjectId: ID, $designInspirationCaseId: ID) {
  createProjectAsDraft(
    title: $title
    matchingFormat: $matchingFormat
    organization: $organizationId
    projectType: $projectTypeId
    creationSet: $creationSet
    creativeBriefDefinition: $creativeBriefDefinitionId
    creativeBriefValues: $creativeBriefValues
    assetCategoryDefinition: $assetCategoryDefinitionId
    assetCategoryValues: $assetCategoryValues
    parent: $parentProjectId
    designInspirationCaseId: $designInspirationCaseId
  ) {
    id
  }
}
    `;
export type CreateProjectAsDraftMutationFn = Apollo.MutationFunction<CreateProjectAsDraftMutation, CreateProjectAsDraftMutationVariables>;

/**
 * __useCreateProjectAsDraftMutation__
 *
 * To run a mutation, you first call `useCreateProjectAsDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectAsDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectAsDraftMutation, { data, loading, error }] = useCreateProjectAsDraftMutation({
 *   variables: {
 *      title: // value for 'title'
 *      matchingFormat: // value for 'matchingFormat'
 *      organizationId: // value for 'organizationId'
 *      projectTypeId: // value for 'projectTypeId'
 *      creationSet: // value for 'creationSet'
 *      creativeBriefDefinitionId: // value for 'creativeBriefDefinitionId'
 *      creativeBriefValues: // value for 'creativeBriefValues'
 *      assetCategoryDefinitionId: // value for 'assetCategoryDefinitionId'
 *      assetCategoryValues: // value for 'assetCategoryValues'
 *      parentProjectId: // value for 'parentProjectId'
 *      designInspirationCaseId: // value for 'designInspirationCaseId'
 *   },
 * });
 */
export function useCreateProjectAsDraftMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectAsDraftMutation, CreateProjectAsDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectAsDraftMutation, CreateProjectAsDraftMutationVariables>(CreateProjectAsDraftDocument, options);
      }
export type CreateProjectAsDraftMutationHookResult = ReturnType<typeof useCreateProjectAsDraftMutation>;
export type CreateProjectAsDraftMutationResult = Apollo.MutationResult<CreateProjectAsDraftMutation>;
export type CreateProjectAsDraftMutationOptions = Apollo.BaseMutationOptions<CreateProjectAsDraftMutation, CreateProjectAsDraftMutationVariables>;
export const UpdateDraftProjectDocument = gql`
    mutation updateDraftProject($id: ID!, $title: String!, $matchingFormat: MatchingFormat!, $creationSet: CreationSetInput, $creativeBriefValues: DynamicSchemaValuesInput, $assetCategoryValues: DynamicSchemaValuesInput, $designInspirationCaseId: ID, $selectedPricingMerchandiseOptionIds: [ID!]) {
  updateProjectAsDraft(
    id: $id
    title: $title
    matchingFormat: $matchingFormat
    creationSet: $creationSet
    creativeBriefValues: $creativeBriefValues
    assetCategoryValues: $assetCategoryValues
    designInspirationCaseId: $designInspirationCaseId
    selectedPricingMerchandiseOptionIds: $selectedPricingMerchandiseOptionIds
  ) {
    ...ProjectDetails
  }
}
    ${ProjectDetailsFragmentDoc}`;
export type UpdateDraftProjectMutationFn = Apollo.MutationFunction<UpdateDraftProjectMutation, UpdateDraftProjectMutationVariables>;

/**
 * __useUpdateDraftProjectMutation__
 *
 * To run a mutation, you first call `useUpdateDraftProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDraftProjectMutation, { data, loading, error }] = useUpdateDraftProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      matchingFormat: // value for 'matchingFormat'
 *      creationSet: // value for 'creationSet'
 *      creativeBriefValues: // value for 'creativeBriefValues'
 *      assetCategoryValues: // value for 'assetCategoryValues'
 *      designInspirationCaseId: // value for 'designInspirationCaseId'
 *      selectedPricingMerchandiseOptionIds: // value for 'selectedPricingMerchandiseOptionIds'
 *   },
 * });
 */
export function useUpdateDraftProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDraftProjectMutation, UpdateDraftProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDraftProjectMutation, UpdateDraftProjectMutationVariables>(UpdateDraftProjectDocument, options);
      }
export type UpdateDraftProjectMutationHookResult = ReturnType<typeof useUpdateDraftProjectMutation>;
export type UpdateDraftProjectMutationResult = Apollo.MutationResult<UpdateDraftProjectMutation>;
export type UpdateDraftProjectMutationOptions = Apollo.BaseMutationOptions<UpdateDraftProjectMutation, UpdateDraftProjectMutationVariables>;
export const UpdateProjectAssetCategoryValueDocument = gql`
    mutation updateProjectAssetCategoryValue($id: ID!, $assetCategoryValues: DynamicSchemaValuesInput) {
  updateProjectAsDraft(id: $id, assetCategoryValues: $assetCategoryValues) {
    id
  }
}
    `;
export type UpdateProjectAssetCategoryValueMutationFn = Apollo.MutationFunction<UpdateProjectAssetCategoryValueMutation, UpdateProjectAssetCategoryValueMutationVariables>;

/**
 * __useUpdateProjectAssetCategoryValueMutation__
 *
 * To run a mutation, you first call `useUpdateProjectAssetCategoryValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectAssetCategoryValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectAssetCategoryValueMutation, { data, loading, error }] = useUpdateProjectAssetCategoryValueMutation({
 *   variables: {
 *      id: // value for 'id'
 *      assetCategoryValues: // value for 'assetCategoryValues'
 *   },
 * });
 */
export function useUpdateProjectAssetCategoryValueMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectAssetCategoryValueMutation, UpdateProjectAssetCategoryValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectAssetCategoryValueMutation, UpdateProjectAssetCategoryValueMutationVariables>(UpdateProjectAssetCategoryValueDocument, options);
      }
export type UpdateProjectAssetCategoryValueMutationHookResult = ReturnType<typeof useUpdateProjectAssetCategoryValueMutation>;
export type UpdateProjectAssetCategoryValueMutationResult = Apollo.MutationResult<UpdateProjectAssetCategoryValueMutation>;
export type UpdateProjectAssetCategoryValueMutationOptions = Apollo.BaseMutationOptions<UpdateProjectAssetCategoryValueMutation, UpdateProjectAssetCategoryValueMutationVariables>;
export const SubmitProjectDocument = gql`
    mutation submitProject($id: ID!, $code: String, $agreedWithCreativeVisibility: Boolean!) {
  submitProject(
    id: $id
    code: $code
    agreedWithCreativeVisibility: $agreedWithCreativeVisibility
  ) {
    ...ProjectDetails
  }
}
    ${ProjectDetailsFragmentDoc}`;
export type SubmitProjectMutationFn = Apollo.MutationFunction<SubmitProjectMutation, SubmitProjectMutationVariables>;

/**
 * __useSubmitProjectMutation__
 *
 * To run a mutation, you first call `useSubmitProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitProjectMutation, { data, loading, error }] = useSubmitProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      code: // value for 'code'
 *      agreedWithCreativeVisibility: // value for 'agreedWithCreativeVisibility'
 *   },
 * });
 */
export function useSubmitProjectMutation(baseOptions?: Apollo.MutationHookOptions<SubmitProjectMutation, SubmitProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitProjectMutation, SubmitProjectMutationVariables>(SubmitProjectDocument, options);
      }
export type SubmitProjectMutationHookResult = ReturnType<typeof useSubmitProjectMutation>;
export type SubmitProjectMutationResult = Apollo.MutationResult<SubmitProjectMutation>;
export type SubmitProjectMutationOptions = Apollo.BaseMutationOptions<SubmitProjectMutation, SubmitProjectMutationVariables>;
export const UpdateProjectDocument = gql`
    mutation updateProject($id: ID!, $versionId: ID!, $title: String!, $creativeBriefValues: DynamicSchemaValuesInput, $assetCategoryValues: DynamicSchemaValuesInput) {
  updateProject(
    id: $id
    versionId: $versionId
    title: $title
    creativeBriefValues: $creativeBriefValues
    assetCategoryValues: $assetCategoryValues
  ) {
    updated
    project {
      ...ProjectDetails
    }
  }
}
    ${ProjectDetailsFragmentDoc}`;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *      title: // value for 'title'
 *      creativeBriefValues: // value for 'creativeBriefValues'
 *      assetCategoryValues: // value for 'assetCategoryValues'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const GetCreationSetByIdDocument = gql`
    query getCreationSetById($creationSetId: ID!) {
  creationSet(id: $creationSetId) {
    ...SingleCreationSet
  }
}
    ${SingleCreationSetFragmentDoc}`;

/**
 * __useGetCreationSetByIdQuery__
 *
 * To run a query within a React component, call `useGetCreationSetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreationSetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreationSetByIdQuery({
 *   variables: {
 *      creationSetId: // value for 'creationSetId'
 *   },
 * });
 */
export function useGetCreationSetByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCreationSetByIdQuery, GetCreationSetByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreationSetByIdQuery, GetCreationSetByIdQueryVariables>(GetCreationSetByIdDocument, options);
      }
export function useGetCreationSetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreationSetByIdQuery, GetCreationSetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreationSetByIdQuery, GetCreationSetByIdQueryVariables>(GetCreationSetByIdDocument, options);
        }
export type GetCreationSetByIdQueryHookResult = ReturnType<typeof useGetCreationSetByIdQuery>;
export type GetCreationSetByIdLazyQueryHookResult = ReturnType<typeof useGetCreationSetByIdLazyQuery>;
export type GetCreationSetByIdQueryResult = Apollo.QueryResult<GetCreationSetByIdQuery, GetCreationSetByIdQueryVariables>;
export const GetCreationByIdDocument = gql`
    query getCreationById($creationId: ID!) {
  creation(id: $creationId) {
    ...CreationDetail
  }
}
    ${CreationDetailFragmentDoc}`;

/**
 * __useGetCreationByIdQuery__
 *
 * To run a query within a React component, call `useGetCreationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreationByIdQuery({
 *   variables: {
 *      creationId: // value for 'creationId'
 *   },
 * });
 */
export function useGetCreationByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCreationByIdQuery, GetCreationByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreationByIdQuery, GetCreationByIdQueryVariables>(GetCreationByIdDocument, options);
      }
export function useGetCreationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreationByIdQuery, GetCreationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreationByIdQuery, GetCreationByIdQueryVariables>(GetCreationByIdDocument, options);
        }
export type GetCreationByIdQueryHookResult = ReturnType<typeof useGetCreationByIdQuery>;
export type GetCreationByIdLazyQueryHookResult = ReturnType<typeof useGetCreationByIdLazyQuery>;
export type GetCreationByIdQueryResult = Apollo.QueryResult<GetCreationByIdQuery, GetCreationByIdQueryVariables>;
export const CreateModificationRequestAsDraftDocument = gql`
    mutation createModificationRequestAsDraft($targetDeliverableId: ID!) {
  createModificationRequestAsDraft(targetDeliverableId: $targetDeliverableId) {
    ...ModificationRequestForDetail
  }
}
    ${ModificationRequestForDetailFragmentDoc}`;
export type CreateModificationRequestAsDraftMutationFn = Apollo.MutationFunction<CreateModificationRequestAsDraftMutation, CreateModificationRequestAsDraftMutationVariables>;

/**
 * __useCreateModificationRequestAsDraftMutation__
 *
 * To run a mutation, you first call `useCreateModificationRequestAsDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModificationRequestAsDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModificationRequestAsDraftMutation, { data, loading, error }] = useCreateModificationRequestAsDraftMutation({
 *   variables: {
 *      targetDeliverableId: // value for 'targetDeliverableId'
 *   },
 * });
 */
export function useCreateModificationRequestAsDraftMutation(baseOptions?: Apollo.MutationHookOptions<CreateModificationRequestAsDraftMutation, CreateModificationRequestAsDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateModificationRequestAsDraftMutation, CreateModificationRequestAsDraftMutationVariables>(CreateModificationRequestAsDraftDocument, options);
      }
export type CreateModificationRequestAsDraftMutationHookResult = ReturnType<typeof useCreateModificationRequestAsDraftMutation>;
export type CreateModificationRequestAsDraftMutationResult = Apollo.MutationResult<CreateModificationRequestAsDraftMutation>;
export type CreateModificationRequestAsDraftMutationOptions = Apollo.BaseMutationOptions<CreateModificationRequestAsDraftMutation, CreateModificationRequestAsDraftMutationVariables>;
export const SubmitModificationRequestDocument = gql`
    mutation submitModificationRequest($modificationRequestId: ID!, $feeType: ModificationRequestFeeType) {
  submitModificationRequest(
    modificationRequestId: $modificationRequestId
    feeType: $feeType
  ) {
    ...ModificationRequestForDetail
  }
}
    ${ModificationRequestForDetailFragmentDoc}`;
export type SubmitModificationRequestMutationFn = Apollo.MutationFunction<SubmitModificationRequestMutation, SubmitModificationRequestMutationVariables>;

/**
 * __useSubmitModificationRequestMutation__
 *
 * To run a mutation, you first call `useSubmitModificationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitModificationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitModificationRequestMutation, { data, loading, error }] = useSubmitModificationRequestMutation({
 *   variables: {
 *      modificationRequestId: // value for 'modificationRequestId'
 *      feeType: // value for 'feeType'
 *   },
 * });
 */
export function useSubmitModificationRequestMutation(baseOptions?: Apollo.MutationHookOptions<SubmitModificationRequestMutation, SubmitModificationRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitModificationRequestMutation, SubmitModificationRequestMutationVariables>(SubmitModificationRequestDocument, options);
      }
export type SubmitModificationRequestMutationHookResult = ReturnType<typeof useSubmitModificationRequestMutation>;
export type SubmitModificationRequestMutationResult = Apollo.MutationResult<SubmitModificationRequestMutation>;
export type SubmitModificationRequestMutationOptions = Apollo.BaseMutationOptions<SubmitModificationRequestMutation, SubmitModificationRequestMutationVariables>;
export const CancelCreatingDraftModificationRequestDocument = gql`
    mutation cancelCreatingDraftModificationRequest($modificationRequestId: ID!) {
  cancelCreatingDraftModificationRequest(
    modificationRequestId: $modificationRequestId
  ) {
    ...CreationDetail
  }
}
    ${CreationDetailFragmentDoc}`;
export type CancelCreatingDraftModificationRequestMutationFn = Apollo.MutationFunction<CancelCreatingDraftModificationRequestMutation, CancelCreatingDraftModificationRequestMutationVariables>;

/**
 * __useCancelCreatingDraftModificationRequestMutation__
 *
 * To run a mutation, you first call `useCancelCreatingDraftModificationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelCreatingDraftModificationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelCreatingDraftModificationRequestMutation, { data, loading, error }] = useCancelCreatingDraftModificationRequestMutation({
 *   variables: {
 *      modificationRequestId: // value for 'modificationRequestId'
 *   },
 * });
 */
export function useCancelCreatingDraftModificationRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelCreatingDraftModificationRequestMutation, CancelCreatingDraftModificationRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelCreatingDraftModificationRequestMutation, CancelCreatingDraftModificationRequestMutationVariables>(CancelCreatingDraftModificationRequestDocument, options);
      }
export type CancelCreatingDraftModificationRequestMutationHookResult = ReturnType<typeof useCancelCreatingDraftModificationRequestMutation>;
export type CancelCreatingDraftModificationRequestMutationResult = Apollo.MutationResult<CancelCreatingDraftModificationRequestMutation>;
export type CancelCreatingDraftModificationRequestMutationOptions = Apollo.BaseMutationOptions<CancelCreatingDraftModificationRequestMutation, CancelCreatingDraftModificationRequestMutationVariables>;
export const CreateModificationRequestItemDocument = gql`
    mutation createModificationRequestItem($modificationRequestId: ID!, $body: ModificationRequestItemsInput!) {
  createModificationRequestItem(
    modificationRequestId: $modificationRequestId
    body: $body
  ) {
    ...ModificationRequestItemForDetail
  }
}
    ${ModificationRequestItemForDetailFragmentDoc}`;
export type CreateModificationRequestItemMutationFn = Apollo.MutationFunction<CreateModificationRequestItemMutation, CreateModificationRequestItemMutationVariables>;

/**
 * __useCreateModificationRequestItemMutation__
 *
 * To run a mutation, you first call `useCreateModificationRequestItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModificationRequestItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModificationRequestItemMutation, { data, loading, error }] = useCreateModificationRequestItemMutation({
 *   variables: {
 *      modificationRequestId: // value for 'modificationRequestId'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCreateModificationRequestItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateModificationRequestItemMutation, CreateModificationRequestItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateModificationRequestItemMutation, CreateModificationRequestItemMutationVariables>(CreateModificationRequestItemDocument, options);
      }
export type CreateModificationRequestItemMutationHookResult = ReturnType<typeof useCreateModificationRequestItemMutation>;
export type CreateModificationRequestItemMutationResult = Apollo.MutationResult<CreateModificationRequestItemMutation>;
export type CreateModificationRequestItemMutationOptions = Apollo.BaseMutationOptions<CreateModificationRequestItemMutation, CreateModificationRequestItemMutationVariables>;
export const EditModificationRequestItemDocument = gql`
    mutation editModificationRequestItem($modificationRequestItemId: ID!, $body: ModificationRequestItemsInput!) {
  editModificationRequestItem(
    modificationRequestItemId: $modificationRequestItemId
    body: $body
  ) {
    ...ModificationRequestItemForDetail
  }
}
    ${ModificationRequestItemForDetailFragmentDoc}`;
export type EditModificationRequestItemMutationFn = Apollo.MutationFunction<EditModificationRequestItemMutation, EditModificationRequestItemMutationVariables>;

/**
 * __useEditModificationRequestItemMutation__
 *
 * To run a mutation, you first call `useEditModificationRequestItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditModificationRequestItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editModificationRequestItemMutation, { data, loading, error }] = useEditModificationRequestItemMutation({
 *   variables: {
 *      modificationRequestItemId: // value for 'modificationRequestItemId'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useEditModificationRequestItemMutation(baseOptions?: Apollo.MutationHookOptions<EditModificationRequestItemMutation, EditModificationRequestItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditModificationRequestItemMutation, EditModificationRequestItemMutationVariables>(EditModificationRequestItemDocument, options);
      }
export type EditModificationRequestItemMutationHookResult = ReturnType<typeof useEditModificationRequestItemMutation>;
export type EditModificationRequestItemMutationResult = Apollo.MutationResult<EditModificationRequestItemMutation>;
export type EditModificationRequestItemMutationOptions = Apollo.BaseMutationOptions<EditModificationRequestItemMutation, EditModificationRequestItemMutationVariables>;
export const DeleteModificationRequestItemDocument = gql`
    mutation deleteModificationRequestItem($modificationRequestItemId: ID!) {
  deleteModificationRequestItem(
    modificationRequestItemId: $modificationRequestItemId
  ) {
    ...ModificationRequestForDetail
  }
}
    ${ModificationRequestForDetailFragmentDoc}`;
export type DeleteModificationRequestItemMutationFn = Apollo.MutationFunction<DeleteModificationRequestItemMutation, DeleteModificationRequestItemMutationVariables>;

/**
 * __useDeleteModificationRequestItemMutation__
 *
 * To run a mutation, you first call `useDeleteModificationRequestItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModificationRequestItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModificationRequestItemMutation, { data, loading, error }] = useDeleteModificationRequestItemMutation({
 *   variables: {
 *      modificationRequestItemId: // value for 'modificationRequestItemId'
 *   },
 * });
 */
export function useDeleteModificationRequestItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteModificationRequestItemMutation, DeleteModificationRequestItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteModificationRequestItemMutation, DeleteModificationRequestItemMutationVariables>(DeleteModificationRequestItemDocument, options);
      }
export type DeleteModificationRequestItemMutationHookResult = ReturnType<typeof useDeleteModificationRequestItemMutation>;
export type DeleteModificationRequestItemMutationResult = Apollo.MutationResult<DeleteModificationRequestItemMutation>;
export type DeleteModificationRequestItemMutationOptions = Apollo.BaseMutationOptions<DeleteModificationRequestItemMutation, DeleteModificationRequestItemMutationVariables>;
export const AddModificationRequestItemAssetDocument = gql`
    mutation addModificationRequestItemAsset($modificationRequestItemId: ID!, $assetId: String!) {
  addModificationRequestItemAsset(
    modificationRequestItemId: $modificationRequestItemId
    assetId: $assetId
  )
}
    `;
export type AddModificationRequestItemAssetMutationFn = Apollo.MutationFunction<AddModificationRequestItemAssetMutation, AddModificationRequestItemAssetMutationVariables>;

/**
 * __useAddModificationRequestItemAssetMutation__
 *
 * To run a mutation, you first call `useAddModificationRequestItemAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddModificationRequestItemAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addModificationRequestItemAssetMutation, { data, loading, error }] = useAddModificationRequestItemAssetMutation({
 *   variables: {
 *      modificationRequestItemId: // value for 'modificationRequestItemId'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useAddModificationRequestItemAssetMutation(baseOptions?: Apollo.MutationHookOptions<AddModificationRequestItemAssetMutation, AddModificationRequestItemAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddModificationRequestItemAssetMutation, AddModificationRequestItemAssetMutationVariables>(AddModificationRequestItemAssetDocument, options);
      }
export type AddModificationRequestItemAssetMutationHookResult = ReturnType<typeof useAddModificationRequestItemAssetMutation>;
export type AddModificationRequestItemAssetMutationResult = Apollo.MutationResult<AddModificationRequestItemAssetMutation>;
export type AddModificationRequestItemAssetMutationOptions = Apollo.BaseMutationOptions<AddModificationRequestItemAssetMutation, AddModificationRequestItemAssetMutationVariables>;
export const DeleteModificationRequestItemAssetsDocument = gql`
    mutation deleteModificationRequestItemAssets($modificationRequestItemId: ID!, $assetIds: [String!]!) {
  deleteModificationRequestItemAssets(
    modificationRequestItemId: $modificationRequestItemId
    assetIds: $assetIds
  )
}
    `;
export type DeleteModificationRequestItemAssetsMutationFn = Apollo.MutationFunction<DeleteModificationRequestItemAssetsMutation, DeleteModificationRequestItemAssetsMutationVariables>;

/**
 * __useDeleteModificationRequestItemAssetsMutation__
 *
 * To run a mutation, you first call `useDeleteModificationRequestItemAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModificationRequestItemAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModificationRequestItemAssetsMutation, { data, loading, error }] = useDeleteModificationRequestItemAssetsMutation({
 *   variables: {
 *      modificationRequestItemId: // value for 'modificationRequestItemId'
 *      assetIds: // value for 'assetIds'
 *   },
 * });
 */
export function useDeleteModificationRequestItemAssetsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteModificationRequestItemAssetsMutation, DeleteModificationRequestItemAssetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteModificationRequestItemAssetsMutation, DeleteModificationRequestItemAssetsMutationVariables>(DeleteModificationRequestItemAssetsDocument, options);
      }
export type DeleteModificationRequestItemAssetsMutationHookResult = ReturnType<typeof useDeleteModificationRequestItemAssetsMutation>;
export type DeleteModificationRequestItemAssetsMutationResult = Apollo.MutationResult<DeleteModificationRequestItemAssetsMutation>;
export type DeleteModificationRequestItemAssetsMutationOptions = Apollo.BaseMutationOptions<DeleteModificationRequestItemAssetsMutation, DeleteModificationRequestItemAssetsMutationVariables>;
export const CreateModificationRequestItemIssueDocument = gql`
    mutation createModificationRequestItemIssue($modificationRequestItemId: ID!, $name: String!, $body: String!, $bucketId: String, $assetIds: [String!]!) {
  createModificationRequestItemIssue(
    modificationRequestItemId: $modificationRequestItemId
    name: $name
    body: $body
    bucketId: $bucketId
    assetIds: $assetIds
  ) {
    ...ModificationRequestItemIssueForDetail
  }
}
    ${ModificationRequestItemIssueForDetailFragmentDoc}`;
export type CreateModificationRequestItemIssueMutationFn = Apollo.MutationFunction<CreateModificationRequestItemIssueMutation, CreateModificationRequestItemIssueMutationVariables>;

/**
 * __useCreateModificationRequestItemIssueMutation__
 *
 * To run a mutation, you first call `useCreateModificationRequestItemIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModificationRequestItemIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModificationRequestItemIssueMutation, { data, loading, error }] = useCreateModificationRequestItemIssueMutation({
 *   variables: {
 *      modificationRequestItemId: // value for 'modificationRequestItemId'
 *      name: // value for 'name'
 *      body: // value for 'body'
 *      bucketId: // value for 'bucketId'
 *      assetIds: // value for 'assetIds'
 *   },
 * });
 */
export function useCreateModificationRequestItemIssueMutation(baseOptions?: Apollo.MutationHookOptions<CreateModificationRequestItemIssueMutation, CreateModificationRequestItemIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateModificationRequestItemIssueMutation, CreateModificationRequestItemIssueMutationVariables>(CreateModificationRequestItemIssueDocument, options);
      }
export type CreateModificationRequestItemIssueMutationHookResult = ReturnType<typeof useCreateModificationRequestItemIssueMutation>;
export type CreateModificationRequestItemIssueMutationResult = Apollo.MutationResult<CreateModificationRequestItemIssueMutation>;
export type CreateModificationRequestItemIssueMutationOptions = Apollo.BaseMutationOptions<CreateModificationRequestItemIssueMutation, CreateModificationRequestItemIssueMutationVariables>;
export const CreateModificationRequestItemIssueCommentDocument = gql`
    mutation createModificationRequestItemIssueComment($issueId: ID!, $body: String!, $bucketId: String, $assetIds: [String!]!) {
  createModificationRequestItemIssueComment(
    issueId: $issueId
    body: $body
    bucketId: $bucketId
    assetIds: $assetIds
  ) {
    ...ModificationRequestItemIssueCommentForDetail
  }
}
    ${ModificationRequestItemIssueCommentForDetailFragmentDoc}`;
export type CreateModificationRequestItemIssueCommentMutationFn = Apollo.MutationFunction<CreateModificationRequestItemIssueCommentMutation, CreateModificationRequestItemIssueCommentMutationVariables>;

/**
 * __useCreateModificationRequestItemIssueCommentMutation__
 *
 * To run a mutation, you first call `useCreateModificationRequestItemIssueCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModificationRequestItemIssueCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModificationRequestItemIssueCommentMutation, { data, loading, error }] = useCreateModificationRequestItemIssueCommentMutation({
 *   variables: {
 *      issueId: // value for 'issueId'
 *      body: // value for 'body'
 *      bucketId: // value for 'bucketId'
 *      assetIds: // value for 'assetIds'
 *   },
 * });
 */
export function useCreateModificationRequestItemIssueCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateModificationRequestItemIssueCommentMutation, CreateModificationRequestItemIssueCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateModificationRequestItemIssueCommentMutation, CreateModificationRequestItemIssueCommentMutationVariables>(CreateModificationRequestItemIssueCommentDocument, options);
      }
export type CreateModificationRequestItemIssueCommentMutationHookResult = ReturnType<typeof useCreateModificationRequestItemIssueCommentMutation>;
export type CreateModificationRequestItemIssueCommentMutationResult = Apollo.MutationResult<CreateModificationRequestItemIssueCommentMutation>;
export type CreateModificationRequestItemIssueCommentMutationOptions = Apollo.BaseMutationOptions<CreateModificationRequestItemIssueCommentMutation, CreateModificationRequestItemIssueCommentMutationVariables>;
export const ResolveModificationRequestIssueDocument = gql`
    mutation resolveModificationRequestIssue($issueId: ID!) {
  resolveModificationRequestIssue(issueId: $issueId)
}
    `;
export type ResolveModificationRequestIssueMutationFn = Apollo.MutationFunction<ResolveModificationRequestIssueMutation, ResolveModificationRequestIssueMutationVariables>;

/**
 * __useResolveModificationRequestIssueMutation__
 *
 * To run a mutation, you first call `useResolveModificationRequestIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveModificationRequestIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveModificationRequestIssueMutation, { data, loading, error }] = useResolveModificationRequestIssueMutation({
 *   variables: {
 *      issueId: // value for 'issueId'
 *   },
 * });
 */
export function useResolveModificationRequestIssueMutation(baseOptions?: Apollo.MutationHookOptions<ResolveModificationRequestIssueMutation, ResolveModificationRequestIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveModificationRequestIssueMutation, ResolveModificationRequestIssueMutationVariables>(ResolveModificationRequestIssueDocument, options);
      }
export type ResolveModificationRequestIssueMutationHookResult = ReturnType<typeof useResolveModificationRequestIssueMutation>;
export type ResolveModificationRequestIssueMutationResult = Apollo.MutationResult<ResolveModificationRequestIssueMutation>;
export type ResolveModificationRequestIssueMutationOptions = Apollo.BaseMutationOptions<ResolveModificationRequestIssueMutation, ResolveModificationRequestIssueMutationVariables>;
export const ReopenModificationRequestIssueDocument = gql`
    mutation reopenModificationRequestIssue($issueId: ID!) {
  reopenModificationRequestIssue(issueId: $issueId) {
    ...ModificationRequestItemIssueForDetail
  }
}
    ${ModificationRequestItemIssueForDetailFragmentDoc}`;
export type ReopenModificationRequestIssueMutationFn = Apollo.MutationFunction<ReopenModificationRequestIssueMutation, ReopenModificationRequestIssueMutationVariables>;

/**
 * __useReopenModificationRequestIssueMutation__
 *
 * To run a mutation, you first call `useReopenModificationRequestIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenModificationRequestIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenModificationRequestIssueMutation, { data, loading, error }] = useReopenModificationRequestIssueMutation({
 *   variables: {
 *      issueId: // value for 'issueId'
 *   },
 * });
 */
export function useReopenModificationRequestIssueMutation(baseOptions?: Apollo.MutationHookOptions<ReopenModificationRequestIssueMutation, ReopenModificationRequestIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReopenModificationRequestIssueMutation, ReopenModificationRequestIssueMutationVariables>(ReopenModificationRequestIssueDocument, options);
      }
export type ReopenModificationRequestIssueMutationHookResult = ReturnType<typeof useReopenModificationRequestIssueMutation>;
export type ReopenModificationRequestIssueMutationResult = Apollo.MutationResult<ReopenModificationRequestIssueMutation>;
export type ReopenModificationRequestIssueMutationOptions = Apollo.BaseMutationOptions<ReopenModificationRequestIssueMutation, ReopenModificationRequestIssueMutationVariables>;
export const ApproveModificationRequestDocument = gql`
    mutation approveModificationRequest($modificationRequestId: ID!) {
  approveModificationRequest(modificationRequestId: $modificationRequestId) {
    ...ModificationRequestForDetail
  }
}
    ${ModificationRequestForDetailFragmentDoc}`;
export type ApproveModificationRequestMutationFn = Apollo.MutationFunction<ApproveModificationRequestMutation, ApproveModificationRequestMutationVariables>;

/**
 * __useApproveModificationRequestMutation__
 *
 * To run a mutation, you first call `useApproveModificationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveModificationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveModificationRequestMutation, { data, loading, error }] = useApproveModificationRequestMutation({
 *   variables: {
 *      modificationRequestId: // value for 'modificationRequestId'
 *   },
 * });
 */
export function useApproveModificationRequestMutation(baseOptions?: Apollo.MutationHookOptions<ApproveModificationRequestMutation, ApproveModificationRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveModificationRequestMutation, ApproveModificationRequestMutationVariables>(ApproveModificationRequestDocument, options);
      }
export type ApproveModificationRequestMutationHookResult = ReturnType<typeof useApproveModificationRequestMutation>;
export type ApproveModificationRequestMutationResult = Apollo.MutationResult<ApproveModificationRequestMutation>;
export type ApproveModificationRequestMutationOptions = Apollo.BaseMutationOptions<ApproveModificationRequestMutation, ApproveModificationRequestMutationVariables>;
export const GetOrganizationByIdDocument = gql`
    query getOrganizationById($id: ID!) {
  organization(id: $id) {
    ...OrganizationDetail
  }
}
    ${OrganizationDetailFragmentDoc}`;

/**
 * __useGetOrganizationByIdQuery__
 *
 * To run a query within a React component, call `useGetOrganizationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationByIdQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>(GetOrganizationByIdDocument, options);
      }
export function useGetOrganizationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>(GetOrganizationByIdDocument, options);
        }
export type GetOrganizationByIdQueryHookResult = ReturnType<typeof useGetOrganizationByIdQuery>;
export type GetOrganizationByIdLazyQueryHookResult = ReturnType<typeof useGetOrganizationByIdLazyQuery>;
export type GetOrganizationByIdQueryResult = Apollo.QueryResult<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>;
export const GetDailySummaryPerformanceDocument = gql`
    query getDailySummaryPerformance($reportId: ID!, $request: PerformanceReportSummaryRequest!) {
  dailySummaryPerformance(reportId: $reportId, request: $request) {
    ...DailySummaryPerformanceWithAllFields
  }
}
    ${DailySummaryPerformanceWithAllFieldsFragmentDoc}`;

/**
 * __useGetDailySummaryPerformanceQuery__
 *
 * To run a query within a React component, call `useGetDailySummaryPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailySummaryPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailySummaryPerformanceQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      request: // value for 'request'
 *   },
 * });
 */
export function useGetDailySummaryPerformanceQuery(baseOptions: Apollo.QueryHookOptions<GetDailySummaryPerformanceQuery, GetDailySummaryPerformanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailySummaryPerformanceQuery, GetDailySummaryPerformanceQueryVariables>(GetDailySummaryPerformanceDocument, options);
      }
export function useGetDailySummaryPerformanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailySummaryPerformanceQuery, GetDailySummaryPerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailySummaryPerformanceQuery, GetDailySummaryPerformanceQueryVariables>(GetDailySummaryPerformanceDocument, options);
        }
export type GetDailySummaryPerformanceQueryHookResult = ReturnType<typeof useGetDailySummaryPerformanceQuery>;
export type GetDailySummaryPerformanceLazyQueryHookResult = ReturnType<typeof useGetDailySummaryPerformanceLazyQuery>;
export type GetDailySummaryPerformanceQueryResult = Apollo.QueryResult<GetDailySummaryPerformanceQuery, GetDailySummaryPerformanceQueryVariables>;
export const GetPeriodicDetailPerformanceDocument = gql`
    query getPeriodicDetailPerformance($reportId: ID!, $request: PerformanceReportDetailRequest!) {
  periodicDetailPerformance(reportId: $reportId, request: $request) {
    ...PeriodicDetailPerformanceWithAllFields
  }
}
    ${PeriodicDetailPerformanceWithAllFieldsFragmentDoc}`;

/**
 * __useGetPeriodicDetailPerformanceQuery__
 *
 * To run a query within a React component, call `useGetPeriodicDetailPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPeriodicDetailPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPeriodicDetailPerformanceQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      request: // value for 'request'
 *   },
 * });
 */
export function useGetPeriodicDetailPerformanceQuery(baseOptions: Apollo.QueryHookOptions<GetPeriodicDetailPerformanceQuery, GetPeriodicDetailPerformanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPeriodicDetailPerformanceQuery, GetPeriodicDetailPerformanceQueryVariables>(GetPeriodicDetailPerformanceDocument, options);
      }
export function useGetPeriodicDetailPerformanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPeriodicDetailPerformanceQuery, GetPeriodicDetailPerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPeriodicDetailPerformanceQuery, GetPeriodicDetailPerformanceQueryVariables>(GetPeriodicDetailPerformanceDocument, options);
        }
export type GetPeriodicDetailPerformanceQueryHookResult = ReturnType<typeof useGetPeriodicDetailPerformanceQuery>;
export type GetPeriodicDetailPerformanceLazyQueryHookResult = ReturnType<typeof useGetPeriodicDetailPerformanceLazyQuery>;
export type GetPeriodicDetailPerformanceQueryResult = Apollo.QueryResult<GetPeriodicDetailPerformanceQuery, GetPeriodicDetailPerformanceQueryVariables>;
export const GetPeriodicImprovementPerformanceDocument = gql`
    query getPeriodicImprovementPerformance($reportId: ID!, $request: PerformanceReportImprovementRequest!) {
  periodicImprovementPerformance(reportId: $reportId, request: $request) {
    ...PeriodicImprovementPerformanceWithAllFields
  }
}
    ${PeriodicImprovementPerformanceWithAllFieldsFragmentDoc}`;

/**
 * __useGetPeriodicImprovementPerformanceQuery__
 *
 * To run a query within a React component, call `useGetPeriodicImprovementPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPeriodicImprovementPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPeriodicImprovementPerformanceQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      request: // value for 'request'
 *   },
 * });
 */
export function useGetPeriodicImprovementPerformanceQuery(baseOptions: Apollo.QueryHookOptions<GetPeriodicImprovementPerformanceQuery, GetPeriodicImprovementPerformanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPeriodicImprovementPerformanceQuery, GetPeriodicImprovementPerformanceQueryVariables>(GetPeriodicImprovementPerformanceDocument, options);
      }
export function useGetPeriodicImprovementPerformanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPeriodicImprovementPerformanceQuery, GetPeriodicImprovementPerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPeriodicImprovementPerformanceQuery, GetPeriodicImprovementPerformanceQueryVariables>(GetPeriodicImprovementPerformanceDocument, options);
        }
export type GetPeriodicImprovementPerformanceQueryHookResult = ReturnType<typeof useGetPeriodicImprovementPerformanceQuery>;
export type GetPeriodicImprovementPerformanceLazyQueryHookResult = ReturnType<typeof useGetPeriodicImprovementPerformanceLazyQuery>;
export type GetPeriodicImprovementPerformanceQueryResult = Apollo.QueryResult<GetPeriodicImprovementPerformanceQuery, GetPeriodicImprovementPerformanceQueryVariables>;
export const GetProjectChangeDocument = gql`
    query getProjectChange($projectId: ID!) {
  projectChange(projectId: $projectId) {
    updatedAt
    latestVersion {
      creativeBrief
      assetCategory
    }
    beforeVersion {
      creativeBrief
      assetCategory
    }
  }
}
    `;

/**
 * __useGetProjectChangeQuery__
 *
 * To run a query within a React component, call `useGetProjectChangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectChangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectChangeQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectChangeQuery(baseOptions: Apollo.QueryHookOptions<GetProjectChangeQuery, GetProjectChangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectChangeQuery, GetProjectChangeQueryVariables>(GetProjectChangeDocument, options);
      }
export function useGetProjectChangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectChangeQuery, GetProjectChangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectChangeQuery, GetProjectChangeQueryVariables>(GetProjectChangeDocument, options);
        }
export type GetProjectChangeQueryHookResult = ReturnType<typeof useGetProjectChangeQuery>;
export type GetProjectChangeLazyQueryHookResult = ReturnType<typeof useGetProjectChangeLazyQuery>;
export type GetProjectChangeQueryResult = Apollo.QueryResult<GetProjectChangeQuery, GetProjectChangeQueryVariables>;
export const GetProjectTypesByRegionDocument = gql`
    query getProjectTypesByRegion($language: ID!, $organizationId: ID) {
  projectTypes(language: $language, organizationId: $organizationId, first: 100) {
    edges {
      node {
        ...ProjectTypeForList
      }
    }
  }
}
    ${ProjectTypeForListFragmentDoc}`;

/**
 * __useGetProjectTypesByRegionQuery__
 *
 * To run a query within a React component, call `useGetProjectTypesByRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectTypesByRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectTypesByRegionQuery({
 *   variables: {
 *      language: // value for 'language'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetProjectTypesByRegionQuery(baseOptions: Apollo.QueryHookOptions<GetProjectTypesByRegionQuery, GetProjectTypesByRegionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectTypesByRegionQuery, GetProjectTypesByRegionQueryVariables>(GetProjectTypesByRegionDocument, options);
      }
export function useGetProjectTypesByRegionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectTypesByRegionQuery, GetProjectTypesByRegionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectTypesByRegionQuery, GetProjectTypesByRegionQueryVariables>(GetProjectTypesByRegionDocument, options);
        }
export type GetProjectTypesByRegionQueryHookResult = ReturnType<typeof useGetProjectTypesByRegionQuery>;
export type GetProjectTypesByRegionLazyQueryHookResult = ReturnType<typeof useGetProjectTypesByRegionLazyQuery>;
export type GetProjectTypesByRegionQueryResult = Apollo.QueryResult<GetProjectTypesByRegionQuery, GetProjectTypesByRegionQueryVariables>;
export const GetProjectType2Document = gql`
    query getProjectType2($key: String!, $language: ID!) {
  projectType(key: $key, language: $language) {
    ...ProjectTypeDetail
  }
}
    ${ProjectTypeDetailFragmentDoc}`;

/**
 * __useGetProjectType2Query__
 *
 * To run a query within a React component, call `useGetProjectType2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectType2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectType2Query({
 *   variables: {
 *      key: // value for 'key'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGetProjectType2Query(baseOptions: Apollo.QueryHookOptions<GetProjectType2Query, GetProjectType2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectType2Query, GetProjectType2QueryVariables>(GetProjectType2Document, options);
      }
export function useGetProjectType2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectType2Query, GetProjectType2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectType2Query, GetProjectType2QueryVariables>(GetProjectType2Document, options);
        }
export type GetProjectType2QueryHookResult = ReturnType<typeof useGetProjectType2Query>;
export type GetProjectType2LazyQueryHookResult = ReturnType<typeof useGetProjectType2LazyQuery>;
export type GetProjectType2QueryResult = Apollo.QueryResult<GetProjectType2Query, GetProjectType2QueryVariables>;
export const GetByIdForEditDocument = gql`
    query getByIdForEdit($id: ID!, $language: ID) {
  project(id: $id, language: $language) {
    ...ProjectDetailsForEdit
  }
}
    ${ProjectDetailsForEditFragmentDoc}`;

/**
 * __useGetByIdForEditQuery__
 *
 * To run a query within a React component, call `useGetByIdForEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetByIdForEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetByIdForEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGetByIdForEditQuery(baseOptions: Apollo.QueryHookOptions<GetByIdForEditQuery, GetByIdForEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetByIdForEditQuery, GetByIdForEditQueryVariables>(GetByIdForEditDocument, options);
      }
export function useGetByIdForEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetByIdForEditQuery, GetByIdForEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetByIdForEditQuery, GetByIdForEditQueryVariables>(GetByIdForEditDocument, options);
        }
export type GetByIdForEditQueryHookResult = ReturnType<typeof useGetByIdForEditQuery>;
export type GetByIdForEditLazyQueryHookResult = ReturnType<typeof useGetByIdForEditLazyQuery>;
export type GetByIdForEditQueryResult = Apollo.QueryResult<GetByIdForEditQuery, GetByIdForEditQueryVariables>;
export const GetProjectByIdForShowPageDocument = gql`
    query getProjectByIdForShowPage($id: ID!, $language: ID) {
  project(id: $id, language: $language) {
    ...ProjectDetailsForShow
  }
}
    ${ProjectDetailsForShowFragmentDoc}`;

/**
 * __useGetProjectByIdForShowPageQuery__
 *
 * To run a query within a React component, call `useGetProjectByIdForShowPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectByIdForShowPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectByIdForShowPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGetProjectByIdForShowPageQuery(baseOptions: Apollo.QueryHookOptions<GetProjectByIdForShowPageQuery, GetProjectByIdForShowPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectByIdForShowPageQuery, GetProjectByIdForShowPageQueryVariables>(GetProjectByIdForShowPageDocument, options);
      }
export function useGetProjectByIdForShowPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectByIdForShowPageQuery, GetProjectByIdForShowPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectByIdForShowPageQuery, GetProjectByIdForShowPageQueryVariables>(GetProjectByIdForShowPageDocument, options);
        }
export type GetProjectByIdForShowPageQueryHookResult = ReturnType<typeof useGetProjectByIdForShowPageQuery>;
export type GetProjectByIdForShowPageLazyQueryHookResult = ReturnType<typeof useGetProjectByIdForShowPageLazyQuery>;
export type GetProjectByIdForShowPageQueryResult = Apollo.QueryResult<GetProjectByIdForShowPageQuery, GetProjectByIdForShowPageQueryVariables>;
export const GetProjectsByOrganizationDocument = gql`
    query getProjectsByOrganization($organizationId: ID!, $order: ProjectOrder, $filter: ProjectFilter, $after: String, $first: Int) {
  projectsByOrganization(
    organizationId: $organizationId
    order: $order
    filter: $filter
    after: $after
    first: $first
  ) {
    nodes {
      ...ProjectForAllOfOrganization
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${ProjectForAllOfOrganizationFragmentDoc}`;

/**
 * __useGetProjectsByOrganizationQuery__
 *
 * To run a query within a React component, call `useGetProjectsByOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsByOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsByOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      order: // value for 'order'
 *      filter: // value for 'filter'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetProjectsByOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetProjectsByOrganizationQuery, GetProjectsByOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectsByOrganizationQuery, GetProjectsByOrganizationQueryVariables>(GetProjectsByOrganizationDocument, options);
      }
export function useGetProjectsByOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectsByOrganizationQuery, GetProjectsByOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectsByOrganizationQuery, GetProjectsByOrganizationQueryVariables>(GetProjectsByOrganizationDocument, options);
        }
export type GetProjectsByOrganizationQueryHookResult = ReturnType<typeof useGetProjectsByOrganizationQuery>;
export type GetProjectsByOrganizationLazyQueryHookResult = ReturnType<typeof useGetProjectsByOrganizationLazyQuery>;
export type GetProjectsByOrganizationQueryResult = Apollo.QueryResult<GetProjectsByOrganizationQuery, GetProjectsByOrganizationQueryVariables>;
export const CreateProjectAsDraft2Document = gql`
    mutation createProjectAsDraft2($title: String!, $matchingFormat: MatchingFormat!, $organizationId: ID!, $projectTypeId: ID!, $creationSet: CreationSetInput, $creativeBriefDefinitionId: ID!, $creativeBriefValues: DynamicSchemaValuesInput, $assetCategoryDefinitionId: ID!, $assetCategoryValues: DynamicSchemaValuesInput, $parentProjectId: ID, $designInspirationCaseId: ID) {
  createProjectAsDraft(
    title: $title
    matchingFormat: $matchingFormat
    organization: $organizationId
    projectType: $projectTypeId
    creationSet: $creationSet
    creativeBriefDefinition: $creativeBriefDefinitionId
    creativeBriefValues: $creativeBriefValues
    assetCategoryDefinition: $assetCategoryDefinitionId
    assetCategoryValues: $assetCategoryValues
    parent: $parentProjectId
    designInspirationCaseId: $designInspirationCaseId
  ) {
    id
  }
}
    `;
export type CreateProjectAsDraft2MutationFn = Apollo.MutationFunction<CreateProjectAsDraft2Mutation, CreateProjectAsDraft2MutationVariables>;

/**
 * __useCreateProjectAsDraft2Mutation__
 *
 * To run a mutation, you first call `useCreateProjectAsDraft2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectAsDraft2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectAsDraft2Mutation, { data, loading, error }] = useCreateProjectAsDraft2Mutation({
 *   variables: {
 *      title: // value for 'title'
 *      matchingFormat: // value for 'matchingFormat'
 *      organizationId: // value for 'organizationId'
 *      projectTypeId: // value for 'projectTypeId'
 *      creationSet: // value for 'creationSet'
 *      creativeBriefDefinitionId: // value for 'creativeBriefDefinitionId'
 *      creativeBriefValues: // value for 'creativeBriefValues'
 *      assetCategoryDefinitionId: // value for 'assetCategoryDefinitionId'
 *      assetCategoryValues: // value for 'assetCategoryValues'
 *      parentProjectId: // value for 'parentProjectId'
 *      designInspirationCaseId: // value for 'designInspirationCaseId'
 *   },
 * });
 */
export function useCreateProjectAsDraft2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectAsDraft2Mutation, CreateProjectAsDraft2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectAsDraft2Mutation, CreateProjectAsDraft2MutationVariables>(CreateProjectAsDraft2Document, options);
      }
export type CreateProjectAsDraft2MutationHookResult = ReturnType<typeof useCreateProjectAsDraft2Mutation>;
export type CreateProjectAsDraft2MutationResult = Apollo.MutationResult<CreateProjectAsDraft2Mutation>;
export type CreateProjectAsDraft2MutationOptions = Apollo.BaseMutationOptions<CreateProjectAsDraft2Mutation, CreateProjectAsDraft2MutationVariables>;
export const DeleteDraftProjectDocument = gql`
    mutation deleteDraftProject($id: ID!) {
  deleteProject(id: $id) {
    success
  }
}
    `;
export type DeleteDraftProjectMutationFn = Apollo.MutationFunction<DeleteDraftProjectMutation, DeleteDraftProjectMutationVariables>;

/**
 * __useDeleteDraftProjectMutation__
 *
 * To run a mutation, you first call `useDeleteDraftProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDraftProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDraftProjectMutation, { data, loading, error }] = useDeleteDraftProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDraftProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDraftProjectMutation, DeleteDraftProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDraftProjectMutation, DeleteDraftProjectMutationVariables>(DeleteDraftProjectDocument, options);
      }
export type DeleteDraftProjectMutationHookResult = ReturnType<typeof useDeleteDraftProjectMutation>;
export type DeleteDraftProjectMutationResult = Apollo.MutationResult<DeleteDraftProjectMutation>;
export type DeleteDraftProjectMutationOptions = Apollo.BaseMutationOptions<DeleteDraftProjectMutation, DeleteDraftProjectMutationVariables>;
export const CreateProjectIssueDocument = gql`
    mutation createProjectIssue($projectId: ID!, $name: String!, $body: String!) {
  createProjectIssue(projectId: $projectId, name: $name, body: $body) {
    ...IssueForProject
  }
}
    ${IssueForProjectFragmentDoc}`;
export type CreateProjectIssueMutationFn = Apollo.MutationFunction<CreateProjectIssueMutation, CreateProjectIssueMutationVariables>;

/**
 * __useCreateProjectIssueMutation__
 *
 * To run a mutation, you first call `useCreateProjectIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectIssueMutation, { data, loading, error }] = useCreateProjectIssueMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      name: // value for 'name'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCreateProjectIssueMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectIssueMutation, CreateProjectIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectIssueMutation, CreateProjectIssueMutationVariables>(CreateProjectIssueDocument, options);
      }
export type CreateProjectIssueMutationHookResult = ReturnType<typeof useCreateProjectIssueMutation>;
export type CreateProjectIssueMutationResult = Apollo.MutationResult<CreateProjectIssueMutation>;
export type CreateProjectIssueMutationOptions = Apollo.BaseMutationOptions<CreateProjectIssueMutation, CreateProjectIssueMutationVariables>;
export const CreateProjectIssueCommentDocument = gql`
    mutation createProjectIssueComment($issueId: ID!, $body: String!) {
  createProjectIssueComment(issueId: $issueId, body: $body) {
    ...IssueCommentForProject
  }
}
    ${IssueCommentForProjectFragmentDoc}`;
export type CreateProjectIssueCommentMutationFn = Apollo.MutationFunction<CreateProjectIssueCommentMutation, CreateProjectIssueCommentMutationVariables>;

/**
 * __useCreateProjectIssueCommentMutation__
 *
 * To run a mutation, you first call `useCreateProjectIssueCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectIssueCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectIssueCommentMutation, { data, loading, error }] = useCreateProjectIssueCommentMutation({
 *   variables: {
 *      issueId: // value for 'issueId'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCreateProjectIssueCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectIssueCommentMutation, CreateProjectIssueCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectIssueCommentMutation, CreateProjectIssueCommentMutationVariables>(CreateProjectIssueCommentDocument, options);
      }
export type CreateProjectIssueCommentMutationHookResult = ReturnType<typeof useCreateProjectIssueCommentMutation>;
export type CreateProjectIssueCommentMutationResult = Apollo.MutationResult<CreateProjectIssueCommentMutation>;
export type CreateProjectIssueCommentMutationOptions = Apollo.BaseMutationOptions<CreateProjectIssueCommentMutation, CreateProjectIssueCommentMutationVariables>;
export const UpdateProjectIssueCommentDocument = gql`
    mutation updateProjectIssueComment($commentId: ID!, $body: String!) {
  updateProjectIssueComment(commentId: $commentId, body: $body) {
    ...IssueCommentForProject
  }
}
    ${IssueCommentForProjectFragmentDoc}`;
export type UpdateProjectIssueCommentMutationFn = Apollo.MutationFunction<UpdateProjectIssueCommentMutation, UpdateProjectIssueCommentMutationVariables>;

/**
 * __useUpdateProjectIssueCommentMutation__
 *
 * To run a mutation, you first call `useUpdateProjectIssueCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectIssueCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectIssueCommentMutation, { data, loading, error }] = useUpdateProjectIssueCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateProjectIssueCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectIssueCommentMutation, UpdateProjectIssueCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectIssueCommentMutation, UpdateProjectIssueCommentMutationVariables>(UpdateProjectIssueCommentDocument, options);
      }
export type UpdateProjectIssueCommentMutationHookResult = ReturnType<typeof useUpdateProjectIssueCommentMutation>;
export type UpdateProjectIssueCommentMutationResult = Apollo.MutationResult<UpdateProjectIssueCommentMutation>;
export type UpdateProjectIssueCommentMutationOptions = Apollo.BaseMutationOptions<UpdateProjectIssueCommentMutation, UpdateProjectIssueCommentMutationVariables>;
export const DeleteProjectIssueCommentDocument = gql`
    mutation deleteProjectIssueComment($commentId: ID!) {
  deleteProjectIssueComment(commentId: $commentId) {
    ...IssueForProject
  }
}
    ${IssueForProjectFragmentDoc}`;
export type DeleteProjectIssueCommentMutationFn = Apollo.MutationFunction<DeleteProjectIssueCommentMutation, DeleteProjectIssueCommentMutationVariables>;

/**
 * __useDeleteProjectIssueCommentMutation__
 *
 * To run a mutation, you first call `useDeleteProjectIssueCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectIssueCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectIssueCommentMutation, { data, loading, error }] = useDeleteProjectIssueCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useDeleteProjectIssueCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectIssueCommentMutation, DeleteProjectIssueCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectIssueCommentMutation, DeleteProjectIssueCommentMutationVariables>(DeleteProjectIssueCommentDocument, options);
      }
export type DeleteProjectIssueCommentMutationHookResult = ReturnType<typeof useDeleteProjectIssueCommentMutation>;
export type DeleteProjectIssueCommentMutationResult = Apollo.MutationResult<DeleteProjectIssueCommentMutation>;
export type DeleteProjectIssueCommentMutationOptions = Apollo.BaseMutationOptions<DeleteProjectIssueCommentMutation, DeleteProjectIssueCommentMutationVariables>;
export const DirectorUserDocument = gql`
    query directorUser {
  me {
    ...SingleDirectorUser
  }
}
    ${SingleDirectorUserFragmentDoc}`;

/**
 * __useDirectorUserQuery__
 *
 * To run a query within a React component, call `useDirectorUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useDirectorUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDirectorUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useDirectorUserQuery(baseOptions?: Apollo.QueryHookOptions<DirectorUserQuery, DirectorUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DirectorUserQuery, DirectorUserQueryVariables>(DirectorUserDocument, options);
      }
export function useDirectorUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DirectorUserQuery, DirectorUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DirectorUserQuery, DirectorUserQueryVariables>(DirectorUserDocument, options);
        }
export type DirectorUserQueryHookResult = ReturnType<typeof useDirectorUserQuery>;
export type DirectorUserLazyQueryHookResult = ReturnType<typeof useDirectorUserLazyQuery>;
export type DirectorUserQueryResult = Apollo.QueryResult<DirectorUserQuery, DirectorUserQueryVariables>;